var Yn = Object.defineProperty;
var Jn = (s, e, t) => e in s ? Yn(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t;
var le = (s, e, t) => (Jn(s, typeof e != "symbol" ? e + "" : e, t), t), Gt = (s, e, t) => {
  if (!e.has(s))
    throw TypeError("Cannot " + t);
};
var a = (s, e, t) => (Gt(s, e, "read from private field"), t ? t.call(s) : e.get(s)), P = (s, e, t) => {
  if (e.has(s))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(s) : e.set(s, t);
}, O = (s, e, t, n) => (Gt(s, e, "write to private field"), n ? n.call(s, t) : e.set(s, t), t), Lt = (s, e, t, n) => ({
  set _(i) {
    O(s, e, i, t);
  },
  get _() {
    return a(s, e, n);
  }
}), F = (s, e, t) => (Gt(s, e, "access private method"), t);
import { reactive as ke, watch as W, onMounted as ie, onBeforeUnmount as $t, provide as Re, computed as Te, ref as ne, defineComponent as ae, createVNode as u, cloneVNode as ei, nextTick as ut, inject as N, Fragment as Wt, toRef as Bt, mergeProps as ti, isVNode as ni } from "vue";
const d = "md-editor", ii = "md-editor-v3", si = "https://at.alicdn.com/t/c/font_2605852_u82y61ve02.js", Y = "https://cdnjs.cloudflare.com/ajax/libs", li = `${Y}/highlight.js/11.7.0/highlight.min.js`, fn = {
  main: `${Y}/prettier/2.8.0/standalone.js`,
  markdown: `${Y}/prettier/2.8.0/parser-markdown.js`
}, mn = {
  css: `${Y}/cropperjs/1.5.13/cropper.min.css`,
  js: `${Y}/cropperjs/1.5.13/cropper.min.js`
}, oi = `${Y}/screenfull.js/5.2.0/screenfull.min.js`, Dn = [
  "bold",
  "underline",
  "italic",
  "strikeThrough",
  "-",
  "title",
  "sub",
  "sup",
  "quote",
  "unorderedList",
  "orderedList",
  "task",
  "-",
  "codeRow",
  "code",
  "link",
  "image",
  "table",
  "mermaid",
  "katex",
  "-",
  "revoke",
  "next",
  "save",
  "=",
  "prettier",
  "pageFullscreen",
  "fullscreen",
  "preview",
  "htmlPreview",
  "catalog",
  "github"
], Hn = ["markdownTotal", "=", "scrollSwitch"], gn = {
  "zh-CN": {
    toolbarTips: {
      bold: "加粗",
      underline: "下划线",
      italic: "斜体",
      strikeThrough: "删除线",
      title: "标题",
      sub: "下标",
      sup: "上标",
      quote: "引用",
      unorderedList: "无序列表",
      orderedList: "有序列表",
      task: "任务列表",
      codeRow: "行内代码",
      code: "块级代码",
      link: "链接",
      image: "图片",
      table: "表格",
      mermaid: "mermaid图",
      katex: "katex公式",
      revoke: "后退",
      next: "前进",
      save: "保存",
      prettier: "美化",
      pageFullscreen: "浏览器全屏",
      fullscreen: "屏幕全屏",
      preview: "预览",
      htmlPreview: "html代码预览",
      catalog: "目录",
      github: "源码地址"
    },
    titleItem: {
      h1: "一级标题",
      h2: "二级标题",
      h3: "三级标题",
      h4: "四级标题",
      h5: "五级标题",
      h6: "六级标题"
    },
    imgTitleItem: {
      link: "添加链接",
      upload: "上传图片",
      clip2upload: "裁剪上传"
    },
    linkModalTips: {
      linkTitle: "添加链接",
      imageTitle: "添加图片",
      descLabel: "链接描述：",
      descLabelPlaceHolder: "请输入描述...",
      urlLabel: "链接地址：",
      urlLabelPlaceHolder: "请输入链接...",
      buttonOK: "确定"
    },
    clipModalTips: {
      title: "裁剪图片上传",
      buttonUpload: "上传"
    },
    copyCode: {
      text: "复制代码",
      successTips: "已复制！",
      failTips: "复制失败！"
    },
    mermaid: {
      flow: "流程图",
      sequence: "时序图",
      gantt: "甘特图",
      class: "类图",
      state: "状态图",
      pie: "饼图",
      relationship: "关系图",
      journey: "旅程图"
    },
    katex: {
      inline: "行内公式",
      block: "块级公式"
    },
    footer: {
      markdownTotal: "字数",
      scrollAuto: "同步滚动"
    }
  },
  "en-US": {
    toolbarTips: {
      bold: "bold",
      underline: "underline",
      italic: "italic",
      strikeThrough: "strikeThrough",
      title: "title",
      sub: "subscript",
      sup: "superscript",
      quote: "quote",
      unorderedList: "unordered list",
      orderedList: "ordered list",
      task: "task list",
      codeRow: "inline code",
      code: "block-level code",
      link: "link",
      image: "image",
      table: "table",
      mermaid: "mermaid",
      katex: "formula",
      revoke: "revoke",
      next: "undo revoke",
      save: "save",
      prettier: "prettier",
      pageFullscreen: "fullscreen in page",
      fullscreen: "fullscreen",
      preview: "preview",
      htmlPreview: "html preview",
      catalog: "catalog",
      github: "source code"
    },
    titleItem: {
      h1: "Lv1 Heading",
      h2: "Lv2 Heading",
      h3: "Lv3 Heading",
      h4: "Lv4 Heading",
      h5: "Lv5 Heading",
      h6: "Lv6 Heading"
    },
    imgTitleItem: {
      link: "Add Img Link",
      upload: "Upload Img",
      clip2upload: "Clip Upload"
    },
    linkModalTips: {
      linkTitle: "Add Link",
      imageTitle: "Add Image",
      descLabel: "Desc:",
      descLabelPlaceHolder: "Enter a description...",
      urlLabel: "Link:",
      urlLabelPlaceHolder: "Enter a link...",
      buttonOK: "OK"
    },
    clipModalTips: {
      title: "Crop Image",
      buttonUpload: "Upload"
    },
    copyCode: {
      text: "Copy",
      successTips: "Copied!",
      failTips: "Copy failed!"
    },
    mermaid: {
      flow: "flow",
      sequence: "sequence",
      gantt: "gantt",
      class: "class",
      state: "state",
      pie: "pie",
      relationship: "relationship",
      journey: "journey"
    },
    katex: {
      inline: "inline",
      block: "block"
    },
    footer: {
      markdownTotal: "Word Count",
      scrollAuto: "Scroll Auto"
    }
  }
}, ri = `${Y}/mermaid/9.4.0/mermaid.min.js`, pn = {
  js: `${Y}/KaTeX/0.16.3/katex.min.js`,
  css: `${Y}/KaTeX/0.16.3/katex.min.css`
}, vn = {
  a11y: {
    light: `${Y}/highlight.js/11.7.0/styles/a11y-light.min.css`,
    dark: `${Y}/highlight.js/11.7.0/styles/a11y-dark.min.css`
  },
  atom: {
    light: `${Y}/highlight.js/11.7.0/styles/atom-one-light.min.css`,
    dark: `${Y}/highlight.js/11.7.0/styles/atom-one-dark.min.css`
  },
  github: {
    light: `${Y}/highlight.js/11.7.0/styles/github.min.css`,
    dark: `${Y}/highlight.js/11.7.0/styles/github-dark.min.css`
  },
  gradient: {
    light: `${Y}/highlight.js/11.7.0/styles/gradient-light.min.css`,
    dark: `${Y}/highlight.js/11.7.0/styles/gradient-dark.min.css`
  },
  kimbie: {
    light: `${Y}/highlight.js/11.7.0/styles/kimbie-light.min.css`,
    dark: `${Y}/highlight.js/11.7.0/styles/kimbie-dark.min.css`
  },
  paraiso: {
    light: `${Y}/highlight.js/11.7.0/styles/paraiso-light.min.css`,
    dark: `${Y}/highlight.js/11.7.0/styles/paraiso-dark.min.css`
  },
  qtcreator: {
    light: `${Y}/highlight.js/11.7.0/styles/qtcreator-light.min.css`,
    dark: `${Y}/highlight.js/11.7.0/styles/qtcreator-dark.min.css`
  },
  stackoverflow: {
    light: `${Y}/highlight.js/11.7.0/styles/stackoverflow-light.min.css`,
    dark: `${Y}/highlight.js/11.7.0/styles/stackoverflow-dark.min.css`
  }
}, te = {
  markedRenderer: (s) => s,
  markedExtensions: [],
  markedOptions: {},
  editorExtensions: {},
  editorConfig: {}
}, ai = (s) => {
  if (s)
    for (const e in s) {
      const t = s[e];
      t && (te[e] = t);
    }
};
class ci {
  constructor() {
    // 事件池
    le(this, "pools", {});
  }
  // 移除事件监听
  remove(e, t, n) {
    const l = this.pools[e] && this.pools[e][t];
    l && (this.pools[e][t] = l.filter((r) => r !== n));
  }
  // 清空全部事件，由于单一实例，多次注册会被共享内容
  clear(e) {
    this.pools[e] = {};
  }
  // 注册事件监听
  on(e, t) {
    return this.pools[e] || (this.pools[e] = {}), this.pools[e][t.name] || (this.pools[e][t.name] = []), this.pools[e][t.name].push(t.callback), this.pools[e][t.name].includes(t.callback);
  }
  // 触发事件
  emit(e, t, ...n) {
    this.pools[e] || (this.pools[e] = {});
    const l = this.pools[e][t];
    l && l.forEach((r) => {
      try {
        r(...n);
      } catch (o) {
        console.error(`${t} monitor event exception！`, o);
      }
    });
  }
}
const x = new ci(), Oe = (s, e = 0, t = e) => new Promise((n, i) => {
  s.setSelectionRange ? setTimeout(() => {
    s.setSelectionRange(e, t), s.focus(), n(!0);
  }, 0) : (console.error("Can not reset position!"), i());
}), Xt = (s, e, t) => {
  const { deviationStart: n = 0, deviationEnd: i = 0, direct: l = !1, select: r = !1 } = t;
  let o = "";
  if (s.selectionStart || s.selectionStart === 0) {
    const c = s.selectionStart, f = s.selectionEnd || 0, {
      prefixVal: h = s.value.substring(0, c),
      subfixVal: m = s.value.substring(f, s.value.length)
    } = t;
    o = h + e + m, Oe(
      s,
      // 选中值开始位置为设定开始，否者为结束位置
      r ? c + n : c + e.length + i,
      c + e.length + i
    );
  } else
    o += e;
  return l && (s.value = o), o;
}, ui = (s, e = {
  newWindow: !0,
  nofollow: !0
}) => {
  s || console.error("error link!");
  const t = document.createElement("a");
  t.href = s, t.style.display = "none", e.newWindow && (t.target = "_blank"), e.nofollow && (t.rel = "noopener noreferrer"), document.body.appendChild(t), t.click(), document.body.removeChild(t);
}, bn = (s, e) => {
  const t = Kt(() => {
    s.removeEventListener("scroll", n), s.addEventListener("scroll", n), e.removeEventListener("scroll", n), e.addEventListener("scroll", n);
  }, 50), n = (i) => {
    const l = s.clientHeight, r = e.clientHeight, o = s.scrollHeight, c = e.scrollHeight, f = (o - l) / (c - r);
    i.target === s ? (e.removeEventListener("scroll", n), e.scrollTo({
      top: s.scrollTop / f
      // behavior: 'smooth'
    }), t()) : (s.removeEventListener("scroll", n), s.scrollTo({
      top: e.scrollTop * f
      // behavior: 'smooth'
    }), t());
  };
  return [
    () => {
      t().finally(() => {
        s.dispatchEvent(new Event("scroll"));
      });
    },
    () => {
      s.removeEventListener("scroll", n), e.removeEventListener("scroll", n);
    }
  ];
}, di = (s, e = "image.png") => {
  const t = s.split(","), n = t[0].match(/:(.*?);/);
  if (n) {
    const i = n[1], l = atob(t[1]);
    let r = l.length;
    const o = new Uint8Array(r);
    for (; r--; )
      o[r] = l.charCodeAt(r);
    return new File([o], e, { type: i });
  }
  return null;
}, kn = (s) => {
  if (!s)
    return s;
  const e = s.split(`
`), t = ['<span rn-wrapper aria-hidden="true">'];
  return e.forEach(() => {
    t.push("<span></span>");
  }), t.push("</span>"), `<span class="code-block">${s}</span>${t.join("")}`;
}, Kt = (s, e = 200) => {
  let t = 0;
  return (...n) => new Promise((i) => {
    t && (clearTimeout(t), i("cancel")), t = window.setTimeout(() => {
      s.apply(void 0, n), t = 0, i("done");
    }, e);
  });
}, hi = (s, e = 200) => {
  let t = 0, n = null;
  return (...i) => {
    const l = (r) => {
      t === 0 && (t = r), r - t >= e ? (s.apply(void 0, n), n = null, t = 0) : window.requestAnimationFrame(l);
    };
    n === null && window.requestAnimationFrame(l), n = i;
  };
}, yn = (s, e = "$") => {
  const t = s.split(e);
  let n = e, i = "";
  for (let l = 1; l < t.length; l++)
    if (/\\$/.test(t[l]))
      n += t[l] + "$", i += t[l] + "$";
    else {
      n += t[l] + e, i += t[l];
      break;
    }
  return [n, i];
}, fi = (s) => {
  var t;
  return navigator.userAgent.indexOf("Firefox") > -1 ? s.value.substring(s.selectionStart, s.selectionEnd) : ((t = window.getSelection()) == null ? void 0 : t.toString()) || "";
}, mi = (s, e) => {
  const t = s == null ? void 0 : s.getBoundingClientRect();
  if (e === document.documentElement)
    return t.top - e.clientTop;
  const n = e == null ? void 0 : e.getBoundingClientRect();
  return t.top - n.top;
}, gi = (s, e) => {
  const t = { ...s };
  return e.forEach((n) => {
    Reflect.deleteProperty(t, n);
  }), t;
}, pi = () => `${Date.now().toString(36)}${Math.random().toString(36).substring(2)}`, wn = (s, e) => {
  const t = (n) => {
    const i = s.parentElement || document.body, l = i.offsetWidth, r = i.offsetHeight, { clientWidth: o } = document.documentElement, { clientHeight: c } = document.documentElement, f = n.offsetX, h = n.offsetY, m = (g) => {
      let $ = g.x + document.body.scrollLeft - document.body.clientLeft - f, b = g.y + document.body.scrollTop - document.body.clientTop - h;
      $ = $ < 1 ? 1 : $ < o - l - 1 ? $ : o - l - 1, b = b < 1 ? 1 : b < c - r - 1 ? b : c - r - 1, e ? e($, b) : (i.style.left = `${$}px`, i.style.top = `${b}px`);
    };
    document.addEventListener("mousemove", m);
    const v = () => {
      document.removeEventListener("mousemove", m), document.removeEventListener("mouseup", v);
    };
    document.addEventListener("mouseup", v);
  };
  return s.addEventListener("mousedown", t), () => {
    s.removeEventListener("mousedown", t);
  };
}, Ce = (s, e = "") => {
  const t = document.getElementById(s.id), n = s.onload;
  s.onload = null;
  const i = function(l) {
    typeof n == "function" && n.bind(this)(l), s.removeEventListener("load", i);
  };
  t ? e !== "" && (t.addEventListener("load", i), Reflect.get(window, e) && t.dispatchEvent(new Event("load"))) : (s.addEventListener("load", i), document.head.appendChild(s));
}, vi = Kt((s, e, t) => {
  const n = document.getElementById(s);
  n && n.setAttribute(e, t);
}, 10), Nt = "onSave", on = "changeCatalogVisible", jn = "changeFullscreen", xn = "pageFullscreenChanged", $n = "fullscreenChanged", Qt = "previewChanged", Sn = "htmlPreviewChanged", Cn = "catalogVisibleChanged", Pn = "textareaFocus", bi = (s, e) => {
  const { editorId: t, noPrettier: n, previewOnly: i } = s, l = ke({
    // 是否已编译成html
    buildFinished: !1,
    // 存储当前最新的html
    html: ""
  }), r = (o) => {
    if (o.target === document.querySelector(`#${s.editorId}-textarea`))
      if (x.emit(t, "selectTextChange"), o.ctrlKey || o.metaKey)
        switch (o.code) {
          case "KeyS": {
            o.shiftKey ? x.emit(t, "replace", "strikeThrough") : (x.emit(t, Nt, s.modelValue), o.preventDefault());
            break;
          }
          case "KeyB": {
            x.emit(t, "replace", "bold"), o.preventDefault();
            break;
          }
          case "KeyU": {
            o.shiftKey ? (x.emit(t, "replace", "unorderedList"), o.preventDefault()) : (x.emit(t, "replace", "underline"), o.preventDefault());
            break;
          }
          case "KeyI": {
            o.shiftKey ? (x.emit(t, "openModals", "image"), o.preventDefault()) : (x.emit(t, "replace", "italic"), o.preventDefault());
            break;
          }
          case "Digit1": {
            x.emit(t, "replace", "h1"), o.preventDefault();
            break;
          }
          case "Digit2": {
            x.emit(t, "replace", "h2"), o.preventDefault();
            break;
          }
          case "Digit3": {
            x.emit(t, "replace", "h3"), o.preventDefault();
            break;
          }
          case "Digit4": {
            x.emit(t, "replace", "h4"), o.preventDefault();
            break;
          }
          case "Digit5": {
            x.emit(t, "replace", "h5"), o.preventDefault();
            break;
          }
          case "Digit6": {
            x.emit(t, "replace", "h6"), o.preventDefault();
            break;
          }
          case "ArrowUp": {
            x.emit(t, "replace", "sup"), o.preventDefault();
            break;
          }
          case "ArrowDown": {
            x.emit(t, "replace", "sub"), o.preventDefault();
            break;
          }
          case "KeyQ": {
            if (o.key === "a") {
              o.target.select();
              return;
            }
            x.emit(t, "replace", "quote"), o.preventDefault();
            break;
          }
          case "KeyA":
            if (o.key === "q") {
              x.emit(t, "replace", "quote"), o.preventDefault();
              break;
            } else
              return;
          case "KeyO": {
            x.emit(t, "replace", "orderedList"), o.preventDefault();
            break;
          }
          case "KeyC": {
            if (o.shiftKey)
              x.emit(t, "replace", "code"), o.preventDefault();
            else if (o.altKey)
              x.emit(t, "replace", "codeRow"), o.preventDefault();
            else {
              o.preventDefault(), x.emit(t, "replace", "ctrlC");
              break;
            }
            break;
          }
          case "KeyL": {
            x.emit(t, "openModals", "link"), o.preventDefault();
            break;
          }
          case "KeyZ": {
            if (o.key === "w")
              return;
            o.shiftKey ? (x.emit(t, "ctrlShiftZ"), o.preventDefault()) : (x.emit(t, "ctrlZ"), o.preventDefault());
            break;
          }
          case "KeyW":
            if (o.key === "z") {
              o.shiftKey ? (x.emit(t, "ctrlShiftZ"), o.preventDefault()) : (x.emit(t, "ctrlZ"), o.preventDefault());
              break;
            } else
              return;
          case "KeyF": {
            o.shiftKey && (n || (x.emit(t, "replace", "prettier"), o.preventDefault()));
            break;
          }
          case "KeyT": {
            o.altKey && o.shiftKey && (x.emit(t, "replace", "table"), o.preventDefault());
            break;
          }
          case "KeyX": {
            x.emit(t, "replace", "ctrlX"), o.preventDefault();
            break;
          }
          case "KeyD": {
            o.preventDefault(), x.emit(t, "replace", "ctrlD");
            break;
          }
        }
      else
        o.code === "Tab" && (o.preventDefault(), o.shiftKey ? x.emit(t, "replace", "shiftTab") : x.emit(t, "replace", "tab"));
  };
  W(
    () => s.modelValue,
    () => {
      l.buildFinished = !1;
    }
  ), ie(() => {
    i || (window.addEventListener("keydown", r), x.on(t, {
      name: "buildFinished",
      callback(o) {
        l.buildFinished = !0, l.html = o;
      }
    }), x.on(t, {
      name: Nt,
      callback() {
        const o = new Promise((c) => {
          if (l.buildFinished)
            c(l.html);
          else {
            const f = (h) => {
              c(h), x.remove(t, "buildFinished", f);
            };
            x.on(t, {
              name: "buildFinished",
              callback: f
            });
          }
        });
        s.onSave ? s.onSave(s.modelValue, o) : e.emit("onSave", s.modelValue, o);
      }
    }));
  }), $t(() => {
    i || window.removeEventListener("keydown", r);
  });
}, ki = (s) => {
  var l;
  const { editorId: e, previewOnly: t } = s, n = (l = te == null ? void 0 : te.editorExtensions) == null ? void 0 : l.highlight;
  Re("editorId", e), Re("tabWidth", s.tabWidth), Re(
    "theme",
    Te(() => s.theme)
  ), Re(
    "highlight",
    Te(() => {
      const r = {
        ...vn,
        ...n == null ? void 0 : n.css
      }, o = s.codeStyleReverse && s.codeStyleReverseList.includes(s.previewTheme) ? "dark" : s.theme;
      return {
        js: (n == null ? void 0 : n.js) || li,
        css: r[s.codeTheme] ? r[s.codeTheme][o] : vn.atom[o]
      };
    })
  ), Re("historyLength", s.historyLength), Re("previewOnly", t), Re("showCodeRowNumber", s.showCodeRowNumber);
  const i = Te(() => {
    var o;
    const r = {
      ...gn,
      ...(o = te == null ? void 0 : te.editorConfig) == null ? void 0 : o.languageUserDefined
    };
    return r[s.language] ? r[s.language] : gn["zh-CN"];
  });
  Re("usedLanguageText", i), Re(
    "previewTheme",
    Te(() => s.previewTheme)
  );
}, yi = (s) => {
  var f, h, m, v, g, $;
  const { noPrettier: e, previewOnly: t, noIconfont: n, noUploadImg: i } = s, { editorExtensions: l } = te, r = e || !!((h = (f = te.editorExtensions) == null ? void 0 : f.prettier) != null && h.prettierInstance), o = e || !!((v = (m = te.editorExtensions) == null ? void 0 : m.prettier) != null && v.parserMarkdownInstance), c = i || !!(($ = (g = te.editorExtensions) == null ? void 0 : g.cropper) != null && $.instance);
  ie(() => {
    var T, z, M, A;
    const b = document.createElement("script");
    b.src = (l == null ? void 0 : l.iconfont) || si, b.id = `${d}-icon`;
    const y = document.createElement("script"), p = document.createElement("script");
    y.src = ((T = l == null ? void 0 : l.prettier) == null ? void 0 : T.standaloneJs) || fn.main, y.id = `${d}-prettier`, p.src = ((z = l == null ? void 0 : l.prettier) == null ? void 0 : z.parserMarkdownJs) || fn.markdown, p.id = `${d}-prettierMD`;
    const w = document.createElement("link");
    w.rel = "stylesheet", w.href = ((M = l == null ? void 0 : l.cropper) == null ? void 0 : M.css) || mn.css, w.id = `${d}-cropperCss`;
    const S = document.createElement("script");
    S.src = ((A = l == null ? void 0 : l.cropper) == null ? void 0 : A.js) || mn.js, S.id = `${d}-cropper`, n || Ce(b), t || (c || (Ce(w), Ce(S)), r || Ce(y), o || Ce(p));
  });
}, wi = (s, e) => {
  const { editorId: t, previewOnly: n } = s, i = ke({
    pageFullscreen: s.pageFullscreen,
    fullscreen: !1,
    preview: s.preview,
    htmlPreview: s.preview ? !1 : s.htmlPreview
  }), l = (c, f) => {
    i[c] = f === void 0 ? !i[c] : f, c === "preview" && i.preview ? i.htmlPreview = !1 : c === "htmlPreview" && i.htmlPreview && (i.preview = !1);
  };
  let r = "";
  const o = () => {
    i.pageFullscreen || i.fullscreen ? document.body.style.overflow = "hidden" : document.body.style.overflow = r;
  };
  return W(() => [i.pageFullscreen, i.fullscreen], o), ie(() => {
    n || x.on(t, {
      name: "uploadImage",
      callback(c, f) {
        const h = (m) => {
          x.emit(t, "replace", "image", {
            desc: "",
            urls: m
          }), f && f();
        };
        s.onUploadImg ? s.onUploadImg(c, h) : e.emit("onUploadImg", c, h);
      }
    }), r = document.body.style.overflow, o();
  }), [i, l];
}, xi = (s) => {
  const { editorId: e } = s, t = ne(!1);
  ie(() => {
    x.on(e, {
      name: on,
      callback: (i) => {
        i === void 0 ? t.value = !t.value : t.value = i;
      }
    });
  });
  const n = Te(() => !s.toolbarsExclude.includes("catalog") && s.toolbars.includes("catalog"));
  return [t, n];
}, $i = (s, e, t, n, i) => {
  const { editorId: l } = s;
  W(
    () => n.pageFullscreen,
    (o) => {
      x.emit(l, xn, o);
    }
  ), W(
    () => n.fullscreen,
    (o) => {
      x.emit(l, $n, o);
    }
  ), W(
    () => n.preview,
    (o) => {
      x.emit(l, Qt, o);
    }
  ), W(
    () => n.htmlPreview,
    (o) => {
      x.emit(l, Sn, o);
    }
  ), W(t, (o) => {
    x.emit(l, Cn, o);
  });
  const r = {
    on(o, c) {
      switch (o) {
        case "pageFullscreen": {
          x.on(l, {
            name: xn,
            callback(f) {
              c(f);
            }
          });
          break;
        }
        case "fullscreen": {
          x.on(l, {
            name: $n,
            callback(f) {
              c(f);
            }
          });
          break;
        }
        case "preview": {
          x.on(l, {
            name: Qt,
            callback(f) {
              c(f);
            }
          });
          break;
        }
        case "htmlPreview": {
          x.on(l, {
            name: Sn,
            callback(f) {
              c(f);
            }
          });
          break;
        }
        case "catalog": {
          x.on(l, {
            name: Cn,
            callback(f) {
              c(f);
            }
          });
          break;
        }
      }
    },
    togglePageFullscreen(o) {
      i("pageFullscreen", o);
    },
    toggleFullscreen(o) {
      x.emit(l, jn, o);
    },
    togglePreview(o) {
      i("preview", o);
    },
    toggleHtmlPreview(o) {
      i("htmlPreview", o);
    },
    toggleCatalog(o) {
      x.emit(l, on, o);
    },
    triggerSave() {
      x.emit(l, Nt);
    },
    insert(o) {
      x.emit(l, "replace", "universal", { generate: o });
    },
    focus() {
      x.emit(l, Pn);
    }
  };
  e.expose(r);
};
const Si = /* @__PURE__ */ ae({
  setup() {
    return () => u("div", {
      class: `${d}-divider`
    }, null);
  }
}), Ee = ({
  instance: s,
  ctx: e,
  props: t = {}
}, n = "default") => {
  const i = (s == null ? void 0 : s.$slots[n]) || (e == null ? void 0 : e.slots[n]);
  return (i ? i(s) : "") || t[n];
};
const Ci = () => ({
  trigger: {
    type: String,
    default: "hover"
  },
  overlay: {
    type: [String, Object],
    default: ""
  },
  visible: {
    type: Boolean,
    default: !1
  },
  onChange: {
    type: Function,
    default: () => {
    }
  },
  // 相对滚动的元素选择器
  relative: {
    type: String,
    default: "html"
  }
}), it = /* @__PURE__ */ ae({
  props: Ci(),
  setup(s, e) {
    const t = `${d}-dropdown-hidden`, n = ke({
      overlayClass: [t],
      overlayStyle: {},
      triggerHover: !1,
      overlayHover: !1
    }), i = ne(), l = ne(), r = () => {
      var S;
      s.trigger === "hover" && (n.triggerHover = !0);
      const m = i.value, v = l.value, g = m.getBoundingClientRect(), $ = m.offsetTop, b = m.offsetLeft, y = g.height, p = g.width, w = ((S = document.querySelector(s.relative)) == null ? void 0 : S.scrollLeft) || 0;
      n.overlayStyle = {
        ...n.overlayStyle,
        top: $ + y + "px",
        left: b - v.offsetWidth / 2 + p / 2 - w + "px"
      }, s.onChange(!0);
    }, o = () => {
      n.overlayHover = !0;
    };
    W(() => s.visible, (m) => {
      m ? n.overlayClass = n.overlayClass.filter((v) => v !== t) : n.overlayClass.push(t);
    });
    const c = (m) => {
      const v = i.value, g = l.value;
      !v.contains(m.target) && !g.contains(m.target) && s.onChange(!1);
    };
    let f = -1;
    const h = (m) => {
      i.value === m.target ? n.triggerHover = !1 : n.overlayHover = !1, clearTimeout(f), f = window.setTimeout(() => {
        !n.overlayHover && !n.triggerHover && s.onChange(!1);
      }, 10);
    };
    return ie(() => {
      s.trigger === "click" ? (i.value.addEventListener("click", r), document.addEventListener("click", c)) : (i.value.addEventListener("mouseenter", r), i.value.addEventListener("mouseleave", h), l.value.addEventListener("mouseenter", o), l.value.addEventListener("mouseleave", h));
    }), $t(() => {
      s.trigger === "click" ? (i.value.removeEventListener("click", r), document.removeEventListener("click", c)) : (i.value.removeEventListener("mouseenter", r), i.value.removeEventListener("mouseleave", h), l.value.removeEventListener("mouseenter", o), l.value.removeEventListener("mouseleave", h));
    }), () => {
      const m = Ee({
        ctx: e
      }), v = Ee({
        props: s,
        ctx: e
      }, "overlay"), g = ei(m instanceof Array ? m[0] : m, {
        ref: i
      }), $ = u("div", {
        class: [`${d}-dropdown`, n.overlayClass],
        style: n.overlayStyle,
        ref: l
      }, [u("div", {
        class: `${d}-dropdown-overlay`
      }, [v instanceof Array ? v[0] : v])]);
      return [g, $];
    };
  }
});
const Ti = () => ({
  title: {
    type: String,
    default: ""
  },
  visible: {
    type: Boolean,
    default: !1
  },
  width: {
    type: String,
    default: "auto"
  },
  height: {
    type: String,
    default: "auto"
  },
  onClose: {
    type: Function,
    default: () => {
    }
  },
  showAdjust: {
    type: Boolean,
    default: !1
  },
  isFullscreen: {
    type: Boolean,
    default: !1
  },
  onAdjust: {
    type: Function,
    default: () => {
    }
  },
  class: {
    type: String
  }
}), rn = /* @__PURE__ */ ae({
  props: Ti(),
  setup(s, e) {
    const t = ne(s.visible), n = ne([`${d}-modal`]), i = ne(), l = ne();
    let r = () => {
    };
    const o = ke({
      initPos: {
        left: "0px",
        top: "0px"
      },
      historyPos: {
        left: "0px",
        top: "0px"
      }
    }), c = Te(() => s.isFullscreen ? {
      width: "100%",
      height: "100%"
    } : {
      width: s.width,
      height: s.height
    });
    return ie(() => {
      r = wn(l.value, (f, h) => {
        o.initPos.left = f + "px", o.initPos.top = h + "px";
      });
    }), $t(() => {
      r();
    }), W(() => s.isFullscreen, (f) => {
      f ? r() : r = wn(l.value, (h, m) => {
        o.initPos.left = h + "px", o.initPos.top = m + "px";
      });
    }), W(() => s.visible, (f) => {
      f ? (n.value.push("zoom-in"), t.value = f, ut(() => {
        const h = i.value.offsetWidth / 2, m = i.value.offsetHeight / 2, v = document.documentElement.clientWidth / 2, g = document.documentElement.clientHeight / 2;
        o.initPos.left = v - h + "px", o.initPos.top = g - m + "px";
      }), setTimeout(() => {
        n.value = n.value.filter((h) => h !== "zoom-in");
      }, 140)) : (n.value.push("zoom-out"), setTimeout(() => {
        n.value = n.value.filter((h) => h !== "zoom-out"), t.value = f;
      }, 130));
    }), () => {
      const f = Ee({
        ctx: e
      }), h = Ee({
        props: s,
        ctx: e
      }, "title");
      return u("div", {
        class: [s.class],
        style: {
          display: t.value ? "block" : "none"
        }
      }, [u("div", {
        class: `${d}-modal-mask`,
        onClick: s.onClose
      }, null), u("div", {
        class: n.value,
        style: {
          ...o.initPos,
          ...c.value
        },
        ref: i
      }, [u("div", {
        class: `${d}-modal-header`,
        ref: l
      }, [h || ""]), u("div", {
        class: `${d}-modal-body`
      }, [f]), u("div", {
        class: `${d}-modal-func`
      }, [s.showAdjust && u("div", {
        class: `${d}-modal-adjust`,
        onClick: (m) => {
          m.stopPropagation(), s.isFullscreen ? o.initPos = o.historyPos : (o.historyPos = o.initPos, o.initPos = {
            left: "0",
            top: "0"
          }), s.onAdjust(!s.isFullscreen);
        }
      }, [u("svg", {
        class: `${d}-icon`,
        "aria-hidden": "true"
      }, [u("use", {
        "xlink:href": `#md-editor-icon-${s.isFullscreen ? "suoxiao" : "fangda"}`
      }, null)])]), u("div", {
        class: `${d}-modal-close`,
        onClick: (m) => {
          m.stopPropagation(), s.onClose && s.onClose();
        }
      }, [u("svg", {
        class: `${d}-icon`,
        "aria-hidden": "true"
      }, [u("use", {
        "xlink:href": "#md-editor-icon-close"
      }, null)])])])])]);
    };
  }
}), Ei = () => ({
  type: {
    type: String,
    default: "link"
  },
  visible: {
    type: Boolean,
    default: !1
  },
  onCancel: {
    type: Function,
    default: () => {
    }
  },
  onOk: {
    type: Function,
    default: () => {
    }
  }
}), zi = /* @__PURE__ */ ae({
  props: Ei(),
  setup(s) {
    const e = N("usedLanguageText"), t = N("editorId"), n = Te(() => {
      var l, r;
      switch (s.type) {
        case "link":
          return (l = e.value.linkModalTips) == null ? void 0 : l.linkTitle;
        case "image":
          return (r = e.value.linkModalTips) == null ? void 0 : r.imageTitle;
        default:
          return "";
      }
    }), i = ke({
      desc: "",
      url: ""
    });
    return W(() => s.visible, (l) => {
      l || setTimeout(() => {
        i.desc = "", i.url = "";
      }, 200);
    }), () => u(rn, {
      title: n.value,
      visible: s.visible,
      onClose: s.onCancel
    }, {
      default: () => {
        var l, r, o, c, f;
        return [u("div", {
          class: `${d}-form-item`
        }, [u("label", {
          class: `${d}-label`,
          for: `link-desc-${t}`
        }, [(l = e.value.linkModalTips) == null ? void 0 : l.descLabel]), u("input", {
          placeholder: (r = e.value.linkModalTips) == null ? void 0 : r.descLabelPlaceHolder,
          class: `${d}-input`,
          id: `link-desc-${t}`,
          type: "text",
          value: i.desc,
          onChange: (h) => {
            i.desc = h.target.value;
          },
          autocomplete: "off"
        }, null)]), u("div", {
          class: `${d}-form-item`
        }, [u("label", {
          class: `${d}-label`,
          for: `link-url-${t}`
        }, [(o = e.value.linkModalTips) == null ? void 0 : o.urlLabel]), u("input", {
          placeholder: (c = e.value.linkModalTips) == null ? void 0 : c.urlLabelPlaceHolder,
          class: `${d}-input`,
          id: `link-url-${t}`,
          type: "text",
          value: i.url,
          onChange: (h) => {
            i.url = h.target.value;
          },
          autocomplete: "off"
        }, null)]), u("div", {
          class: `${d}-form-item`
        }, [u("button", {
          class: [`${d}-btn`, `${d}-btn-row`],
          type: "button",
          onClick: () => {
            s.onOk(i), i.desc = "", i.url = "";
          }
        }, [(f = e.value.linkModalTips) == null ? void 0 : f.buttonOK])])];
      }
    });
  }
});
const _i = () => ({
  visible: {
    type: Boolean,
    default: !1
  },
  onCancel: {
    type: Function,
    default: () => {
    }
  },
  onOk: {
    type: Function,
    default: () => {
    }
  }
}), Ai = /* @__PURE__ */ ae({
  props: _i(),
  setup(s) {
    var h, m;
    const e = N("usedLanguageText"), t = N("editorId");
    let n = (m = (h = te == null ? void 0 : te.editorExtensions) == null ? void 0 : h.cropper) == null ? void 0 : m.instance;
    const i = ne(), l = ne(), r = ne(), o = ke({
      cropperInited: !1,
      imgSelected: !1,
      imgSrc: "",
      // 是否全屏
      isFullscreen: !1
    });
    let c = null;
    W(() => s.visible, () => {
      s.visible && !o.cropperInited && (n = n || window.Cropper, i.value.onchange = () => {
        if (!n) {
          x.emit(t, "errorCatcher", {
            name: "Cropper",
            message: "Cropper is undefined"
          });
          return;
        }
        const v = i.value.files || [];
        if (o.imgSelected = !0, (v == null ? void 0 : v.length) > 0) {
          const g = new FileReader();
          g.onload = ($) => {
            o.imgSrc = $.target.result, ut(() => {
              c = new n(l.value, {
                viewMode: 2,
                preview: `.${d}-clip-preview-target`
                // aspectRatio: 16 / 9,
              });
            });
          }, g.readAsDataURL(v[0]);
        }
      });
    }), W(() => [o.imgSelected], () => {
      r.value.style = "";
    }), W(() => o.isFullscreen, () => {
      ut(() => {
        c == null || c.destroy(), r.value.style = "", l.value && (c = new n(l.value, {
          viewMode: 2,
          preview: `.${d}-clip-preview-target`
          // aspectRatio: 16 / 9,
        }));
      });
    });
    const f = () => {
      c.clear(), c.destroy(), c = null, i.value.value = "", o.imgSelected = !1;
    };
    return () => {
      var v;
      return u(rn, {
        class: `${d}-modal-clip`,
        title: (v = e.value.clipModalTips) == null ? void 0 : v.title,
        visible: s.visible,
        onClose: s.onCancel,
        showAdjust: !0,
        isFullscreen: o.isFullscreen,
        onAdjust: (g) => {
          o.isFullscreen = g;
        },
        width: "668px",
        height: "421px"
      }, {
        default: () => {
          var g, $;
          return [u("div", {
            class: `${d}-form-item ${d}-clip`
          }, [u("div", {
            class: `${d}-clip-main`
          }, [o.imgSelected ? u("div", {
            class: `${d}-clip-cropper`
          }, [u("img", {
            src: o.imgSrc,
            ref: l,
            style: {
              display: "none"
            },
            alt: ""
          }, null), u("div", {
            class: `${d}-clip-delete`,
            onClick: f
          }, [u("svg", {
            class: `${d}-icon`,
            "aria-hidden": "true"
          }, [u("use", {
            "xlink:href": "#md-editor-icon-delete"
          }, null)])])]) : u("div", {
            class: `${d}-clip-upload`,
            onClick: () => {
              i.value.click();
            }
          }, [u("svg", {
            class: `${d}-icon`,
            "aria-hidden": "true"
          }, [u("use", {
            "xlink:href": "#md-editor-icon-upload"
          }, null)])])]), u("div", {
            class: `${d}-clip-preview`
          }, [u("div", {
            class: `${d}-clip-preview-target`,
            ref: r
          }, null)])]), u("div", {
            class: `${d}-form-item`
          }, [u("button", {
            class: `${d}-btn`,
            type: "button",
            onClick: () => {
              if (c) {
                const b = c.getCroppedCanvas();
                x.emit(t, "uploadImage", [di(b.toDataURL("image/png"))], s.onOk), f();
              }
            }
          }, [((g = e.value.clipModalTips) == null ? void 0 : g.buttonUpload) || (($ = e.value.linkModalTips) == null ? void 0 : $.buttonOK)])]), u("input", {
            ref: i,
            accept: "image/*",
            type: "file",
            multiple: !1,
            style: {
              display: "none"
            }
          }, null)];
        }
      });
    };
  }
}), Ii = () => ({
  type: {
    type: String,
    default: "link"
  },
  linkVisible: {
    type: Boolean,
    default: !1
  },
  clipVisible: {
    type: Boolean,
    default: !1
  },
  onCancel: {
    type: Function,
    default: () => {
    }
  },
  onOk: {
    type: Function,
    default: () => {
    }
  }
}), Li = /* @__PURE__ */ ae({
  props: Ii(),
  setup(s) {
    return () => u(Wt, null, [u(zi, {
      type: s.type,
      visible: s.linkVisible,
      onOk: s.onOk,
      onCancel: s.onCancel
    }, null), u(Ai, {
      visible: s.clipVisible,
      onOk: s.onOk,
      onCancel: s.onCancel
    }, null)]);
  }
}), Fi = (s) => {
  var c, f, h, m;
  const e = N("editorId");
  let t = (f = (c = te.editorExtensions) == null ? void 0 : c.screenfull) == null ? void 0 : f.instance;
  const n = (m = (h = te.editorExtensions) == null ? void 0 : h.screenfull) == null ? void 0 : m.js, i = ne(!1), l = (v) => {
    if (!t) {
      x.emit(e, "errorCatcher", {
        name: "fullscreen",
        message: "fullscreen is undefined"
      });
      return;
    }
    t.isEnabled ? (i.value = !0, (v === void 0 ? !t.isFullscreen : v) ? t.request() : t.exit()) : console.error("browser does not support screenfull!");
  }, r = () => {
    t && t.isEnabled && t.on("change", () => {
      (i.value || s.setting.fullscreen) && (i.value = !1, s.updateSetting("fullscreen"));
    });
  }, o = () => {
    t = window.screenfull, r();
  };
  return ie(() => {
    if (r(), !t) {
      const v = document.createElement("script");
      v.src = n || oi, v.onload = o, v.id = `${d}-screenfull`, Ce(v, "screenfull");
    }
  }), ie(() => {
    x.on(e, {
      name: jn,
      callback: l
    });
  }), { fullscreenHandler: l };
}, Ri = () => ({
  tableShape: {
    type: Array,
    default: () => [6, 4]
  },
  onSelected: {
    type: Function,
    default: () => {
    }
  }
}), Oi = /* @__PURE__ */ ae({
  name: "TableShape",
  props: Ri(),
  setup(s) {
    const e = ke({
      x: -1,
      y: -1
    });
    return () => u("div", {
      class: `${d}-table-shape`,
      onMouseleave: () => {
        e.x = -1, e.y = -1;
      }
    }, [new Array(s.tableShape[1]).fill("").map((t, n) => u("div", {
      class: `${d}-table-shape-row`,
      key: `table-shape-row-${n}`
    }, [new Array(s.tableShape[0]).fill("").map((i, l) => u("div", {
      class: `${d}-table-shape-col`,
      key: `table-shape-col-${l}`,
      onMouseenter: () => {
        e.x = n, e.y = l;
      },
      onClick: () => {
        s.onSelected(e);
      }
    }, [u("div", {
      class: [`${d}-table-shape-col-default`, n <= e.x && l <= e.y && `${d}-table-shape-col-include`]
    }, null)]))]))]);
  }
}), Di = () => ({
  noPrettier: {
    type: Boolean
  },
  // 工具栏选择显示
  toolbars: {
    type: Array,
    default: () => []
  },
  // 工具栏选择不显示
  toolbarsExclude: {
    type: Array,
    default: () => []
  },
  setting: {
    type: Object,
    default: () => ({})
  },
  screenfull: {
    type: Object,
    default: null
  },
  screenfullJs: {
    type: String,
    default: ""
  },
  updateSetting: {
    type: Function,
    default: () => {
    }
  },
  tableShape: {
    type: Array,
    default: () => [6, 4]
  },
  defToolbars: {
    type: Object
  },
  noUploadImg: {
    type: Boolean
  }
}), Hi = /* @__PURE__ */ ae({
  name: "MDEditorToolbar",
  props: Di(),
  setup(s) {
    const e = N("editorId"), t = N("usedLanguageText"), {
      fullscreenHandler: n
    } = Fi(s), i = `${e}-toolbar-wrapper`, l = ke({
      title: !1,
      catalog: !1,
      // 图片上传下拉
      image: !1,
      // 表格预选
      table: !1,
      // mermaid
      mermaid: !1,
      katex: !1
    }), r = (g, $) => {
      x.emit(e, "replace", g, $);
    }, o = ke({
      type: "link",
      linkVisible: !1,
      clipVisible: !1
    }), c = ne();
    ie(() => {
      x.on(e, {
        name: "openModals",
        callback(g) {
          o.type = g, o.linkVisible = !0;
        }
      });
    });
    const f = Te(() => {
      const g = s.toolbars.filter((p) => !s.toolbarsExclude.includes(p)), $ = g.indexOf("="), b = $ === -1 ? g : g.slice(0, $ + 1), y = $ === -1 ? [] : g.slice($, Number.MAX_SAFE_INTEGER);
      return [b, y];
    }), h = ne(), m = () => {
      x.emit(e, "uploadImage", Array.from(h.value.files || [])), h.value.value = "";
    };
    ie(() => {
      h.value.addEventListener("change", m);
    });
    const v = (g) => {
      var $, b, y, p, w, S, T, z, M, A, k, K, U, q, L, D, B, _, C, j, Z, ee, se, be, ht, Ke, Me, Be, St, Ct, Ge, Tt, Et, Je, et, zt, _t, tt, At, It, ft, dn, hn;
      if (Dn.includes(g))
        switch (g) {
          case "-":
            return u(Si, null, null);
          case "bold":
            return u("div", {
              class: `${d}-toolbar-item`,
              title: ($ = t.value.toolbarTips) == null ? void 0 : $.bold,
              onClick: () => {
                r("bold");
              }
            }, [u("svg", {
              class: `${d}-icon`,
              "aria-hidden": "true"
            }, [u("use", {
              "xlink:href": "#md-editor-icon-bold"
            }, null)])]);
          case "underline":
            return u("div", {
              class: `${d}-toolbar-item`,
              title: (b = t.value.toolbarTips) == null ? void 0 : b.underline,
              onClick: () => {
                r("underline");
              }
            }, [u("svg", {
              class: `${d}-icon`,
              "aria-hidden": "true"
            }, [u("use", {
              "xlink:href": "#md-editor-icon-underline"
            }, null)])]);
          case "italic":
            return u("div", {
              class: `${d}-toolbar-item`,
              title: (y = t.value.toolbarTips) == null ? void 0 : y.italic,
              onClick: () => {
                r("italic");
              }
            }, [u("svg", {
              class: `${d}-icon`,
              "aria-hidden": "true"
            }, [u("use", {
              "xlink:href": "#md-editor-icon-italic"
            }, null)])]);
          case "strikeThrough":
            return u("div", {
              class: `${d}-toolbar-item`,
              title: (p = t.value.toolbarTips) == null ? void 0 : p.strikeThrough,
              onClick: () => {
                r("strikeThrough");
              }
            }, [u("svg", {
              class: `${d}-icon`,
              "aria-hidden": "true"
            }, [u("use", {
              "xlink:href": "#md-editor-icon-strike-through"
            }, null)])]);
          case "title":
            return u(it, {
              relative: `#${i}`,
              visible: l.title,
              onChange: (V) => {
                l.title = V;
              },
              overlay: u("ul", {
                class: `${d}-menu`,
                onClick: () => {
                  l.title = !1;
                }
              }, [u("li", {
                class: `${d}-menu-item`,
                onClick: () => {
                  r("h1");
                }
              }, [(w = t.value.titleItem) == null ? void 0 : w.h1]), u("li", {
                class: `${d}-menu-item`,
                onClick: () => {
                  r("h2");
                }
              }, [(S = t.value.titleItem) == null ? void 0 : S.h2]), u("li", {
                class: `${d}-menu-item`,
                onClick: () => {
                  r("h3");
                }
              }, [(T = t.value.titleItem) == null ? void 0 : T.h3]), u("li", {
                class: `${d}-menu-item`,
                onClick: () => {
                  r("h4");
                }
              }, [(z = t.value.titleItem) == null ? void 0 : z.h4]), u("li", {
                class: `${d}-menu-item`,
                onClick: () => {
                  r("h5");
                }
              }, [(M = t.value.titleItem) == null ? void 0 : M.h5]), u("li", {
                class: `${d}-menu-item`,
                onClick: () => {
                  r("h6");
                }
              }, [(A = t.value.titleItem) == null ? void 0 : A.h6])])
            }, {
              default: () => {
                var V;
                return [u("div", {
                  class: `${d}-toolbar-item`,
                  title: (V = t.value.toolbarTips) == null ? void 0 : V.title
                }, [u("svg", {
                  class: `${d}-icon`,
                  "aria-hidden": "true"
                }, [u("use", {
                  "xlink:href": "#md-editor-icon-title"
                }, null)])])];
              }
            });
          case "sub":
            return u("div", {
              class: `${d}-toolbar-item`,
              title: (k = t.value.toolbarTips) == null ? void 0 : k.sub,
              onClick: () => {
                r("sub");
              }
            }, [u("svg", {
              class: `${d}-icon`,
              "aria-hidden": "true"
            }, [u("use", {
              "xlink:href": "#md-editor-icon-sub"
            }, null)])]);
          case "sup":
            return u("div", {
              class: `${d}-toolbar-item`,
              title: (K = t.value.toolbarTips) == null ? void 0 : K.sup,
              onClick: () => {
                r("sup");
              }
            }, [u("svg", {
              class: `${d}-icon`,
              "aria-hidden": "true"
            }, [u("use", {
              "xlink:href": "#md-editor-icon-sup"
            }, null)])]);
          case "quote":
            return u("div", {
              class: `${d}-toolbar-item`,
              title: (U = t.value.toolbarTips) == null ? void 0 : U.quote,
              onClick: () => {
                r("quote");
              }
            }, [u("svg", {
              class: `${d}-icon`,
              "aria-hidden": "true"
            }, [u("use", {
              "xlink:href": "#md-editor-icon-quote"
            }, null)])]);
          case "unorderedList":
            return u("div", {
              class: `${d}-toolbar-item`,
              title: (q = t.value.toolbarTips) == null ? void 0 : q.unorderedList,
              onClick: () => {
                r("unorderedList");
              }
            }, [u("svg", {
              class: `${d}-icon`,
              "aria-hidden": "true"
            }, [u("use", {
              "xlink:href": "#md-editor-icon-unordered-list"
            }, null)])]);
          case "orderedList":
            return u("div", {
              class: `${d}-toolbar-item`,
              title: (L = t.value.toolbarTips) == null ? void 0 : L.orderedList,
              onClick: () => {
                r("orderedList");
              }
            }, [u("svg", {
              class: `${d}-icon`,
              "aria-hidden": "true"
            }, [u("use", {
              "xlink:href": "#md-editor-icon-ordered-list"
            }, null)])]);
          case "task":
            return u("div", {
              class: `${d}-toolbar-item`,
              title: (D = t.value.toolbarTips) == null ? void 0 : D.task,
              onClick: () => {
                r("task");
              }
            }, [u("svg", {
              class: `${d}-icon`,
              "aria-hidden": "true"
            }, [u("use", {
              "xlink:href": "#md-editor-icon-task"
            }, null)])]);
          case "codeRow":
            return u("div", {
              class: `${d}-toolbar-item`,
              title: (B = t.value.toolbarTips) == null ? void 0 : B.codeRow,
              onClick: () => {
                r("codeRow");
              }
            }, [u("svg", {
              class: `${d}-icon`,
              "aria-hidden": "true"
            }, [u("use", {
              "xlink:href": "#md-editor-icon-code-row"
            }, null)])]);
          case "code":
            return u("div", {
              class: `${d}-toolbar-item`,
              title: (_ = t.value.toolbarTips) == null ? void 0 : _.code,
              onClick: () => {
                r("code");
              }
            }, [u("svg", {
              class: `${d}-icon`,
              "aria-hidden": "true"
            }, [u("use", {
              "xlink:href": "#md-editor-icon-code"
            }, null)])]);
          case "link":
            return u("div", {
              class: `${d}-toolbar-item`,
              title: (C = t.value.toolbarTips) == null ? void 0 : C.link,
              onClick: () => {
                o.type = "link", o.linkVisible = !0;
              }
            }, [u("svg", {
              class: `${d}-icon`,
              "aria-hidden": "true"
            }, [u("use", {
              "xlink:href": "#md-editor-icon-link"
            }, null)])]);
          case "image":
            return s.noUploadImg ? u("div", {
              class: `${d}-toolbar-item`,
              title: (j = t.value.toolbarTips) == null ? void 0 : j.image,
              onClick: () => {
                o.type = "image", o.linkVisible = !0;
              }
            }, [u("svg", {
              class: `${d}-icon`,
              "aria-hidden": "true"
            }, [u("use", {
              "xlink:href": "#md-editor-icon-image"
            }, null)])]) : u(it, {
              relative: `#${i}`,
              visible: l.image,
              onChange: (V) => {
                l.image = V;
              },
              overlay: u("ul", {
                class: `${d}-menu`,
                onClick: () => {
                  l.title = !1;
                }
              }, [u("li", {
                class: `${d}-menu-item`,
                onClick: () => {
                  o.type = "image", o.linkVisible = !0;
                }
              }, [(Z = t.value.imgTitleItem) == null ? void 0 : Z.link]), u("li", {
                class: `${d}-menu-item`,
                onClick: () => {
                  h.value.click();
                }
              }, [(ee = t.value.imgTitleItem) == null ? void 0 : ee.upload]), u("li", {
                class: `${d}-menu-item`,
                onClick: () => {
                  o.clipVisible = !0;
                }
              }, [(se = t.value.imgTitleItem) == null ? void 0 : se.clip2upload])])
            }, {
              default: () => {
                var V;
                return [u("div", {
                  class: `${d}-toolbar-item`,
                  title: (V = t.value.toolbarTips) == null ? void 0 : V.image
                }, [u("svg", {
                  class: `${d}-icon`,
                  "aria-hidden": "true"
                }, [u("use", {
                  "xlink:href": "#md-editor-icon-image"
                }, null)])])];
              }
            });
          case "table":
            return u(it, {
              relative: `#${i}`,
              visible: l.table,
              onChange: (V) => {
                l.table = V;
              },
              key: "bar-table",
              overlay: u(Oi, {
                tableShape: s.tableShape,
                onSelected: (V) => {
                  r("table", {
                    selectedShape: V
                  });
                }
              }, null)
            }, {
              default: () => {
                var V;
                return [u("div", {
                  class: `${d}-toolbar-item`,
                  title: (V = t.value.toolbarTips) == null ? void 0 : V.table
                }, [u("svg", {
                  class: `${d}-icon`,
                  "aria-hidden": "true"
                }, [u("use", {
                  "xlink:href": "#md-editor-icon-table"
                }, null)])])];
              }
            });
          case "revoke":
            return u("div", {
              class: `${d}-toolbar-item`,
              title: (be = t.value.toolbarTips) == null ? void 0 : be.revoke,
              onClick: () => {
                x.emit(e, "ctrlZ");
              }
            }, [u("svg", {
              class: `${d}-icon`,
              "aria-hidden": "true"
            }, [u("use", {
              "xlink:href": "#md-editor-icon-revoke"
            }, null)])]);
          case "next":
            return u("div", {
              class: `${d}-toolbar-item`,
              title: (ht = t.value.toolbarTips) == null ? void 0 : ht.next,
              onClick: () => {
                x.emit(e, "ctrlShiftZ");
              }
            }, [u("svg", {
              class: `${d}-icon`,
              "aria-hidden": "true"
            }, [u("use", {
              "xlink:href": "#md-editor-icon-next"
            }, null)])]);
          case "save":
            return u("div", {
              class: `${d}-toolbar-item`,
              title: (Ke = t.value.toolbarTips) == null ? void 0 : Ke.save,
              onClick: () => {
                x.emit(e, Nt);
              }
            }, [u("svg", {
              class: `${d}-icon`,
              "aria-hidden": "true"
            }, [u("use", {
              "xlink:href": "#md-editor-icon-baocun"
            }, null)])]);
          case "prettier":
            return s.noPrettier ? "" : u("div", {
              class: `${d}-toolbar-item`,
              title: (Me = t.value.toolbarTips) == null ? void 0 : Me.prettier,
              onClick: () => {
                r("prettier");
              }
            }, [u("svg", {
              class: `${d}-icon`,
              "aria-hidden": "true"
            }, [u("use", {
              "xlink:href": "#md-editor-icon-prettier"
            }, null)])]);
          case "pageFullscreen":
            return !s.setting.fullscreen && u("div", {
              class: `${d}-toolbar-item`,
              title: (Be = t.value.toolbarTips) == null ? void 0 : Be.pageFullscreen,
              onClick: () => {
                s.updateSetting("pageFullscreen");
              }
            }, [u("svg", {
              class: `${d}-icon`,
              "aria-hidden": "true"
            }, [u("use", {
              "xlink:href": `#md-editor-icon-${s.setting.pageFullscreen ? "suoxiao" : "fangda"}`
            }, null)])]);
          case "fullscreen":
            return u("div", {
              class: `${d}-toolbar-item`,
              title: (St = t.value.toolbarTips) == null ? void 0 : St.fullscreen,
              onClick: () => {
                n();
              }
            }, [u("svg", {
              class: `${d}-icon`,
              "aria-hidden": "true"
            }, [u("use", {
              "xlink:href": `#md-editor-icon-${s.setting.fullscreen ? "fullscreen-exit" : "fullscreen"}`
            }, null)])]);
          case "preview":
            return u("div", {
              class: `${d}-toolbar-item`,
              title: (Ct = t.value.toolbarTips) == null ? void 0 : Ct.preview,
              onClick: () => {
                s.updateSetting("preview");
              }
            }, [u("svg", {
              class: `${d}-icon`,
              "aria-hidden": "true"
            }, [u("use", {
              "xlink:href": "#md-editor-icon-preview"
            }, null)])]);
          case "htmlPreview":
            return u("div", {
              class: `${d}-toolbar-item`,
              title: (Ge = t.value.toolbarTips) == null ? void 0 : Ge.htmlPreview,
              onClick: () => {
                s.updateSetting("htmlPreview");
              }
            }, [u("svg", {
              class: `${d}-icon`,
              "aria-hidden": "true"
            }, [u("use", {
              "xlink:href": "#md-editor-icon-coding"
            }, null)])]);
          case "catalog":
            return u("div", {
              class: `${d}-toolbar-item`,
              title: (Tt = t.value.toolbarTips) == null ? void 0 : Tt.catalog,
              onClick: () => {
                x.emit(e, on);
              },
              key: "bar-catalog"
            }, [u("svg", {
              class: `${d}-icon`,
              "aria-hidden": "true"
            }, [u("use", {
              "xlink:href": "#md-editor-icon-catalog"
            }, null)])]);
          case "github":
            return u("div", {
              class: `${d}-toolbar-item`,
              title: (Et = t.value.toolbarTips) == null ? void 0 : Et.github,
              onClick: () => ui("https://github.com/imzbf/md-editor-v3")
            }, [u("svg", {
              class: `${d}-icon`,
              "aria-hidden": "true"
            }, [u("use", {
              "xlink:href": "#md-editor-icon-github"
            }, null)])]);
          case "mermaid":
            return u(it, {
              relative: `#${i}`,
              visible: l.mermaid,
              onChange: (V) => {
                l.mermaid = V;
              },
              overlay: u("ul", {
                class: `${d}-menu`,
                onClick: () => {
                  l.mermaid = !1;
                }
              }, [u("li", {
                class: `${d}-menu-item`,
                onClick: () => {
                  r("flow");
                }
              }, [(Je = t.value.mermaid) == null ? void 0 : Je.flow]), u("li", {
                class: `${d}-menu-item`,
                onClick: () => {
                  r("sequence");
                }
              }, [(et = t.value.mermaid) == null ? void 0 : et.sequence]), u("li", {
                class: `${d}-menu-item`,
                onClick: () => {
                  r("gantt");
                }
              }, [(zt = t.value.mermaid) == null ? void 0 : zt.gantt]), u("li", {
                class: `${d}-menu-item`,
                onClick: () => {
                  r("class");
                }
              }, [(_t = t.value.mermaid) == null ? void 0 : _t.class]), u("li", {
                class: `${d}-menu-item`,
                onClick: () => {
                  r("state");
                }
              }, [(tt = t.value.mermaid) == null ? void 0 : tt.state]), u("li", {
                class: `${d}-menu-item`,
                onClick: () => {
                  r("pie");
                }
              }, [(At = t.value.mermaid) == null ? void 0 : At.pie]), u("li", {
                class: `${d}-menu-item`,
                onClick: () => {
                  r("relationship");
                }
              }, [(It = t.value.mermaid) == null ? void 0 : It.relationship]), u("li", {
                class: `${d}-menu-item`,
                onClick: () => {
                  r("journey");
                }
              }, [(ft = t.value.mermaid) == null ? void 0 : ft.journey])]),
              key: "bar-mermaid"
            }, {
              default: () => {
                var V;
                return [u("div", {
                  class: `${d}-toolbar-item`,
                  title: (V = t.value.toolbarTips) == null ? void 0 : V.mermaid
                }, [u("svg", {
                  class: `${d}-icon`,
                  "aria-hidden": "true"
                }, [u("use", {
                  "xlink:href": "#md-editor-icon-mermaid"
                }, null)])])];
              }
            });
          case "katex":
            return u(it, {
              relative: `#${i}`,
              visible: l.katex,
              onChange: (V) => {
                l.katex = V;
              },
              overlay: u("ul", {
                class: `${d}-menu`,
                onClick: () => {
                  l.katex = !1;
                }
              }, [u("li", {
                class: `${d}-menu-item`,
                onClick: () => {
                  r("katexInline");
                }
              }, [(dn = t.value.katex) == null ? void 0 : dn.inline]), u("li", {
                class: `${d}-menu-item`,
                onClick: () => {
                  r("katexBlock");
                }
              }, [(hn = t.value.katex) == null ? void 0 : hn.block])]),
              key: "bar-katex"
            }, {
              default: () => {
                var V;
                return [u("div", {
                  class: `${d}-toolbar-item`,
                  title: (V = t.value.toolbarTips) == null ? void 0 : V.katex
                }, [u("svg", {
                  class: `${d}-icon`,
                  "aria-hidden": "true"
                }, [u("use", {
                  "xlink:href": "#md-editor-icon-formula"
                }, null)])])];
              }
            });
        }
      else
        return s.defToolbars instanceof Array ? s.defToolbars[g] || "" : s.defToolbars && s.defToolbars.children instanceof Array && s.defToolbars.children[g] || "";
    };
    return () => {
      const g = f.value[0].map((b) => v(b)), $ = f.value[1].map((b) => v(b));
      return u(Wt, null, [s.toolbars.length > 0 && u("div", {
        class: `${d}-toolbar-wrapper`,
        id: i
      }, [u("div", {
        class: `${d}-toolbar`
      }, [u("div", {
        class: `${d}-toolbar-left`,
        ref: c
      }, [g]), u("div", {
        class: `${d}-toolbar-right`
      }, [$])])]), u("input", {
        ref: h,
        accept: "image/*",
        type: "file",
        multiple: !0,
        style: {
          display: "none"
        }
      }, null), u(Li, {
        linkVisible: o.linkVisible,
        clipVisible: o.clipVisible,
        type: o.type,
        onCancel: () => {
          o.linkVisible = !1, o.clipVisible = !1;
        },
        onOk: (b) => {
          b && r(o.type, {
            desc: b.desc,
            url: b.url
          }), o.linkVisible = !1, o.clipVisible = !1;
        }
      }, null)]);
    };
  }
});
function Mn() {
  return {
    async: !1,
    baseUrl: null,
    breaks: !1,
    extensions: null,
    gfm: !0,
    headerIds: !0,
    headerPrefix: "",
    highlight: null,
    langPrefix: "language-",
    mangle: !0,
    pedantic: !1,
    renderer: null,
    sanitize: !1,
    sanitizer: null,
    silent: !1,
    smartypants: !1,
    tokenizer: null,
    walkTokens: null,
    xhtml: !1
  };
}
let dt = Mn();
function ji(s) {
  dt = s;
}
const Bn = /[&<>"']/, Pi = new RegExp(Bn.source, "g"), Nn = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/, Mi = new RegExp(Nn.source, "g"), Bi = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
}, Tn = (s) => Bi[s];
function de(s, e) {
  if (e) {
    if (Bn.test(s))
      return s.replace(Pi, Tn);
  } else if (Nn.test(s))
    return s.replace(Mi, Tn);
  return s;
}
const Ni = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;
function Un(s) {
  return s.replace(Ni, (e, t) => (t = t.toLowerCase(), t === "colon" ? ":" : t.charAt(0) === "#" ? t.charAt(1) === "x" ? String.fromCharCode(parseInt(t.substring(2), 16)) : String.fromCharCode(+t.substring(1)) : ""));
}
const Ui = /(^|[^\[])\^/g;
function G(s, e) {
  s = typeof s == "string" ? s : s.source, e = e || "";
  const t = {
    replace: (n, i) => (i = i.source || i, i = i.replace(Ui, "$1"), s = s.replace(n, i), t),
    getRegex: () => new RegExp(s, e)
  };
  return t;
}
const qi = /[^\w:]/g, Vi = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;
function En(s, e, t) {
  if (s) {
    let n;
    try {
      n = decodeURIComponent(Un(t)).replace(qi, "").toLowerCase();
    } catch {
      return null;
    }
    if (n.indexOf("javascript:") === 0 || n.indexOf("vbscript:") === 0 || n.indexOf("data:") === 0)
      return null;
  }
  e && !Vi.test(t) && (t = Zi(e, t));
  try {
    t = encodeURI(t).replace(/%25/g, "%");
  } catch {
    return null;
  }
  return t;
}
const Ft = {}, Wi = /^[^:]+:\/*[^/]*$/, Ki = /^([^:]+:)[\s\S]*$/, Gi = /^([^:]+:\/*[^/]*)[\s\S]*$/;
function Zi(s, e) {
  Ft[" " + s] || (Wi.test(s) ? Ft[" " + s] = s + "/" : Ft[" " + s] = Ot(s, "/", !0)), s = Ft[" " + s];
  const t = s.indexOf(":") === -1;
  return e.substring(0, 2) === "//" ? t ? e : s.replace(Ki, "$1") + e : e.charAt(0) === "/" ? t ? e : s.replace(Gi, "$1") + e : s + e;
}
const Ut = { exec: function() {
} };
function ze(s) {
  let e = 1, t, n;
  for (; e < arguments.length; e++) {
    t = arguments[e];
    for (n in t)
      Object.prototype.hasOwnProperty.call(t, n) && (s[n] = t[n]);
  }
  return s;
}
function zn(s, e) {
  const t = s.replace(/\|/g, (l, r, o) => {
    let c = !1, f = r;
    for (; --f >= 0 && o[f] === "\\"; )
      c = !c;
    return c ? "|" : " |";
  }), n = t.split(/ \|/);
  let i = 0;
  if (n[0].trim() || n.shift(), n.length > 0 && !n[n.length - 1].trim() && n.pop(), n.length > e)
    n.splice(e);
  else
    for (; n.length < e; )
      n.push("");
  for (; i < n.length; i++)
    n[i] = n[i].trim().replace(/\\\|/g, "|");
  return n;
}
function Ot(s, e, t) {
  const n = s.length;
  if (n === 0)
    return "";
  let i = 0;
  for (; i < n; ) {
    const l = s.charAt(n - i - 1);
    if (l === e && !t)
      i++;
    else if (l !== e && t)
      i++;
    else
      break;
  }
  return s.slice(0, n - i);
}
function Xi(s, e) {
  if (s.indexOf(e[1]) === -1)
    return -1;
  const t = s.length;
  let n = 0, i = 0;
  for (; i < t; i++)
    if (s[i] === "\\")
      i++;
    else if (s[i] === e[0])
      n++;
    else if (s[i] === e[1] && (n--, n < 0))
      return i;
  return -1;
}
function qn(s) {
  s && s.sanitize && !s.silent && console.warn("marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options");
}
function _n(s, e) {
  if (e < 1)
    return "";
  let t = "";
  for (; e > 1; )
    e & 1 && (t += s), e >>= 1, s += s;
  return t + s;
}
function An(s, e, t, n) {
  const i = e.href, l = e.title ? de(e.title) : null, r = s[1].replace(/\\([\[\]])/g, "$1");
  if (s[0].charAt(0) !== "!") {
    n.state.inLink = !0;
    const o = {
      type: "link",
      raw: t,
      href: i,
      title: l,
      text: r,
      tokens: n.inlineTokens(r)
    };
    return n.state.inLink = !1, o;
  }
  return {
    type: "image",
    raw: t,
    href: i,
    title: l,
    text: de(r)
  };
}
function Qi(s, e) {
  const t = s.match(/^(\s+)(?:```)/);
  if (t === null)
    return e;
  const n = t[1];
  return e.split(`
`).map((i) => {
    const l = i.match(/^\s+/);
    if (l === null)
      return i;
    const [r] = l;
    return r.length >= n.length ? i.slice(n.length) : i;
  }).join(`
`);
}
class an {
  constructor(e) {
    this.options = e || dt;
  }
  space(e) {
    const t = this.rules.block.newline.exec(e);
    if (t && t[0].length > 0)
      return {
        type: "space",
        raw: t[0]
      };
  }
  code(e) {
    const t = this.rules.block.code.exec(e);
    if (t) {
      const n = t[0].replace(/^ {1,4}/gm, "");
      return {
        type: "code",
        raw: t[0],
        codeBlockStyle: "indented",
        text: this.options.pedantic ? n : Ot(n, `
`)
      };
    }
  }
  fences(e) {
    const t = this.rules.block.fences.exec(e);
    if (t) {
      const n = t[0], i = Qi(n, t[3] || "");
      return {
        type: "code",
        raw: n,
        lang: t[2] ? t[2].trim().replace(this.rules.inline._escapes, "$1") : t[2],
        text: i
      };
    }
  }
  heading(e) {
    const t = this.rules.block.heading.exec(e);
    if (t) {
      let n = t[2].trim();
      if (/#$/.test(n)) {
        const i = Ot(n, "#");
        (this.options.pedantic || !i || / $/.test(i)) && (n = i.trim());
      }
      return {
        type: "heading",
        raw: t[0],
        depth: t[1].length,
        text: n,
        tokens: this.lexer.inline(n)
      };
    }
  }
  hr(e) {
    const t = this.rules.block.hr.exec(e);
    if (t)
      return {
        type: "hr",
        raw: t[0]
      };
  }
  blockquote(e) {
    const t = this.rules.block.blockquote.exec(e);
    if (t) {
      const n = t[0].replace(/^ *>[ \t]?/gm, ""), i = this.lexer.state.top;
      this.lexer.state.top = !0;
      const l = this.lexer.blockTokens(n);
      return this.lexer.state.top = i, {
        type: "blockquote",
        raw: t[0],
        tokens: l,
        text: n
      };
    }
  }
  list(e) {
    let t = this.rules.block.list.exec(e);
    if (t) {
      let n, i, l, r, o, c, f, h, m, v, g, $, b = t[1].trim();
      const y = b.length > 1, p = {
        type: "list",
        raw: "",
        ordered: y,
        start: y ? +b.slice(0, -1) : "",
        loose: !1,
        items: []
      };
      b = y ? `\\d{1,9}\\${b.slice(-1)}` : `\\${b}`, this.options.pedantic && (b = y ? b : "[*+-]");
      const w = new RegExp(`^( {0,3}${b})((?:[	 ][^\\n]*)?(?:\\n|$))`);
      for (; e && ($ = !1, !(!(t = w.exec(e)) || this.rules.block.hr.test(e))); ) {
        if (n = t[0], e = e.substring(n.length), h = t[2].split(`
`, 1)[0].replace(/^\t+/, (T) => " ".repeat(3 * T.length)), m = e.split(`
`, 1)[0], this.options.pedantic ? (r = 2, g = h.trimLeft()) : (r = t[2].search(/[^ ]/), r = r > 4 ? 1 : r, g = h.slice(r), r += t[1].length), c = !1, !h && /^ *$/.test(m) && (n += m + `
`, e = e.substring(m.length + 1), $ = !0), !$) {
          const T = new RegExp(`^ {0,${Math.min(3, r - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`), z = new RegExp(`^ {0,${Math.min(3, r - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`), M = new RegExp(`^ {0,${Math.min(3, r - 1)}}(?:\`\`\`|~~~)`), A = new RegExp(`^ {0,${Math.min(3, r - 1)}}#`);
          for (; e && (v = e.split(`
`, 1)[0], m = v, this.options.pedantic && (m = m.replace(/^ {1,4}(?=( {4})*[^ ])/g, "  ")), !(M.test(m) || A.test(m) || T.test(m) || z.test(e))); ) {
            if (m.search(/[^ ]/) >= r || !m.trim())
              g += `
` + m.slice(r);
            else {
              if (c || h.search(/[^ ]/) >= 4 || M.test(h) || A.test(h) || z.test(h))
                break;
              g += `
` + m;
            }
            !c && !m.trim() && (c = !0), n += v + `
`, e = e.substring(v.length + 1), h = m.slice(r);
          }
        }
        p.loose || (f ? p.loose = !0 : /\n *\n *$/.test(n) && (f = !0)), this.options.gfm && (i = /^\[[ xX]\] /.exec(g), i && (l = i[0] !== "[ ] ", g = g.replace(/^\[[ xX]\] +/, ""))), p.items.push({
          type: "list_item",
          raw: n,
          task: !!i,
          checked: l,
          loose: !1,
          text: g
        }), p.raw += n;
      }
      p.items[p.items.length - 1].raw = n.trimRight(), p.items[p.items.length - 1].text = g.trimRight(), p.raw = p.raw.trimRight();
      const S = p.items.length;
      for (o = 0; o < S; o++)
        if (this.lexer.state.top = !1, p.items[o].tokens = this.lexer.blockTokens(p.items[o].text, []), !p.loose) {
          const T = p.items[o].tokens.filter((M) => M.type === "space"), z = T.length > 0 && T.some((M) => /\n.*\n/.test(M.raw));
          p.loose = z;
        }
      if (p.loose)
        for (o = 0; o < S; o++)
          p.items[o].loose = !0;
      return p;
    }
  }
  html(e) {
    const t = this.rules.block.html.exec(e);
    if (t) {
      const n = {
        type: "html",
        raw: t[0],
        pre: !this.options.sanitizer && (t[1] === "pre" || t[1] === "script" || t[1] === "style"),
        text: t[0]
      };
      if (this.options.sanitize) {
        const i = this.options.sanitizer ? this.options.sanitizer(t[0]) : de(t[0]);
        n.type = "paragraph", n.text = i, n.tokens = this.lexer.inline(i);
      }
      return n;
    }
  }
  def(e) {
    const t = this.rules.block.def.exec(e);
    if (t) {
      const n = t[1].toLowerCase().replace(/\s+/g, " "), i = t[2] ? t[2].replace(/^<(.*)>$/, "$1").replace(this.rules.inline._escapes, "$1") : "", l = t[3] ? t[3].substring(1, t[3].length - 1).replace(this.rules.inline._escapes, "$1") : t[3];
      return {
        type: "def",
        tag: n,
        raw: t[0],
        href: i,
        title: l
      };
    }
  }
  table(e) {
    const t = this.rules.block.table.exec(e);
    if (t) {
      const n = {
        type: "table",
        header: zn(t[1]).map((i) => ({ text: i })),
        align: t[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
        rows: t[3] && t[3].trim() ? t[3].replace(/\n[ \t]*$/, "").split(`
`) : []
      };
      if (n.header.length === n.align.length) {
        n.raw = t[0];
        let i = n.align.length, l, r, o, c;
        for (l = 0; l < i; l++)
          /^ *-+: *$/.test(n.align[l]) ? n.align[l] = "right" : /^ *:-+: *$/.test(n.align[l]) ? n.align[l] = "center" : /^ *:-+ *$/.test(n.align[l]) ? n.align[l] = "left" : n.align[l] = null;
        for (i = n.rows.length, l = 0; l < i; l++)
          n.rows[l] = zn(n.rows[l], n.header.length).map((f) => ({ text: f }));
        for (i = n.header.length, r = 0; r < i; r++)
          n.header[r].tokens = this.lexer.inline(n.header[r].text);
        for (i = n.rows.length, r = 0; r < i; r++)
          for (c = n.rows[r], o = 0; o < c.length; o++)
            c[o].tokens = this.lexer.inline(c[o].text);
        return n;
      }
    }
  }
  lheading(e) {
    const t = this.rules.block.lheading.exec(e);
    if (t)
      return {
        type: "heading",
        raw: t[0],
        depth: t[2].charAt(0) === "=" ? 1 : 2,
        text: t[1],
        tokens: this.lexer.inline(t[1])
      };
  }
  paragraph(e) {
    const t = this.rules.block.paragraph.exec(e);
    if (t) {
      const n = t[1].charAt(t[1].length - 1) === `
` ? t[1].slice(0, -1) : t[1];
      return {
        type: "paragraph",
        raw: t[0],
        text: n,
        tokens: this.lexer.inline(n)
      };
    }
  }
  text(e) {
    const t = this.rules.block.text.exec(e);
    if (t)
      return {
        type: "text",
        raw: t[0],
        text: t[0],
        tokens: this.lexer.inline(t[0])
      };
  }
  escape(e) {
    const t = this.rules.inline.escape.exec(e);
    if (t)
      return {
        type: "escape",
        raw: t[0],
        text: de(t[1])
      };
  }
  tag(e) {
    const t = this.rules.inline.tag.exec(e);
    if (t)
      return !this.lexer.state.inLink && /^<a /i.test(t[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && /^<\/a>/i.test(t[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(t[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(t[0]) && (this.lexer.state.inRawBlock = !1), {
        type: this.options.sanitize ? "text" : "html",
        raw: t[0],
        inLink: this.lexer.state.inLink,
        inRawBlock: this.lexer.state.inRawBlock,
        text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(t[0]) : de(t[0]) : t[0]
      };
  }
  link(e) {
    const t = this.rules.inline.link.exec(e);
    if (t) {
      const n = t[2].trim();
      if (!this.options.pedantic && /^</.test(n)) {
        if (!/>$/.test(n))
          return;
        const r = Ot(n.slice(0, -1), "\\");
        if ((n.length - r.length) % 2 === 0)
          return;
      } else {
        const r = Xi(t[2], "()");
        if (r > -1) {
          const c = (t[0].indexOf("!") === 0 ? 5 : 4) + t[1].length + r;
          t[2] = t[2].substring(0, r), t[0] = t[0].substring(0, c).trim(), t[3] = "";
        }
      }
      let i = t[2], l = "";
      if (this.options.pedantic) {
        const r = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(i);
        r && (i = r[1], l = r[3]);
      } else
        l = t[3] ? t[3].slice(1, -1) : "";
      return i = i.trim(), /^</.test(i) && (this.options.pedantic && !/>$/.test(n) ? i = i.slice(1) : i = i.slice(1, -1)), An(t, {
        href: i && i.replace(this.rules.inline._escapes, "$1"),
        title: l && l.replace(this.rules.inline._escapes, "$1")
      }, t[0], this.lexer);
    }
  }
  reflink(e, t) {
    let n;
    if ((n = this.rules.inline.reflink.exec(e)) || (n = this.rules.inline.nolink.exec(e))) {
      let i = (n[2] || n[1]).replace(/\s+/g, " ");
      if (i = t[i.toLowerCase()], !i) {
        const l = n[0].charAt(0);
        return {
          type: "text",
          raw: l,
          text: l
        };
      }
      return An(n, i, n[0], this.lexer);
    }
  }
  emStrong(e, t, n = "") {
    let i = this.rules.inline.emStrong.lDelim.exec(e);
    if (!i || i[3] && n.match(/[\p{L}\p{N}]/u))
      return;
    const l = i[1] || i[2] || "";
    if (!l || l && (n === "" || this.rules.inline.punctuation.exec(n))) {
      const r = i[0].length - 1;
      let o, c, f = r, h = 0;
      const m = i[0][0] === "*" ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
      for (m.lastIndex = 0, t = t.slice(-1 * e.length + r); (i = m.exec(t)) != null; ) {
        if (o = i[1] || i[2] || i[3] || i[4] || i[5] || i[6], !o)
          continue;
        if (c = o.length, i[3] || i[4]) {
          f += c;
          continue;
        } else if ((i[5] || i[6]) && r % 3 && !((r + c) % 3)) {
          h += c;
          continue;
        }
        if (f -= c, f > 0)
          continue;
        c = Math.min(c, c + f + h);
        const v = e.slice(0, r + i.index + (i[0].length - o.length) + c);
        if (Math.min(r, c) % 2) {
          const $ = v.slice(1, -1);
          return {
            type: "em",
            raw: v,
            text: $,
            tokens: this.lexer.inlineTokens($)
          };
        }
        const g = v.slice(2, -2);
        return {
          type: "strong",
          raw: v,
          text: g,
          tokens: this.lexer.inlineTokens(g)
        };
      }
    }
  }
  codespan(e) {
    const t = this.rules.inline.code.exec(e);
    if (t) {
      let n = t[2].replace(/\n/g, " ");
      const i = /[^ ]/.test(n), l = /^ /.test(n) && / $/.test(n);
      return i && l && (n = n.substring(1, n.length - 1)), n = de(n, !0), {
        type: "codespan",
        raw: t[0],
        text: n
      };
    }
  }
  br(e) {
    const t = this.rules.inline.br.exec(e);
    if (t)
      return {
        type: "br",
        raw: t[0]
      };
  }
  del(e) {
    const t = this.rules.inline.del.exec(e);
    if (t)
      return {
        type: "del",
        raw: t[0],
        text: t[2],
        tokens: this.lexer.inlineTokens(t[2])
      };
  }
  autolink(e, t) {
    const n = this.rules.inline.autolink.exec(e);
    if (n) {
      let i, l;
      return n[2] === "@" ? (i = de(this.options.mangle ? t(n[1]) : n[1]), l = "mailto:" + i) : (i = de(n[1]), l = i), {
        type: "link",
        raw: n[0],
        text: i,
        href: l,
        tokens: [
          {
            type: "text",
            raw: i,
            text: i
          }
        ]
      };
    }
  }
  url(e, t) {
    let n;
    if (n = this.rules.inline.url.exec(e)) {
      let i, l;
      if (n[2] === "@")
        i = de(this.options.mangle ? t(n[0]) : n[0]), l = "mailto:" + i;
      else {
        let r;
        do
          r = n[0], n[0] = this.rules.inline._backpedal.exec(n[0])[0];
        while (r !== n[0]);
        i = de(n[0]), n[1] === "www." ? l = "http://" + n[0] : l = n[0];
      }
      return {
        type: "link",
        raw: n[0],
        text: i,
        href: l,
        tokens: [
          {
            type: "text",
            raw: i,
            text: i
          }
        ]
      };
    }
  }
  inlineText(e, t) {
    const n = this.rules.inline.text.exec(e);
    if (n) {
      let i;
      return this.lexer.state.inRawBlock ? i = this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(n[0]) : de(n[0]) : n[0] : i = de(this.options.smartypants ? t(n[0]) : n[0]), {
        type: "text",
        raw: n[0],
        text: i
      };
    }
  }
}
const R = {
  newline: /^(?: *(?:\n|$))+/,
  code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
  fences: /^ {0,3}(`{3,}(?=[^`\n]*\n)|~{3,})([^\n]*)\n(?:|([\s\S]*?)\n)(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
  hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/,
  heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
  blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
  list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/,
  html: "^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))",
  def: /^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
  table: Ut,
  lheading: /^((?:.|\n(?!\n))+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
  // regex template, placeholders will be replaced according to different paragraph
  // interruption rules of commonmark and the original markdown spec:
  _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
  text: /^[^\n]+/
};
R._label = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
R._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
R.def = G(R.def).replace("label", R._label).replace("title", R._title).getRegex();
R.bullet = /(?:[*+-]|\d{1,9}[.)])/;
R.listItemStart = G(/^( *)(bull) */).replace("bull", R.bullet).getRegex();
R.list = G(R.list).replace(/bull/g, R.bullet).replace("hr", "\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))").replace("def", "\\n+(?=" + R.def.source + ")").getRegex();
R._tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
R._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
R.html = G(R.html, "i").replace("comment", R._comment).replace("tag", R._tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
R.paragraph = G(R._paragraph).replace("hr", R.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", R._tag).getRegex();
R.blockquote = G(R.blockquote).replace("paragraph", R.paragraph).getRegex();
R.normal = ze({}, R);
R.gfm = ze({}, R.normal, {
  table: "^ *([^\\n ].*\\|.*)\\n {0,3}(?:\\| *)?(:?-+:? *(?:\\| *:?-+:? *)*)(?:\\| *)?(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)"
  // Cells
});
R.gfm.table = G(R.gfm.table).replace("hr", R.hr).replace("heading", " {0,3}#{1,6} ").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", R._tag).getRegex();
R.gfm.paragraph = G(R._paragraph).replace("hr", R.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "").replace("table", R.gfm.table).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", R._tag).getRegex();
R.pedantic = ze({}, R.normal, {
  html: G(
    `^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`
  ).replace("comment", R._comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
  def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
  heading: /^(#{1,6})(.*)(?:\n+|$)/,
  fences: Ut,
  // fences not supported
  lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
  paragraph: G(R.normal._paragraph).replace("hr", R.hr).replace("heading", ` *#{1,6} *[^
]`).replace("lheading", R.lheading).replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").getRegex()
});
const E = {
  escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
  autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
  url: Ut,
  tag: "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>",
  // CDATA section
  link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
  reflink: /^!?\[(label)\]\[(ref)\]/,
  nolink: /^!?\[(ref)\](?:\[\])?/,
  reflinkSearch: "reflink|nolink(?!\\()",
  emStrong: {
    lDelim: /^(?:\*+(?:([punct_])|[^\s*]))|^_+(?:([punct*])|([^\s_]))/,
    //        (1) and (2) can only be a Right Delimiter. (3) and (4) can only be Left.  (5) and (6) can be either Left or Right.
    //          () Skip orphan inside strong                                      () Consume to delim     (1) #***                (2) a***#, a***                             (3) #***a, ***a                 (4) ***#              (5) #***#                 (6) a***a
    rDelimAst: /^(?:[^_*\\]|\\.)*?\_\_(?:[^_*\\]|\\.)*?\*(?:[^_*\\]|\\.)*?(?=\_\_)|(?:[^*\\]|\\.)+(?=[^*])|[punct_](\*+)(?=[\s]|$)|(?:[^punct*_\s\\]|\\.)(\*+)(?=[punct_\s]|$)|[punct_\s](\*+)(?=[^punct*_\s])|[\s](\*+)(?=[punct_])|[punct_](\*+)(?=[punct_])|(?:[^punct*_\s\\]|\\.)(\*+)(?=[^punct*_\s])/,
    rDelimUnd: /^(?:[^_*\\]|\\.)*?\*\*(?:[^_*\\]|\\.)*?\_(?:[^_*\\]|\\.)*?(?=\*\*)|(?:[^_\\]|\\.)+(?=[^_])|[punct*](\_+)(?=[\s]|$)|(?:[^punct*_\s\\]|\\.)(\_+)(?=[punct*\s]|$)|[punct*\s](\_+)(?=[^punct*_\s])|[\s](\_+)(?=[punct*])|[punct*](\_+)(?=[punct*])/
    // ^- Not allowed for _
  },
  code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
  br: /^( {2,}|\\)\n(?!\s*$)/,
  del: Ut,
  text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
  punctuation: /^([\spunctuation])/
};
E._punctuation = "!\"#$%&'()+\\-.,/:;<=>?@\\[\\]`^{|}~";
E.punctuation = G(E.punctuation).replace(/punctuation/g, E._punctuation).getRegex();
E.blockSkip = /\[[^\]]*?\]\([^\)]*?\)|`[^`]*?`|<[^>]*?>/g;
E.escapedEmSt = /(?:^|[^\\])(?:\\\\)*\\[*_]/g;
E._comment = G(R._comment).replace("(?:-->|$)", "-->").getRegex();
E.emStrong.lDelim = G(E.emStrong.lDelim).replace(/punct/g, E._punctuation).getRegex();
E.emStrong.rDelimAst = G(E.emStrong.rDelimAst, "g").replace(/punct/g, E._punctuation).getRegex();
E.emStrong.rDelimUnd = G(E.emStrong.rDelimUnd, "g").replace(/punct/g, E._punctuation).getRegex();
E._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g;
E._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
E._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
E.autolink = G(E.autolink).replace("scheme", E._scheme).replace("email", E._email).getRegex();
E._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;
E.tag = G(E.tag).replace("comment", E._comment).replace("attribute", E._attribute).getRegex();
E._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
E._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/;
E._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;
E.link = G(E.link).replace("label", E._label).replace("href", E._href).replace("title", E._title).getRegex();
E.reflink = G(E.reflink).replace("label", E._label).replace("ref", R._label).getRegex();
E.nolink = G(E.nolink).replace("ref", R._label).getRegex();
E.reflinkSearch = G(E.reflinkSearch, "g").replace("reflink", E.reflink).replace("nolink", E.nolink).getRegex();
E.normal = ze({}, E);
E.pedantic = ze({}, E.normal, {
  strong: {
    start: /^__|\*\*/,
    middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
    endAst: /\*\*(?!\*)/g,
    endUnd: /__(?!_)/g
  },
  em: {
    start: /^_|\*/,
    middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
    endAst: /\*(?!\*)/g,
    endUnd: /_(?!_)/g
  },
  link: G(/^!?\[(label)\]\((.*?)\)/).replace("label", E._label).getRegex(),
  reflink: G(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", E._label).getRegex()
});
E.gfm = ze({}, E.normal, {
  escape: G(E.escape).replace("])", "~|])").getRegex(),
  _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
  url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
  _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
  del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
  text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
});
E.gfm.url = G(E.gfm.url, "i").replace("email", E.gfm._extended_email).getRegex();
E.breaks = ze({}, E.gfm, {
  br: G(E.br).replace("{2,}", "*").getRegex(),
  text: G(E.gfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
});
function Yi(s) {
  return s.replace(/---/g, "—").replace(/--/g, "–").replace(/(^|[-\u2014/(\[{"\s])'/g, "$1‘").replace(/'/g, "’").replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1“").replace(/"/g, "”").replace(/\.{3}/g, "…");
}
function In(s) {
  let e = "", t, n;
  const i = s.length;
  for (t = 0; t < i; t++)
    n = s.charCodeAt(t), Math.random() > 0.5 && (n = "x" + n.toString(16)), e += "&#" + n + ";";
  return e;
}
class Pe {
  constructor(e) {
    this.tokens = [], this.tokens.links = /* @__PURE__ */ Object.create(null), this.options = e || dt, this.options.tokenizer = this.options.tokenizer || new an(), this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
      inLink: !1,
      inRawBlock: !1,
      top: !0
    };
    const t = {
      block: R.normal,
      inline: E.normal
    };
    this.options.pedantic ? (t.block = R.pedantic, t.inline = E.pedantic) : this.options.gfm && (t.block = R.gfm, this.options.breaks ? t.inline = E.breaks : t.inline = E.gfm), this.tokenizer.rules = t;
  }
  /**
   * Expose Rules
   */
  static get rules() {
    return {
      block: R,
      inline: E
    };
  }
  /**
   * Static Lex Method
   */
  static lex(e, t) {
    return new Pe(t).lex(e);
  }
  /**
   * Static Lex Inline Method
   */
  static lexInline(e, t) {
    return new Pe(t).inlineTokens(e);
  }
  /**
   * Preprocessing
   */
  lex(e) {
    e = e.replace(/\r\n|\r/g, `
`), this.blockTokens(e, this.tokens);
    let t;
    for (; t = this.inlineQueue.shift(); )
      this.inlineTokens(t.src, t.tokens);
    return this.tokens;
  }
  /**
   * Lexing
   */
  blockTokens(e, t = []) {
    this.options.pedantic ? e = e.replace(/\t/g, "    ").replace(/^ +$/gm, "") : e = e.replace(/^( *)(\t+)/gm, (o, c, f) => c + "    ".repeat(f.length));
    let n, i, l, r;
    for (; e; )
      if (!(this.options.extensions && this.options.extensions.block && this.options.extensions.block.some((o) => (n = o.call({ lexer: this }, e, t)) ? (e = e.substring(n.raw.length), t.push(n), !0) : !1))) {
        if (n = this.tokenizer.space(e)) {
          e = e.substring(n.raw.length), n.raw.length === 1 && t.length > 0 ? t[t.length - 1].raw += `
` : t.push(n);
          continue;
        }
        if (n = this.tokenizer.code(e)) {
          e = e.substring(n.raw.length), i = t[t.length - 1], i && (i.type === "paragraph" || i.type === "text") ? (i.raw += `
` + n.raw, i.text += `
` + n.text, this.inlineQueue[this.inlineQueue.length - 1].src = i.text) : t.push(n);
          continue;
        }
        if (n = this.tokenizer.fences(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.heading(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.hr(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.blockquote(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.list(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.html(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.def(e)) {
          e = e.substring(n.raw.length), i = t[t.length - 1], i && (i.type === "paragraph" || i.type === "text") ? (i.raw += `
` + n.raw, i.text += `
` + n.raw, this.inlineQueue[this.inlineQueue.length - 1].src = i.text) : this.tokens.links[n.tag] || (this.tokens.links[n.tag] = {
            href: n.href,
            title: n.title
          });
          continue;
        }
        if (n = this.tokenizer.table(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.lheading(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (l = e, this.options.extensions && this.options.extensions.startBlock) {
          let o = 1 / 0;
          const c = e.slice(1);
          let f;
          this.options.extensions.startBlock.forEach(function(h) {
            f = h.call({ lexer: this }, c), typeof f == "number" && f >= 0 && (o = Math.min(o, f));
          }), o < 1 / 0 && o >= 0 && (l = e.substring(0, o + 1));
        }
        if (this.state.top && (n = this.tokenizer.paragraph(l))) {
          i = t[t.length - 1], r && i.type === "paragraph" ? (i.raw += `
` + n.raw, i.text += `
` + n.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = i.text) : t.push(n), r = l.length !== e.length, e = e.substring(n.raw.length);
          continue;
        }
        if (n = this.tokenizer.text(e)) {
          e = e.substring(n.raw.length), i = t[t.length - 1], i && i.type === "text" ? (i.raw += `
` + n.raw, i.text += `
` + n.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = i.text) : t.push(n);
          continue;
        }
        if (e) {
          const o = "Infinite loop on byte: " + e.charCodeAt(0);
          if (this.options.silent) {
            console.error(o);
            break;
          } else
            throw new Error(o);
        }
      }
    return this.state.top = !0, t;
  }
  inline(e, t = []) {
    return this.inlineQueue.push({ src: e, tokens: t }), t;
  }
  /**
   * Lexing/Compiling
   */
  inlineTokens(e, t = []) {
    let n, i, l, r = e, o, c, f;
    if (this.tokens.links) {
      const h = Object.keys(this.tokens.links);
      if (h.length > 0)
        for (; (o = this.tokenizer.rules.inline.reflinkSearch.exec(r)) != null; )
          h.includes(o[0].slice(o[0].lastIndexOf("[") + 1, -1)) && (r = r.slice(0, o.index) + "[" + _n("a", o[0].length - 2) + "]" + r.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
    }
    for (; (o = this.tokenizer.rules.inline.blockSkip.exec(r)) != null; )
      r = r.slice(0, o.index) + "[" + _n("a", o[0].length - 2) + "]" + r.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
    for (; (o = this.tokenizer.rules.inline.escapedEmSt.exec(r)) != null; )
      r = r.slice(0, o.index + o[0].length - 2) + "++" + r.slice(this.tokenizer.rules.inline.escapedEmSt.lastIndex), this.tokenizer.rules.inline.escapedEmSt.lastIndex--;
    for (; e; )
      if (c || (f = ""), c = !1, !(this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some((h) => (n = h.call({ lexer: this }, e, t)) ? (e = e.substring(n.raw.length), t.push(n), !0) : !1))) {
        if (n = this.tokenizer.escape(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.tag(e)) {
          e = e.substring(n.raw.length), i = t[t.length - 1], i && n.type === "text" && i.type === "text" ? (i.raw += n.raw, i.text += n.text) : t.push(n);
          continue;
        }
        if (n = this.tokenizer.link(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.reflink(e, this.tokens.links)) {
          e = e.substring(n.raw.length), i = t[t.length - 1], i && n.type === "text" && i.type === "text" ? (i.raw += n.raw, i.text += n.text) : t.push(n);
          continue;
        }
        if (n = this.tokenizer.emStrong(e, r, f)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.codespan(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.br(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.del(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.autolink(e, In)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (!this.state.inLink && (n = this.tokenizer.url(e, In))) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (l = e, this.options.extensions && this.options.extensions.startInline) {
          let h = 1 / 0;
          const m = e.slice(1);
          let v;
          this.options.extensions.startInline.forEach(function(g) {
            v = g.call({ lexer: this }, m), typeof v == "number" && v >= 0 && (h = Math.min(h, v));
          }), h < 1 / 0 && h >= 0 && (l = e.substring(0, h + 1));
        }
        if (n = this.tokenizer.inlineText(l, Yi)) {
          e = e.substring(n.raw.length), n.raw.slice(-1) !== "_" && (f = n.raw.slice(-1)), c = !0, i = t[t.length - 1], i && i.type === "text" ? (i.raw += n.raw, i.text += n.text) : t.push(n);
          continue;
        }
        if (e) {
          const h = "Infinite loop on byte: " + e.charCodeAt(0);
          if (this.options.silent) {
            console.error(h);
            break;
          } else
            throw new Error(h);
        }
      }
    return t;
  }
}
class cn {
  constructor(e) {
    this.options = e || dt;
  }
  code(e, t, n) {
    const i = (t || "").match(/\S*/)[0];
    if (this.options.highlight) {
      const l = this.options.highlight(e, i);
      l != null && l !== e && (n = !0, e = l);
    }
    return e = e.replace(/\n$/, "") + `
`, i ? '<pre><code class="' + this.options.langPrefix + de(i) + '">' + (n ? e : de(e, !0)) + `</code></pre>
` : "<pre><code>" + (n ? e : de(e, !0)) + `</code></pre>
`;
  }
  /**
   * @param {string} quote
   */
  blockquote(e) {
    return `<blockquote>
${e}</blockquote>
`;
  }
  html(e) {
    return e;
  }
  /**
   * @param {string} text
   * @param {string} level
   * @param {string} raw
   * @param {any} slugger
   */
  heading(e, t, n, i) {
    if (this.options.headerIds) {
      const l = this.options.headerPrefix + i.slug(n);
      return `<h${t} id="${l}">${e}</h${t}>
`;
    }
    return `<h${t}>${e}</h${t}>
`;
  }
  hr() {
    return this.options.xhtml ? `<hr/>
` : `<hr>
`;
  }
  list(e, t, n) {
    const i = t ? "ol" : "ul", l = t && n !== 1 ? ' start="' + n + '"' : "";
    return "<" + i + l + `>
` + e + "</" + i + `>
`;
  }
  /**
   * @param {string} text
   */
  listitem(e) {
    return `<li>${e}</li>
`;
  }
  checkbox(e) {
    return "<input " + (e ? 'checked="" ' : "") + 'disabled="" type="checkbox"' + (this.options.xhtml ? " /" : "") + "> ";
  }
  /**
   * @param {string} text
   */
  paragraph(e) {
    return `<p>${e}</p>
`;
  }
  /**
   * @param {string} header
   * @param {string} body
   */
  table(e, t) {
    return t && (t = `<tbody>${t}</tbody>`), `<table>
<thead>
` + e + `</thead>
` + t + `</table>
`;
  }
  /**
   * @param {string} content
   */
  tablerow(e) {
    return `<tr>
${e}</tr>
`;
  }
  tablecell(e, t) {
    const n = t.header ? "th" : "td";
    return (t.align ? `<${n} align="${t.align}">` : `<${n}>`) + e + `</${n}>
`;
  }
  /**
   * span level renderer
   * @param {string} text
   */
  strong(e) {
    return `<strong>${e}</strong>`;
  }
  /**
   * @param {string} text
   */
  em(e) {
    return `<em>${e}</em>`;
  }
  /**
   * @param {string} text
   */
  codespan(e) {
    return `<code>${e}</code>`;
  }
  br() {
    return this.options.xhtml ? "<br/>" : "<br>";
  }
  /**
   * @param {string} text
   */
  del(e) {
    return `<del>${e}</del>`;
  }
  /**
   * @param {string} href
   * @param {string} title
   * @param {string} text
   */
  link(e, t, n) {
    if (e = En(this.options.sanitize, this.options.baseUrl, e), e === null)
      return n;
    let i = '<a href="' + e + '"';
    return t && (i += ' title="' + t + '"'), i += ">" + n + "</a>", i;
  }
  /**
   * @param {string} href
   * @param {string} title
   * @param {string} text
   */
  image(e, t, n) {
    if (e = En(this.options.sanitize, this.options.baseUrl, e), e === null)
      return n;
    let i = `<img src="${e}" alt="${n}"`;
    return t && (i += ` title="${t}"`), i += this.options.xhtml ? "/>" : ">", i;
  }
  text(e) {
    return e;
  }
}
class Vn {
  // no need for block level renderers
  strong(e) {
    return e;
  }
  em(e) {
    return e;
  }
  codespan(e) {
    return e;
  }
  del(e) {
    return e;
  }
  html(e) {
    return e;
  }
  text(e) {
    return e;
  }
  link(e, t, n) {
    return "" + n;
  }
  image(e, t, n) {
    return "" + n;
  }
  br() {
    return "";
  }
}
class Wn {
  constructor() {
    this.seen = {};
  }
  /**
   * @param {string} value
   */
  serialize(e) {
    return e.toLowerCase().trim().replace(/<[!\/a-z].*?>/ig, "").replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, "").replace(/\s/g, "-");
  }
  /**
   * Finds the next safe (unique) slug to use
   * @param {string} originalSlug
   * @param {boolean} isDryRun
   */
  getNextSafeSlug(e, t) {
    let n = e, i = 0;
    if (this.seen.hasOwnProperty(n)) {
      i = this.seen[e];
      do
        i++, n = e + "-" + i;
      while (this.seen.hasOwnProperty(n));
    }
    return t || (this.seen[e] = i, this.seen[n] = 0), n;
  }
  /**
   * Convert string to unique id
   * @param {object} [options]
   * @param {boolean} [options.dryrun] Generates the next unique slug without
   * updating the internal accumulator.
   */
  slug(e, t = {}) {
    const n = this.serialize(e);
    return this.getNextSafeSlug(n, t.dryrun);
  }
}
class Fe {
  constructor(e) {
    this.options = e || dt, this.options.renderer = this.options.renderer || new cn(), this.renderer = this.options.renderer, this.renderer.options = this.options, this.textRenderer = new Vn(), this.slugger = new Wn();
  }
  /**
   * Static Parse Method
   */
  static parse(e, t) {
    return new Fe(t).parse(e);
  }
  /**
   * Static Parse Inline Method
   */
  static parseInline(e, t) {
    return new Fe(t).parseInline(e);
  }
  /**
   * Parse Loop
   */
  parse(e, t = !0) {
    let n = "", i, l, r, o, c, f, h, m, v, g, $, b, y, p, w, S, T, z, M;
    const A = e.length;
    for (i = 0; i < A; i++) {
      if (g = e[i], this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[g.type] && (M = this.options.extensions.renderers[g.type].call({ parser: this }, g), M !== !1 || !["space", "hr", "heading", "code", "table", "blockquote", "list", "html", "paragraph", "text"].includes(g.type))) {
        n += M || "";
        continue;
      }
      switch (g.type) {
        case "space":
          continue;
        case "hr": {
          n += this.renderer.hr();
          continue;
        }
        case "heading": {
          n += this.renderer.heading(
            this.parseInline(g.tokens),
            g.depth,
            Un(this.parseInline(g.tokens, this.textRenderer)),
            this.slugger
          );
          continue;
        }
        case "code": {
          n += this.renderer.code(
            g.text,
            g.lang,
            g.escaped
          );
          continue;
        }
        case "table": {
          for (m = "", h = "", o = g.header.length, l = 0; l < o; l++)
            h += this.renderer.tablecell(
              this.parseInline(g.header[l].tokens),
              { header: !0, align: g.align[l] }
            );
          for (m += this.renderer.tablerow(h), v = "", o = g.rows.length, l = 0; l < o; l++) {
            for (f = g.rows[l], h = "", c = f.length, r = 0; r < c; r++)
              h += this.renderer.tablecell(
                this.parseInline(f[r].tokens),
                { header: !1, align: g.align[r] }
              );
            v += this.renderer.tablerow(h);
          }
          n += this.renderer.table(m, v);
          continue;
        }
        case "blockquote": {
          v = this.parse(g.tokens), n += this.renderer.blockquote(v);
          continue;
        }
        case "list": {
          for ($ = g.ordered, b = g.start, y = g.loose, o = g.items.length, v = "", l = 0; l < o; l++)
            w = g.items[l], S = w.checked, T = w.task, p = "", w.task && (z = this.renderer.checkbox(S), y ? w.tokens.length > 0 && w.tokens[0].type === "paragraph" ? (w.tokens[0].text = z + " " + w.tokens[0].text, w.tokens[0].tokens && w.tokens[0].tokens.length > 0 && w.tokens[0].tokens[0].type === "text" && (w.tokens[0].tokens[0].text = z + " " + w.tokens[0].tokens[0].text)) : w.tokens.unshift({
              type: "text",
              text: z
            }) : p += z), p += this.parse(w.tokens, y), v += this.renderer.listitem(p, T, S);
          n += this.renderer.list(v, $, b);
          continue;
        }
        case "html": {
          n += this.renderer.html(g.text);
          continue;
        }
        case "paragraph": {
          n += this.renderer.paragraph(this.parseInline(g.tokens));
          continue;
        }
        case "text": {
          for (v = g.tokens ? this.parseInline(g.tokens) : g.text; i + 1 < A && e[i + 1].type === "text"; )
            g = e[++i], v += `
` + (g.tokens ? this.parseInline(g.tokens) : g.text);
          n += t ? this.renderer.paragraph(v) : v;
          continue;
        }
        default: {
          const k = 'Token with "' + g.type + '" type was not found.';
          if (this.options.silent) {
            console.error(k);
            return;
          } else
            throw new Error(k);
        }
      }
    }
    return n;
  }
  /**
   * Parse Inline Tokens
   */
  parseInline(e, t) {
    t = t || this.renderer;
    let n = "", i, l, r;
    const o = e.length;
    for (i = 0; i < o; i++) {
      if (l = e[i], this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[l.type] && (r = this.options.extensions.renderers[l.type].call({ parser: this }, l), r !== !1 || !["escape", "html", "link", "image", "strong", "em", "codespan", "br", "del", "text"].includes(l.type))) {
        n += r || "";
        continue;
      }
      switch (l.type) {
        case "escape": {
          n += t.text(l.text);
          break;
        }
        case "html": {
          n += t.html(l.text);
          break;
        }
        case "link": {
          n += t.link(l.href, l.title, this.parseInline(l.tokens, t));
          break;
        }
        case "image": {
          n += t.image(l.href, l.title, l.text);
          break;
        }
        case "strong": {
          n += t.strong(this.parseInline(l.tokens, t));
          break;
        }
        case "em": {
          n += t.em(this.parseInline(l.tokens, t));
          break;
        }
        case "codespan": {
          n += t.codespan(l.text);
          break;
        }
        case "br": {
          n += t.br();
          break;
        }
        case "del": {
          n += t.del(this.parseInline(l.tokens, t));
          break;
        }
        case "text": {
          n += t.text(l.text);
          break;
        }
        default: {
          const c = 'Token with "' + l.type + '" type was not found.';
          if (this.options.silent) {
            console.error(c);
            return;
          } else
            throw new Error(c);
        }
      }
    }
    return n;
  }
}
function I(s, e, t) {
  if (typeof s > "u" || s === null)
    throw new Error("marked(): input parameter is undefined or null");
  if (typeof s != "string")
    throw new Error("marked(): input parameter is of type " + Object.prototype.toString.call(s) + ", string expected");
  if (typeof e == "function" && (t = e, e = null), e = ze({}, I.defaults, e || {}), qn(e), t) {
    const i = e.highlight;
    let l;
    try {
      l = Pe.lex(s, e);
    } catch (c) {
      return t(c);
    }
    const r = function(c) {
      let f;
      if (!c)
        try {
          e.walkTokens && I.walkTokens(l, e.walkTokens), f = Fe.parse(l, e);
        } catch (h) {
          c = h;
        }
      return e.highlight = i, c ? t(c) : t(null, f);
    };
    if (!i || i.length < 3 || (delete e.highlight, !l.length))
      return r();
    let o = 0;
    I.walkTokens(l, function(c) {
      c.type === "code" && (o++, setTimeout(() => {
        i(c.text, c.lang, function(f, h) {
          if (f)
            return r(f);
          h != null && h !== c.text && (c.text = h, c.escaped = !0), o--, o === 0 && r();
        });
      }, 0));
    }), o === 0 && r();
    return;
  }
  function n(i) {
    if (i.message += `
Please report this to https://github.com/markedjs/marked.`, e.silent)
      return "<p>An error occurred:</p><pre>" + de(i.message + "", !0) + "</pre>";
    throw i;
  }
  try {
    const i = Pe.lex(s, e);
    if (e.walkTokens) {
      if (e.async)
        return Promise.all(I.walkTokens(i, e.walkTokens)).then(() => Fe.parse(i, e)).catch(n);
      I.walkTokens(i, e.walkTokens);
    }
    return Fe.parse(i, e);
  } catch (i) {
    n(i);
  }
}
I.options = I.setOptions = function(s) {
  return ze(I.defaults, s), ji(I.defaults), I;
};
I.getDefaults = Mn;
I.defaults = dt;
I.use = function(...s) {
  const e = I.defaults.extensions || { renderers: {}, childTokens: {} };
  s.forEach((t) => {
    const n = ze({}, t);
    if (n.async = I.defaults.async || n.async, t.extensions && (t.extensions.forEach((i) => {
      if (!i.name)
        throw new Error("extension name required");
      if (i.renderer) {
        const l = e.renderers[i.name];
        l ? e.renderers[i.name] = function(...r) {
          let o = i.renderer.apply(this, r);
          return o === !1 && (o = l.apply(this, r)), o;
        } : e.renderers[i.name] = i.renderer;
      }
      if (i.tokenizer) {
        if (!i.level || i.level !== "block" && i.level !== "inline")
          throw new Error("extension level must be 'block' or 'inline'");
        e[i.level] ? e[i.level].unshift(i.tokenizer) : e[i.level] = [i.tokenizer], i.start && (i.level === "block" ? e.startBlock ? e.startBlock.push(i.start) : e.startBlock = [i.start] : i.level === "inline" && (e.startInline ? e.startInline.push(i.start) : e.startInline = [i.start]));
      }
      i.childTokens && (e.childTokens[i.name] = i.childTokens);
    }), n.extensions = e), t.renderer) {
      const i = I.defaults.renderer || new cn();
      for (const l in t.renderer) {
        const r = i[l];
        i[l] = (...o) => {
          let c = t.renderer[l].apply(i, o);
          return c === !1 && (c = r.apply(i, o)), c;
        };
      }
      n.renderer = i;
    }
    if (t.tokenizer) {
      const i = I.defaults.tokenizer || new an();
      for (const l in t.tokenizer) {
        const r = i[l];
        i[l] = (...o) => {
          let c = t.tokenizer[l].apply(i, o);
          return c === !1 && (c = r.apply(i, o)), c;
        };
      }
      n.tokenizer = i;
    }
    if (t.walkTokens) {
      const i = I.defaults.walkTokens;
      n.walkTokens = function(l) {
        let r = [];
        return r.push(t.walkTokens.call(this, l)), i && (r = r.concat(i.call(this, l))), r;
      };
    }
    I.setOptions(n);
  });
};
I.walkTokens = function(s, e) {
  let t = [];
  for (const n of s)
    switch (t = t.concat(e.call(I, n)), n.type) {
      case "table": {
        for (const i of n.header)
          t = t.concat(I.walkTokens(i.tokens, e));
        for (const i of n.rows)
          for (const l of i)
            t = t.concat(I.walkTokens(l.tokens, e));
        break;
      }
      case "list": {
        t = t.concat(I.walkTokens(n.items, e));
        break;
      }
      default:
        I.defaults.extensions && I.defaults.extensions.childTokens && I.defaults.extensions.childTokens[n.type] ? I.defaults.extensions.childTokens[n.type].forEach(function(i) {
          t = t.concat(I.walkTokens(n[i], e));
        }) : n.tokens && (t = t.concat(I.walkTokens(n.tokens, e)));
    }
  return t;
};
I.parseInline = function(s, e) {
  if (typeof s > "u" || s === null)
    throw new Error("marked.parseInline(): input parameter is undefined or null");
  if (typeof s != "string")
    throw new Error("marked.parseInline(): input parameter is of type " + Object.prototype.toString.call(s) + ", string expected");
  e = ze({}, I.defaults, e || {}), qn(e);
  try {
    const t = Pe.lexInline(s, e);
    return e.walkTokens && I.walkTokens(t, e.walkTokens), Fe.parseInline(t, e);
  } catch (t) {
    if (t.message += `
Please report this to https://github.com/markedjs/marked.`, e.silent)
      return "<p>An error occurred:</p><pre>" + de(t.message + "", !0) + "</pre>";
    throw t;
  }
};
I.Parser = Fe;
I.parser = Fe.parse;
I.Renderer = cn;
I.TextRenderer = Vn;
I.Lexer = Pe;
I.lexer = Pe.lex;
I.Tokenizer = an;
I.Slugger = Wn;
I.parse = I;
I.options;
I.setOptions;
I.use;
I.walkTokens;
I.parseInline;
Fe.parse;
Pe.lex;
var Ji = function() {
  var s = document.getSelection();
  if (!s.rangeCount)
    return function() {
    };
  for (var e = document.activeElement, t = [], n = 0; n < s.rangeCount; n++)
    t.push(s.getRangeAt(n));
  switch (e.tagName.toUpperCase()) {
    case "INPUT":
    case "TEXTAREA":
      e.blur();
      break;
    default:
      e = null;
      break;
  }
  return s.removeAllRanges(), function() {
    s.type === "Caret" && s.removeAllRanges(), s.rangeCount || t.forEach(function(i) {
      s.addRange(i);
    }), e && e.focus();
  };
}, es = Ji, Ln = {
  "text/plain": "Text",
  "text/html": "Url",
  default: "Text"
}, ts = "Copy to clipboard: #{key}, Enter";
function ns(s) {
  var e = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return s.replace(/#{\s*key\s*}/g, e);
}
function is(s, e) {
  var t, n, i, l, r, o, c = !1;
  e || (e = {}), t = e.debug || !1;
  try {
    i = es(), l = document.createRange(), r = document.getSelection(), o = document.createElement("span"), o.textContent = s, o.ariaHidden = "true", o.style.all = "unset", o.style.position = "fixed", o.style.top = 0, o.style.clip = "rect(0, 0, 0, 0)", o.style.whiteSpace = "pre", o.style.webkitUserSelect = "text", o.style.MozUserSelect = "text", o.style.msUserSelect = "text", o.style.userSelect = "text", o.addEventListener("copy", function(h) {
      if (h.stopPropagation(), e.format)
        if (h.preventDefault(), typeof h.clipboardData > "u") {
          t && console.warn("unable to use e.clipboardData"), t && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
          var m = Ln[e.format] || Ln.default;
          window.clipboardData.setData(m, s);
        } else
          h.clipboardData.clearData(), h.clipboardData.setData(e.format, s);
      e.onCopy && (h.preventDefault(), e.onCopy(h.clipboardData));
    }), document.body.appendChild(o), l.selectNodeContents(o), r.addRange(l);
    var f = document.execCommand("copy");
    if (!f)
      throw new Error("copy command was unsuccessful");
    c = !0;
  } catch (h) {
    t && console.error("unable to copy using execCommand: ", h), t && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(e.format || "text", s), e.onCopy && e.onCopy(window.clipboardData), c = !0;
    } catch (m) {
      t && console.error("unable to copy using clipboardData: ", m), t && console.error("falling back to prompt"), n = ns("message" in e ? e.message : ts), window.prompt(n, s);
    }
  } finally {
    r && (typeof r.removeRange == "function" ? r.removeRange(l) : r.removeAllRanges()), o && document.body.removeChild(o), i();
  }
  return c;
}
var pt = is;
/*! medium-zoom 1.0.8 | MIT License | https://github.com/francoischalifour/medium-zoom */
var Ze = Object.assign || function(s) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e];
    for (var n in t)
      Object.prototype.hasOwnProperty.call(t, n) && (s[n] = t[n]);
  }
  return s;
}, Rt = function(e) {
  return e.tagName === "IMG";
}, ss = function(e) {
  return NodeList.prototype.isPrototypeOf(e);
}, Dt = function(e) {
  return e && e.nodeType === 1;
}, Fn = function(e) {
  var t = e.currentSrc || e.src;
  return t.substr(-4).toLowerCase() === ".svg";
}, Rn = function(e) {
  try {
    return Array.isArray(e) ? e.filter(Rt) : ss(e) ? [].slice.call(e).filter(Rt) : Dt(e) ? [e].filter(Rt) : typeof e == "string" ? [].slice.call(document.querySelectorAll(e)).filter(Rt) : [];
  } catch {
    throw new TypeError(`The provided selector is invalid.
Expects a CSS selector, a Node element, a NodeList or an array.
See: https://github.com/francoischalifour/medium-zoom`);
  }
}, ls = function(e) {
  var t = document.createElement("div");
  return t.classList.add("medium-zoom-overlay"), t.style.background = e, t;
}, os = function(e) {
  var t = e.getBoundingClientRect(), n = t.top, i = t.left, l = t.width, r = t.height, o = e.cloneNode(), c = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0, f = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
  return o.removeAttribute("id"), o.style.position = "absolute", o.style.top = n + c + "px", o.style.left = i + f + "px", o.style.width = l + "px", o.style.height = r + "px", o.style.transform = "", o;
}, nt = function(e, t) {
  var n = Ze({
    bubbles: !1,
    cancelable: !1,
    detail: void 0
  }, t);
  if (typeof window.CustomEvent == "function")
    return new CustomEvent(e, n);
  var i = document.createEvent("CustomEvent");
  return i.initCustomEvent(e, n.bubbles, n.cancelable, n.detail), i;
}, rs = function s(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = window.Promise || function(L) {
    function D() {
    }
    L(D, D);
  }, i = function(L) {
    var D = L.target;
    if (D === K) {
      $();
      return;
    }
    S.indexOf(D) !== -1 && b({ target: D });
  }, l = function() {
    if (!(z || !k.original)) {
      var L = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      Math.abs(M - L) > A.scrollOffset && setTimeout($, 150);
    }
  }, r = function(L) {
    var D = L.key || L.keyCode;
    (D === "Escape" || D === "Esc" || D === 27) && $();
  }, o = function() {
    var L = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, D = L;
    if (L.background && (K.style.background = L.background), L.container && L.container instanceof Object && (D.container = Ze({}, A.container, L.container)), L.template) {
      var B = Dt(L.template) ? L.template : document.querySelector(L.template);
      D.template = B;
    }
    return A = Ze({}, A, D), S.forEach(function(_) {
      _.dispatchEvent(nt("medium-zoom:update", {
        detail: { zoom: U }
      }));
    }), U;
  }, c = function() {
    var L = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return s(Ze({}, A, L));
  }, f = function() {
    for (var L = arguments.length, D = Array(L), B = 0; B < L; B++)
      D[B] = arguments[B];
    var _ = D.reduce(function(C, j) {
      return [].concat(C, Rn(j));
    }, []);
    return _.filter(function(C) {
      return S.indexOf(C) === -1;
    }).forEach(function(C) {
      S.push(C), C.classList.add("medium-zoom-image");
    }), T.forEach(function(C) {
      var j = C.type, Z = C.listener, ee = C.options;
      _.forEach(function(se) {
        se.addEventListener(j, Z, ee);
      });
    }), U;
  }, h = function() {
    for (var L = arguments.length, D = Array(L), B = 0; B < L; B++)
      D[B] = arguments[B];
    k.zoomed && $();
    var _ = D.length > 0 ? D.reduce(function(C, j) {
      return [].concat(C, Rn(j));
    }, []) : S;
    return _.forEach(function(C) {
      C.classList.remove("medium-zoom-image"), C.dispatchEvent(nt("medium-zoom:detach", {
        detail: { zoom: U }
      }));
    }), S = S.filter(function(C) {
      return _.indexOf(C) === -1;
    }), U;
  }, m = function(L, D) {
    var B = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return S.forEach(function(_) {
      _.addEventListener("medium-zoom:" + L, D, B);
    }), T.push({ type: "medium-zoom:" + L, listener: D, options: B }), U;
  }, v = function(L, D) {
    var B = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return S.forEach(function(_) {
      _.removeEventListener("medium-zoom:" + L, D, B);
    }), T = T.filter(function(_) {
      return !(_.type === "medium-zoom:" + L && _.listener.toString() === D.toString());
    }), U;
  }, g = function() {
    var L = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, D = L.target, B = function() {
      var C = {
        width: document.documentElement.clientWidth,
        height: document.documentElement.clientHeight,
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      }, j = void 0, Z = void 0;
      if (A.container)
        if (A.container instanceof Object)
          C = Ze({}, C, A.container), j = C.width - C.left - C.right - A.margin * 2, Z = C.height - C.top - C.bottom - A.margin * 2;
        else {
          var ee = Dt(A.container) ? A.container : document.querySelector(A.container), se = ee.getBoundingClientRect(), be = se.width, ht = se.height, Ke = se.left, Me = se.top;
          C = Ze({}, C, {
            width: be,
            height: ht,
            left: Ke,
            top: Me
          });
        }
      j = j || C.width - A.margin * 2, Z = Z || C.height - A.margin * 2;
      var Be = k.zoomedHd || k.original, St = Fn(Be) ? j : Be.naturalWidth || j, Ct = Fn(Be) ? Z : Be.naturalHeight || Z, Ge = Be.getBoundingClientRect(), Tt = Ge.top, Et = Ge.left, Je = Ge.width, et = Ge.height, zt = Math.min(Math.max(Je, St), j) / Je, _t = Math.min(Math.max(et, Ct), Z) / et, tt = Math.min(zt, _t), At = (-Et + (j - Je) / 2 + A.margin + C.left) / tt, It = (-Tt + (Z - et) / 2 + A.margin + C.top) / tt, ft = "scale(" + tt + ") translate3d(" + At + "px, " + It + "px, 0)";
      k.zoomed.style.transform = ft, k.zoomedHd && (k.zoomedHd.style.transform = ft);
    };
    return new n(function(_) {
      if (D && S.indexOf(D) === -1) {
        _(U);
        return;
      }
      var C = function be() {
        z = !1, k.zoomed.removeEventListener("transitionend", be), k.original.dispatchEvent(nt("medium-zoom:opened", {
          detail: { zoom: U }
        })), _(U);
      };
      if (k.zoomed) {
        _(U);
        return;
      }
      if (D)
        k.original = D;
      else if (S.length > 0) {
        var j = S;
        k.original = j[0];
      } else {
        _(U);
        return;
      }
      if (k.original.dispatchEvent(nt("medium-zoom:open", {
        detail: { zoom: U }
      })), M = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0, z = !0, k.zoomed = os(k.original), document.body.appendChild(K), A.template) {
        var Z = Dt(A.template) ? A.template : document.querySelector(A.template);
        k.template = document.createElement("div"), k.template.appendChild(Z.content.cloneNode(!0)), document.body.appendChild(k.template);
      }
      if (k.original.parentElement && k.original.parentElement.tagName === "PICTURE" && k.original.currentSrc && (k.zoomed.src = k.original.currentSrc), document.body.appendChild(k.zoomed), window.requestAnimationFrame(function() {
        document.body.classList.add("medium-zoom--opened");
      }), k.original.classList.add("medium-zoom-image--hidden"), k.zoomed.classList.add("medium-zoom-image--opened"), k.zoomed.addEventListener("click", $), k.zoomed.addEventListener("transitionend", C), k.original.getAttribute("data-zoom-src")) {
        k.zoomedHd = k.zoomed.cloneNode(), k.zoomedHd.removeAttribute("srcset"), k.zoomedHd.removeAttribute("sizes"), k.zoomedHd.removeAttribute("loading"), k.zoomedHd.src = k.zoomed.getAttribute("data-zoom-src"), k.zoomedHd.onerror = function() {
          clearInterval(ee), console.warn("Unable to reach the zoom image target " + k.zoomedHd.src), k.zoomedHd = null, B();
        };
        var ee = setInterval(function() {
          k.zoomedHd.complete && (clearInterval(ee), k.zoomedHd.classList.add("medium-zoom-image--opened"), k.zoomedHd.addEventListener("click", $), document.body.appendChild(k.zoomedHd), B());
        }, 10);
      } else if (k.original.hasAttribute("srcset")) {
        k.zoomedHd = k.zoomed.cloneNode(), k.zoomedHd.removeAttribute("sizes"), k.zoomedHd.removeAttribute("loading");
        var se = k.zoomedHd.addEventListener("load", function() {
          k.zoomedHd.removeEventListener("load", se), k.zoomedHd.classList.add("medium-zoom-image--opened"), k.zoomedHd.addEventListener("click", $), document.body.appendChild(k.zoomedHd), B();
        });
      } else
        B();
    });
  }, $ = function() {
    return new n(function(L) {
      if (z || !k.original) {
        L(U);
        return;
      }
      var D = function B() {
        k.original.classList.remove("medium-zoom-image--hidden"), document.body.removeChild(k.zoomed), k.zoomedHd && document.body.removeChild(k.zoomedHd), document.body.removeChild(K), k.zoomed.classList.remove("medium-zoom-image--opened"), k.template && document.body.removeChild(k.template), z = !1, k.zoomed.removeEventListener("transitionend", B), k.original.dispatchEvent(nt("medium-zoom:closed", {
          detail: { zoom: U }
        })), k.original = null, k.zoomed = null, k.zoomedHd = null, k.template = null, L(U);
      };
      z = !0, document.body.classList.remove("medium-zoom--opened"), k.zoomed.style.transform = "", k.zoomedHd && (k.zoomedHd.style.transform = ""), k.template && (k.template.style.transition = "opacity 150ms", k.template.style.opacity = 0), k.original.dispatchEvent(nt("medium-zoom:close", {
        detail: { zoom: U }
      })), k.zoomed.addEventListener("transitionend", D);
    });
  }, b = function() {
    var L = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, D = L.target;
    return k.original ? $() : g({ target: D });
  }, y = function() {
    return A;
  }, p = function() {
    return S;
  }, w = function() {
    return k.original;
  }, S = [], T = [], z = !1, M = 0, A = t, k = {
    original: null,
    zoomed: null,
    zoomedHd: null,
    template: null
    // If the selector is omitted, it's replaced by the options
  };
  Object.prototype.toString.call(e) === "[object Object]" ? A = e : (e || typeof e == "string") && f(e), A = Ze({
    margin: 0,
    background: "#fff",
    scrollOffset: 40,
    container: null,
    template: null
  }, A);
  var K = ls(A.background);
  document.addEventListener("click", i), document.addEventListener("keyup", r), document.addEventListener("scroll", l), window.addEventListener("resize", $);
  var U = {
    open: g,
    close: $,
    toggle: b,
    update: o,
    clone: c,
    attach: f,
    detach: h,
    on: m,
    off: v,
    getOptions: y,
    getImages: p,
    getZoomedImage: w
  };
  return U;
};
function as(s, e) {
  e === void 0 && (e = {});
  var t = e.insertAt;
  if (!(!s || typeof document > "u")) {
    var n = document.head || document.getElementsByTagName("head")[0], i = document.createElement("style");
    i.type = "text/css", t === "top" && n.firstChild ? n.insertBefore(i, n.firstChild) : n.appendChild(i), i.styleSheet ? i.styleSheet.cssText = s : i.appendChild(document.createTextNode(s));
  }
}
var cs = ".medium-zoom-overlay{position:fixed;top:0;right:0;bottom:0;left:0;opacity:0;transition:opacity .3s;will-change:opacity}.medium-zoom--opened .medium-zoom-overlay{cursor:pointer;cursor:zoom-out;opacity:1}.medium-zoom-image{cursor:pointer;cursor:zoom-in;transition:transform .3s cubic-bezier(.2,0,.2,1)!important}.medium-zoom-image--hidden{visibility:hidden}.medium-zoom-image--opened{position:relative;cursor:pointer;cursor:zoom-out;will-change:transform}";
as(cs);
const us = rs, mt = typeof performance == "object" && performance && typeof performance.now == "function" ? performance : Date, Kn = /* @__PURE__ */ new Set(), ds = (s, e, t, n) => {
  typeof process == "object" && process && typeof process.emitWarning == "function" ? process.emitWarning(s, e, t, n) : console.error(`[${t}] ${e}: ${s}`);
}, hs = (s) => !Kn.has(s), Ne = (s) => s && s === Math.floor(s) && s > 0 && isFinite(s), Gn = (s) => Ne(s) ? s <= Math.pow(2, 8) ? Uint8Array : s <= Math.pow(2, 16) ? Uint16Array : s <= Math.pow(2, 32) ? Uint32Array : s <= Number.MAX_SAFE_INTEGER ? Ht : null : null;
class Ht extends Array {
  constructor(e) {
    super(e), this.fill(0);
  }
}
var lt;
const st = class {
  constructor(e, t) {
    le(this, "heap");
    le(this, "length");
    if (!a(st, lt))
      throw new TypeError("instantiate Stack using Stack.create(n)");
    this.heap = new t(e), this.length = 0;
  }
  static create(e) {
    const t = Gn(e);
    if (!t)
      return [];
    O(st, lt, !0);
    const n = new st(e, t);
    return O(st, lt, !1), n;
  }
  push(e) {
    this.heap[this.length++] = e;
  }
  pop() {
    return this.heap[--this.length];
  }
};
let jt = st;
lt = new WeakMap(), // private constructor
P(jt, lt, !1);
var ye, ge, _e, we, ot, oe, xe, re, X, H, fe, pe, he, ce, $e, ue, De, He, Se, Ae, Ve, me, bt, Jt, Xe, je, kt, ve, Vt, Zn, Qe, rt, yt, Ie, Ue, Le, qe, wt, en, at, Pt, ct, Mt, Q, J, xt, tn, Ye, vt;
const un = class {
  constructor(e) {
    P(this, bt);
    P(this, Vt);
    P(this, Ie);
    P(this, Le);
    P(this, wt);
    P(this, at);
    P(this, ct);
    P(this, Q);
    P(this, xt);
    P(this, Ye);
    // properties coming in from the options of these, only max and maxSize
    // really *need* to be protected. The rest can be modified, as they just
    // set defaults for various methods.
    P(this, ye, void 0);
    P(this, ge, void 0);
    P(this, _e, void 0);
    P(this, we, void 0);
    P(this, ot, void 0);
    /**
     * {@link LRUCache.OptionsBase.ttl}
     */
    le(this, "ttl");
    /**
     * {@link LRUCache.OptionsBase.ttlResolution}
     */
    le(this, "ttlResolution");
    /**
     * {@link LRUCache.OptionsBase.ttlAutopurge}
     */
    le(this, "ttlAutopurge");
    /**
     * {@link LRUCache.OptionsBase.updateAgeOnGet}
     */
    le(this, "updateAgeOnGet");
    /**
     * {@link LRUCache.OptionsBase.updateAgeOnHas}
     */
    le(this, "updateAgeOnHas");
    /**
     * {@link LRUCache.OptionsBase.allowStale}
     */
    le(this, "allowStale");
    /**
     * {@link LRUCache.OptionsBase.noDisposeOnSet}
     */
    le(this, "noDisposeOnSet");
    /**
     * {@link LRUCache.OptionsBase.noUpdateTTL}
     */
    le(this, "noUpdateTTL");
    /**
     * {@link LRUCache.OptionsBase.maxEntrySize}
     */
    le(this, "maxEntrySize");
    /**
     * {@link LRUCache.OptionsBase.sizeCalculation}
     */
    le(this, "sizeCalculation");
    /**
     * {@link LRUCache.OptionsBase.noDeleteOnFetchRejection}
     */
    le(this, "noDeleteOnFetchRejection");
    /**
     * {@link LRUCache.OptionsBase.noDeleteOnStaleGet}
     */
    le(this, "noDeleteOnStaleGet");
    /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchAbort}
     */
    le(this, "allowStaleOnFetchAbort");
    /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchRejection}
     */
    le(this, "allowStaleOnFetchRejection");
    /**
     * {@link LRUCache.OptionsBase.ignoreFetchAbort}
     */
    le(this, "ignoreFetchAbort");
    // computed properties
    P(this, oe, void 0);
    P(this, xe, void 0);
    P(this, re, void 0);
    P(this, X, void 0);
    P(this, H, void 0);
    P(this, fe, void 0);
    P(this, pe, void 0);
    P(this, he, void 0);
    P(this, ce, void 0);
    P(this, $e, void 0);
    P(this, ue, void 0);
    P(this, De, void 0);
    P(this, He, void 0);
    P(this, Se, void 0);
    P(this, Ae, void 0);
    P(this, Ve, void 0);
    P(this, me, void 0);
    // conditionally set private methods related to TTL
    P(this, Xe, () => {
    });
    P(this, je, () => {
    });
    P(this, kt, () => {
    });
    /* c8 ignore stop */
    P(this, ve, () => !1);
    P(this, Qe, (e) => {
    });
    P(this, rt, (e, t, n) => {
    });
    P(this, yt, (e, t, n, i) => {
      if (n || i)
        throw new TypeError("cannot set size without setting maxSize or maxEntrySize on cache");
      return 0;
    });
    const { max: t = 0, ttl: n, ttlResolution: i = 1, ttlAutopurge: l, updateAgeOnGet: r, updateAgeOnHas: o, allowStale: c, dispose: f, disposeAfter: h, noDisposeOnSet: m, noUpdateTTL: v, maxSize: g = 0, maxEntrySize: $ = 0, sizeCalculation: b, fetchMethod: y, noDeleteOnFetchRejection: p, noDeleteOnStaleGet: w, allowStaleOnFetchRejection: S, allowStaleOnFetchAbort: T, ignoreFetchAbort: z } = e;
    if (t !== 0 && !Ne(t))
      throw new TypeError("max option must be a nonnegative integer");
    const M = t ? Gn(t) : Array;
    if (!M)
      throw new Error("invalid max value: " + t);
    if (O(this, ye, t), O(this, ge, g), this.maxEntrySize = $ || a(this, ge), this.sizeCalculation = b, this.sizeCalculation) {
      if (!a(this, ge) && !this.maxEntrySize)
        throw new TypeError("cannot set sizeCalculation without setting maxSize or maxEntrySize");
      if (typeof this.sizeCalculation != "function")
        throw new TypeError("sizeCalculation set to non-function");
    }
    if (y !== void 0 && typeof y != "function")
      throw new TypeError("fetchMethod must be a function if specified");
    if (O(this, ot, y), O(this, Ve, !!y), O(this, re, /* @__PURE__ */ new Map()), O(this, X, new Array(t).fill(void 0)), O(this, H, new Array(t).fill(void 0)), O(this, fe, new M(t)), O(this, pe, new M(t)), O(this, he, 0), O(this, ce, 0), O(this, $e, jt.create(t)), O(this, oe, 0), O(this, xe, 0), typeof f == "function" && O(this, _e, f), typeof h == "function" ? (O(this, we, h), O(this, ue, [])) : (O(this, we, void 0), O(this, ue, void 0)), O(this, Ae, !!a(this, _e)), O(this, me, !!a(this, we)), this.noDisposeOnSet = !!m, this.noUpdateTTL = !!v, this.noDeleteOnFetchRejection = !!p, this.allowStaleOnFetchRejection = !!S, this.allowStaleOnFetchAbort = !!T, this.ignoreFetchAbort = !!z, this.maxEntrySize !== 0) {
      if (a(this, ge) !== 0 && !Ne(a(this, ge)))
        throw new TypeError("maxSize must be a positive integer if specified");
      if (!Ne(this.maxEntrySize))
        throw new TypeError("maxEntrySize must be a positive integer if specified");
      F(this, Vt, Zn).call(this);
    }
    if (this.allowStale = !!c, this.noDeleteOnStaleGet = !!w, this.updateAgeOnGet = !!r, this.updateAgeOnHas = !!o, this.ttlResolution = Ne(i) || i === 0 ? i : 1, this.ttlAutopurge = !!l, this.ttl = n || 0, this.ttl) {
      if (!Ne(this.ttl))
        throw new TypeError("ttl must be a positive integer if specified");
      F(this, bt, Jt).call(this);
    }
    if (a(this, ye) === 0 && this.ttl === 0 && a(this, ge) === 0)
      throw new TypeError("At least one of max, maxSize, or ttl is required");
    if (!this.ttlAutopurge && !a(this, ye) && !a(this, ge)) {
      const A = "LRU_CACHE_UNBOUNDED";
      hs(A) && (Kn.add(A), ds("TTL caching without ttlAutopurge, max, or maxSize can result in unbounded memory consumption.", "UnboundedCacheWarning", A, un));
    }
  }
  /**
   * Do not call this method unless you need to inspect the
   * inner workings of the cache.  If anything returned by this
   * object is modified in any way, strange breakage may occur.
   *
   * These fields are private for a reason!
   *
   * @internal
   */
  static unsafeExposeInternals(e) {
    return {
      // properties
      starts: a(e, He),
      ttls: a(e, Se),
      sizes: a(e, De),
      keyMap: a(e, re),
      keyList: a(e, X),
      valList: a(e, H),
      next: a(e, fe),
      prev: a(e, pe),
      get head() {
        return a(e, he);
      },
      get tail() {
        return a(e, ce);
      },
      free: a(e, $e),
      // methods
      isBackgroundFetch: (t) => {
        var n;
        return F(n = e, Q, J).call(n, t);
      },
      backgroundFetch: (t, n, i, l) => {
        var r;
        return F(r = e, ct, Mt).call(r, t, n, i, l);
      },
      moveToTail: (t) => {
        var n;
        return F(n = e, Ye, vt).call(n, t);
      },
      indexes: (t) => {
        var n;
        return F(n = e, Ie, Ue).call(n, t);
      },
      rindexes: (t) => {
        var n;
        return F(n = e, Le, qe).call(n, t);
      },
      isStale: (t) => {
        var n;
        return a(n = e, ve).call(n, t);
      }
    };
  }
  // Protected read-only members
  /**
   * {@link LRUCache.OptionsBase.max} (read-only)
   */
  get max() {
    return a(this, ye);
  }
  /**
   * {@link LRUCache.OptionsBase.maxSize} (read-only)
   */
  get maxSize() {
    return a(this, ge);
  }
  /**
   * The total computed size of items in the cache (read-only)
   */
  get calculatedSize() {
    return a(this, xe);
  }
  /**
   * The number of items stored in the cache (read-only)
   */
  get size() {
    return a(this, oe);
  }
  /**
   * {@link LRUCache.OptionsBase.fetchMethod} (read-only)
   */
  get fetchMethod() {
    return a(this, ot);
  }
  /**
   * {@link LRUCache.OptionsBase.dispose} (read-only)
   */
  get dispose() {
    return a(this, _e);
  }
  /**
   * {@link LRUCache.OptionsBase.disposeAfter} (read-only)
   */
  get disposeAfter() {
    return a(this, we);
  }
  /**
   * Return the remaining TTL time for a given entry key
   */
  getRemainingTTL(e) {
    return a(this, re).has(e) ? 1 / 0 : 0;
  }
  /**
   * Return a generator yielding `[key, value]` pairs,
   * in order from most recently used to least recently used.
   */
  *entries() {
    for (const e of F(this, Ie, Ue).call(this))
      a(this, H)[e] !== void 0 && a(this, X)[e] !== void 0 && !F(this, Q, J).call(this, a(this, H)[e]) && (yield [a(this, X)[e], a(this, H)[e]]);
  }
  /**
   * Inverse order version of {@link LRUCache.entries}
   *
   * Return a generator yielding `[key, value]` pairs,
   * in order from least recently used to most recently used.
   */
  *rentries() {
    for (const e of F(this, Le, qe).call(this))
      a(this, H)[e] !== void 0 && a(this, X)[e] !== void 0 && !F(this, Q, J).call(this, a(this, H)[e]) && (yield [a(this, X)[e], a(this, H)[e]]);
  }
  /**
   * Return a generator yielding the keys in the cache,
   * in order from most recently used to least recently used.
   */
  *keys() {
    for (const e of F(this, Ie, Ue).call(this)) {
      const t = a(this, X)[e];
      t !== void 0 && !F(this, Q, J).call(this, a(this, H)[e]) && (yield t);
    }
  }
  /**
   * Inverse order version of {@link LRUCache.keys}
   *
   * Return a generator yielding the keys in the cache,
   * in order from least recently used to most recently used.
   */
  *rkeys() {
    for (const e of F(this, Le, qe).call(this)) {
      const t = a(this, X)[e];
      t !== void 0 && !F(this, Q, J).call(this, a(this, H)[e]) && (yield t);
    }
  }
  /**
   * Return a generator yielding the values in the cache,
   * in order from most recently used to least recently used.
   */
  *values() {
    for (const e of F(this, Ie, Ue).call(this))
      a(this, H)[e] !== void 0 && !F(this, Q, J).call(this, a(this, H)[e]) && (yield a(this, H)[e]);
  }
  /**
   * Inverse order version of {@link LRUCache.values}
   *
   * Return a generator yielding the values in the cache,
   * in order from least recently used to most recently used.
   */
  *rvalues() {
    for (const e of F(this, Le, qe).call(this))
      a(this, H)[e] !== void 0 && !F(this, Q, J).call(this, a(this, H)[e]) && (yield a(this, H)[e]);
  }
  /**
   * Iterating over the cache itself yields the same results as
   * {@link LRUCache.entries}
   */
  [Symbol.iterator]() {
    return this.entries();
  }
  /**
   * Find a value for which the supplied fn method returns a truthy value,
   * similar to Array.find().  fn is called as fn(value, key, cache).
   */
  find(e, t = {}) {
    for (const n of F(this, Ie, Ue).call(this)) {
      const i = a(this, H)[n], l = F(this, Q, J).call(this, i) ? i.__staleWhileFetching : i;
      if (l !== void 0 && e(l, a(this, X)[n], this))
        return this.get(a(this, X)[n], t);
    }
  }
  /**
   * Call the supplied function on each item in the cache, in order from
   * most recently used to least recently used.  fn is called as
   * fn(value, key, cache).  Does not update age or recenty of use.
   * Does not iterate over stale values.
   */
  forEach(e, t = this) {
    for (const n of F(this, Ie, Ue).call(this)) {
      const i = a(this, H)[n], l = F(this, Q, J).call(this, i) ? i.__staleWhileFetching : i;
      l !== void 0 && e.call(t, l, a(this, X)[n], this);
    }
  }
  /**
   * The same as {@link LRUCache.forEach} but items are iterated over in
   * reverse order.  (ie, less recently used items are iterated over first.)
   */
  rforEach(e, t = this) {
    for (const n of F(this, Le, qe).call(this)) {
      const i = a(this, H)[n], l = F(this, Q, J).call(this, i) ? i.__staleWhileFetching : i;
      l !== void 0 && e.call(t, l, a(this, X)[n], this);
    }
  }
  /**
   * Delete any stale entries. Returns true if anything was removed,
   * false otherwise.
   */
  purgeStale() {
    let e = !1;
    for (const t of F(this, Le, qe).call(this, { allowStale: !0 }))
      a(this, ve).call(this, t) && (this.delete(a(this, X)[t]), e = !0);
    return e;
  }
  /**
   * Return an array of [key, {@link LRUCache.Entry}] tuples which can be
   * passed to cache.load()
   */
  dump() {
    const e = [];
    for (const t of F(this, Ie, Ue).call(this, { allowStale: !0 })) {
      const n = a(this, X)[t], i = a(this, H)[t], l = F(this, Q, J).call(this, i) ? i.__staleWhileFetching : i;
      if (l === void 0 || n === void 0)
        continue;
      const r = { value: l };
      if (a(this, Se) && a(this, He)) {
        r.ttl = a(this, Se)[t];
        const o = mt.now() - a(this, He)[t];
        r.start = Math.floor(Date.now() - o);
      }
      a(this, De) && (r.size = a(this, De)[t]), e.unshift([n, r]);
    }
    return e;
  }
  /**
   * Reset the cache and load in the items in entries in the order listed.
   * Note that the shape of the resulting cache may be different if the
   * same options are not used in both caches.
   */
  load(e) {
    this.clear();
    for (const [t, n] of e) {
      if (n.start) {
        const i = Date.now() - n.start;
        n.start = mt.now() - i;
      }
      this.set(t, n.value, n);
    }
  }
  /**
   * Add a value to the cache.
   */
  set(e, t, n = {}) {
    var v, g, $;
    const { ttl: i = this.ttl, start: l, noDisposeOnSet: r = this.noDisposeOnSet, sizeCalculation: o = this.sizeCalculation, status: c } = n;
    let { noUpdateTTL: f = this.noUpdateTTL } = n;
    const h = a(this, yt).call(this, e, t, n.size || 0, o);
    if (this.maxEntrySize && h > this.maxEntrySize)
      return c && (c.set = "miss", c.maxEntrySizeExceeded = !0), this.delete(e), this;
    let m = a(this, oe) === 0 ? void 0 : a(this, re).get(e);
    if (m === void 0)
      m = a(this, oe) === 0 ? a(this, ce) : a(this, $e).length !== 0 ? a(this, $e).pop() : a(this, oe) === a(this, ye) ? F(this, at, Pt).call(this, !1) : a(this, oe), a(this, X)[m] = e, a(this, H)[m] = t, a(this, re).set(e, m), a(this, fe)[a(this, ce)] = m, a(this, pe)[m] = a(this, ce), O(this, ce, m), Lt(this, oe)._++, a(this, rt).call(this, m, h, c), c && (c.set = "add"), f = !1;
    else {
      F(this, Ye, vt).call(this, m);
      const b = a(this, H)[m];
      if (t !== b) {
        if (a(this, Ve) && F(this, Q, J).call(this, b) ? b.__abortController.abort(new Error("replaced")) : r || (a(this, Ae) && ((v = a(this, _e)) == null || v.call(this, b, e, "set")), a(this, me) && ((g = a(this, ue)) == null || g.push([b, e, "set"]))), a(this, Qe).call(this, m), a(this, rt).call(this, m, h, c), a(this, H)[m] = t, c) {
          c.set = "replace";
          const y = b && F(this, Q, J).call(this, b) ? b.__staleWhileFetching : b;
          y !== void 0 && (c.oldValue = y);
        }
      } else
        c && (c.set = "update");
    }
    if (i !== 0 && !a(this, Se) && F(this, bt, Jt).call(this), a(this, Se) && (f || a(this, kt).call(this, m, i, l), c && a(this, je).call(this, c, m)), !r && a(this, me) && a(this, ue)) {
      const b = a(this, ue);
      let y;
      for (; y = b == null ? void 0 : b.shift(); )
        ($ = a(this, we)) == null || $.call(this, ...y);
    }
    return this;
  }
  /**
   * Evict the least recently used item, returning its value or
   * `undefined` if cache is empty.
   */
  pop() {
    var e;
    try {
      for (; a(this, oe); ) {
        const t = a(this, H)[a(this, he)];
        if (F(this, at, Pt).call(this, !0), F(this, Q, J).call(this, t)) {
          if (t.__staleWhileFetching)
            return t.__staleWhileFetching;
        } else if (t !== void 0)
          return t;
      }
    } finally {
      if (a(this, me) && a(this, ue)) {
        const t = a(this, ue);
        let n;
        for (; n = t == null ? void 0 : t.shift(); )
          (e = a(this, we)) == null || e.call(this, ...n);
      }
    }
  }
  /**
   * Check if a key is in the cache, without updating the recency of use.
   * Will return false if the item is stale, even though it is technically
   * in the cache.
   *
   * Will not update item age unless
   * {@link LRUCache.OptionsBase.updateAgeOnHas} is set.
   */
  has(e, t = {}) {
    const { updateAgeOnHas: n = this.updateAgeOnHas, status: i } = t, l = a(this, re).get(e);
    if (l !== void 0)
      if (a(this, ve).call(this, l))
        i && (i.has = "stale", a(this, je).call(this, i, l));
      else
        return n && a(this, Xe).call(this, l), i && (i.has = "hit", a(this, je).call(this, i, l)), !0;
    else
      i && (i.has = "miss");
    return !1;
  }
  /**
   * Like {@link LRUCache#get} but doesn't update recency or delete stale
   * items.
   *
   * Returns `undefined` if the item is stale, unless
   * {@link LRUCache.OptionsBase.allowStale} is set.
   */
  peek(e, t = {}) {
    const { allowStale: n = this.allowStale } = t, i = a(this, re).get(e);
    if (i !== void 0 && (n || !a(this, ve).call(this, i))) {
      const l = a(this, H)[i];
      return F(this, Q, J).call(this, l) ? l.__staleWhileFetching : l;
    }
  }
  async fetch(e, t = {}) {
    const {
      // get options
      allowStale: n = this.allowStale,
      updateAgeOnGet: i = this.updateAgeOnGet,
      noDeleteOnStaleGet: l = this.noDeleteOnStaleGet,
      // set options
      ttl: r = this.ttl,
      noDisposeOnSet: o = this.noDisposeOnSet,
      size: c = 0,
      sizeCalculation: f = this.sizeCalculation,
      noUpdateTTL: h = this.noUpdateTTL,
      // fetch exclusive options
      noDeleteOnFetchRejection: m = this.noDeleteOnFetchRejection,
      allowStaleOnFetchRejection: v = this.allowStaleOnFetchRejection,
      ignoreFetchAbort: g = this.ignoreFetchAbort,
      allowStaleOnFetchAbort: $ = this.allowStaleOnFetchAbort,
      context: b,
      forceRefresh: y = !1,
      status: p,
      signal: w
    } = t;
    if (!a(this, Ve))
      return p && (p.fetch = "get"), this.get(e, {
        allowStale: n,
        updateAgeOnGet: i,
        noDeleteOnStaleGet: l,
        status: p
      });
    const S = {
      allowStale: n,
      updateAgeOnGet: i,
      noDeleteOnStaleGet: l,
      ttl: r,
      noDisposeOnSet: o,
      size: c,
      sizeCalculation: f,
      noUpdateTTL: h,
      noDeleteOnFetchRejection: m,
      allowStaleOnFetchRejection: v,
      allowStaleOnFetchAbort: $,
      ignoreFetchAbort: g,
      status: p,
      signal: w
    };
    let T = a(this, re).get(e);
    if (T === void 0) {
      p && (p.fetch = "miss");
      const z = F(this, ct, Mt).call(this, e, T, S, b);
      return z.__returned = z;
    } else {
      const z = a(this, H)[T];
      if (F(this, Q, J).call(this, z)) {
        const U = n && z.__staleWhileFetching !== void 0;
        return p && (p.fetch = "inflight", U && (p.returnedStale = !0)), U ? z.__staleWhileFetching : z.__returned = z;
      }
      const M = a(this, ve).call(this, T);
      if (!y && !M)
        return p && (p.fetch = "hit"), F(this, Ye, vt).call(this, T), i && a(this, Xe).call(this, T), p && a(this, je).call(this, p, T), z;
      const A = F(this, ct, Mt).call(this, e, T, S, b), K = A.__staleWhileFetching !== void 0 && n;
      return p && (p.fetch = M ? "stale" : "refresh", K && M && (p.returnedStale = !0)), K ? A.__staleWhileFetching : A.__returned = A;
    }
  }
  /**
   * Return a value from the cache. Will update the recency of the cache
   * entry found.
   *
   * If the key is not found, get() will return `undefined`.
   */
  get(e, t = {}) {
    const { allowStale: n = this.allowStale, updateAgeOnGet: i = this.updateAgeOnGet, noDeleteOnStaleGet: l = this.noDeleteOnStaleGet, status: r } = t, o = a(this, re).get(e);
    if (o !== void 0) {
      const c = a(this, H)[o], f = F(this, Q, J).call(this, c);
      return r && a(this, je).call(this, r, o), a(this, ve).call(this, o) ? (r && (r.get = "stale"), f ? (r && n && c.__staleWhileFetching !== void 0 && (r.returnedStale = !0), n ? c.__staleWhileFetching : void 0) : (l || this.delete(e), r && n && (r.returnedStale = !0), n ? c : void 0)) : (r && (r.get = "hit"), f ? c.__staleWhileFetching : (F(this, Ye, vt).call(this, o), i && a(this, Xe).call(this, o), c));
    } else
      r && (r.get = "miss");
  }
  /**
   * Deletes a key out of the cache.
   * Returns true if the key was deleted, false otherwise.
   */
  delete(e) {
    var n, i, l, r;
    let t = !1;
    if (a(this, oe) !== 0) {
      const o = a(this, re).get(e);
      if (o !== void 0)
        if (t = !0, a(this, oe) === 1)
          this.clear();
        else {
          a(this, Qe).call(this, o);
          const c = a(this, H)[o];
          F(this, Q, J).call(this, c) ? c.__abortController.abort(new Error("deleted")) : (a(this, Ae) || a(this, me)) && (a(this, Ae) && ((n = a(this, _e)) == null || n.call(this, c, e, "delete")), a(this, me) && ((i = a(this, ue)) == null || i.push([c, e, "delete"]))), a(this, re).delete(e), a(this, X)[o] = void 0, a(this, H)[o] = void 0, o === a(this, ce) ? O(this, ce, a(this, pe)[o]) : o === a(this, he) ? O(this, he, a(this, fe)[o]) : (a(this, fe)[a(this, pe)[o]] = a(this, fe)[o], a(this, pe)[a(this, fe)[o]] = a(this, pe)[o]), Lt(this, oe)._--, a(this, $e).push(o);
        }
    }
    if (a(this, me) && ((l = a(this, ue)) != null && l.length)) {
      const o = a(this, ue);
      let c;
      for (; c = o == null ? void 0 : o.shift(); )
        (r = a(this, we)) == null || r.call(this, ...c);
    }
    return t;
  }
  /**
   * Clear the cache entirely, throwing away all values.
   */
  clear() {
    var e, t, n;
    for (const i of F(this, Le, qe).call(this, { allowStale: !0 })) {
      const l = a(this, H)[i];
      if (F(this, Q, J).call(this, l))
        l.__abortController.abort(new Error("deleted"));
      else {
        const r = a(this, X)[i];
        a(this, Ae) && ((e = a(this, _e)) == null || e.call(this, l, r, "delete")), a(this, me) && ((t = a(this, ue)) == null || t.push([l, r, "delete"]));
      }
    }
    if (a(this, re).clear(), a(this, H).fill(void 0), a(this, X).fill(void 0), a(this, Se) && a(this, He) && (a(this, Se).fill(0), a(this, He).fill(0)), a(this, De) && a(this, De).fill(0), O(this, he, 0), O(this, ce, 0), a(this, $e).length = 0, O(this, xe, 0), O(this, oe, 0), a(this, me) && a(this, ue)) {
      const i = a(this, ue);
      let l;
      for (; l = i == null ? void 0 : i.shift(); )
        (n = a(this, we)) == null || n.call(this, ...l);
    }
  }
};
let Yt = un;
ye = new WeakMap(), ge = new WeakMap(), _e = new WeakMap(), we = new WeakMap(), ot = new WeakMap(), oe = new WeakMap(), xe = new WeakMap(), re = new WeakMap(), X = new WeakMap(), H = new WeakMap(), fe = new WeakMap(), pe = new WeakMap(), he = new WeakMap(), ce = new WeakMap(), $e = new WeakMap(), ue = new WeakMap(), De = new WeakMap(), He = new WeakMap(), Se = new WeakMap(), Ae = new WeakMap(), Ve = new WeakMap(), me = new WeakMap(), bt = new WeakSet(), Jt = function() {
  const e = new Ht(a(this, ye)), t = new Ht(a(this, ye));
  O(this, Se, e), O(this, He, t), O(this, kt, (l, r, o = mt.now()) => {
    if (t[l] = r !== 0 ? o : 0, e[l] = r, r !== 0 && this.ttlAutopurge) {
      const c = setTimeout(() => {
        a(this, ve).call(this, l) && this.delete(a(this, X)[l]);
      }, r + 1);
      c.unref && c.unref();
    }
  }), O(this, Xe, (l) => {
    t[l] = e[l] !== 0 ? mt.now() : 0;
  }), O(this, je, (l, r) => {
    if (e[r]) {
      const o = e[r], c = t[r];
      l.ttl = o, l.start = c, l.now = n || i(), l.remainingTTL = l.now + o - c;
    }
  });
  let n = 0;
  const i = () => {
    const l = mt.now();
    if (this.ttlResolution > 0) {
      n = l;
      const r = setTimeout(() => n = 0, this.ttlResolution);
      r.unref && r.unref();
    }
    return l;
  };
  this.getRemainingTTL = (l) => {
    const r = a(this, re).get(l);
    return r === void 0 ? 0 : e[r] === 0 || t[r] === 0 ? 1 / 0 : t[r] + e[r] - (n || i());
  }, O(this, ve, (l) => e[l] !== 0 && t[l] !== 0 && (n || i()) - t[l] > e[l]);
}, Xe = new WeakMap(), je = new WeakMap(), kt = new WeakMap(), ve = new WeakMap(), Vt = new WeakSet(), Zn = function() {
  const e = new Ht(a(this, ye));
  O(this, xe, 0), O(this, De, e), O(this, Qe, (t) => {
    O(this, xe, a(this, xe) - e[t]), e[t] = 0;
  }), O(this, yt, (t, n, i, l) => {
    if (F(this, Q, J).call(this, n))
      return 0;
    if (!Ne(i))
      if (l) {
        if (typeof l != "function")
          throw new TypeError("sizeCalculation must be a function");
        if (i = l(n, t), !Ne(i))
          throw new TypeError("sizeCalculation return invalid (expect positive integer)");
      } else
        throw new TypeError("invalid size value (must be positive integer). When maxSize or maxEntrySize is used, sizeCalculation or size must be set.");
    return i;
  }), O(this, rt, (t, n, i) => {
    if (e[t] = n, a(this, ge)) {
      const l = a(this, ge) - e[t];
      for (; a(this, xe) > l; )
        F(this, at, Pt).call(this, !0);
    }
    O(this, xe, a(this, xe) + e[t]), i && (i.entrySize = n, i.totalCalculatedSize = a(this, xe));
  });
}, Qe = new WeakMap(), rt = new WeakMap(), yt = new WeakMap(), Ie = new WeakSet(), Ue = function* ({ allowStale: e = this.allowStale } = {}) {
  if (a(this, oe))
    for (let t = a(this, ce); !(!F(this, wt, en).call(this, t) || ((e || !a(this, ve).call(this, t)) && (yield t), t === a(this, he))); )
      t = a(this, pe)[t];
}, Le = new WeakSet(), qe = function* ({ allowStale: e = this.allowStale } = {}) {
  if (a(this, oe))
    for (let t = a(this, he); !(!F(this, wt, en).call(this, t) || ((e || !a(this, ve).call(this, t)) && (yield t), t === a(this, ce))); )
      t = a(this, fe)[t];
}, wt = new WeakSet(), en = function(e) {
  return e !== void 0 && a(this, re).get(a(this, X)[e]) === e;
}, at = new WeakSet(), Pt = function(e) {
  var l, r;
  const t = a(this, he), n = a(this, X)[t], i = a(this, H)[t];
  return a(this, Ve) && F(this, Q, J).call(this, i) ? i.__abortController.abort(new Error("evicted")) : (a(this, Ae) || a(this, me)) && (a(this, Ae) && ((l = a(this, _e)) == null || l.call(this, i, n, "evict")), a(this, me) && ((r = a(this, ue)) == null || r.push([i, n, "evict"]))), a(this, Qe).call(this, t), e && (a(this, X)[t] = void 0, a(this, H)[t] = void 0, a(this, $e).push(t)), a(this, oe) === 1 ? (O(this, he, O(this, ce, 0)), a(this, $e).length = 0) : O(this, he, a(this, fe)[t]), a(this, re).delete(n), Lt(this, oe)._--, t;
}, ct = new WeakSet(), Mt = function(e, t, n, i) {
  const l = t === void 0 ? void 0 : a(this, H)[t];
  if (F(this, Q, J).call(this, l))
    return l;
  const r = new AbortController(), { signal: o } = n;
  o == null || o.addEventListener("abort", () => r.abort(o.reason), {
    signal: r.signal
  });
  const c = {
    signal: r.signal,
    options: n,
    context: i
  }, f = (b, y = !1) => {
    const { aborted: p } = r.signal, w = n.ignoreFetchAbort && b !== void 0;
    if (n.status && (p && !y ? (n.status.fetchAborted = !0, n.status.fetchError = r.signal.reason, w && (n.status.fetchAbortIgnored = !0)) : n.status.fetchResolved = !0), p && !w && !y)
      return m(r.signal.reason);
    const S = g;
    return a(this, H)[t] === g && (b === void 0 ? S.__staleWhileFetching ? a(this, H)[t] = S.__staleWhileFetching : this.delete(e) : (n.status && (n.status.fetchUpdated = !0), this.set(e, b, c.options))), b;
  }, h = (b) => (n.status && (n.status.fetchRejected = !0, n.status.fetchError = b), m(b)), m = (b) => {
    const { aborted: y } = r.signal, p = y && n.allowStaleOnFetchAbort, w = p || n.allowStaleOnFetchRejection, S = w || n.noDeleteOnFetchRejection, T = g;
    if (a(this, H)[t] === g && (!S || T.__staleWhileFetching === void 0 ? this.delete(e) : p || (a(this, H)[t] = T.__staleWhileFetching)), w)
      return n.status && T.__staleWhileFetching !== void 0 && (n.status.returnedStale = !0), T.__staleWhileFetching;
    if (T.__returned === T)
      throw b;
  }, v = (b, y) => {
    var w;
    const p = (w = a(this, ot)) == null ? void 0 : w.call(this, e, l, c);
    p && p instanceof Promise && p.then((S) => b(S), y), r.signal.addEventListener("abort", () => {
      (!n.ignoreFetchAbort || n.allowStaleOnFetchAbort) && (b(), n.allowStaleOnFetchAbort && (b = (S) => f(S, !0)));
    });
  };
  n.status && (n.status.fetchDispatched = !0);
  const g = new Promise(v).then(f, h), $ = Object.assign(g, {
    __abortController: r,
    __staleWhileFetching: l,
    __returned: void 0
  });
  return t === void 0 ? (this.set(e, $, { ...c.options, status: void 0 }), t = a(this, re).get(e)) : a(this, H)[t] = $, $;
}, Q = new WeakSet(), J = function(e) {
  if (!a(this, Ve))
    return !1;
  const t = e;
  return !!t && t instanceof Promise && t.hasOwnProperty("__staleWhileFetching") && t.__abortController instanceof AbortController;
}, xt = new WeakSet(), tn = function(e, t) {
  a(this, pe)[t] = e, a(this, fe)[e] = t;
}, Ye = new WeakSet(), vt = function(e) {
  e !== a(this, ce) && (e === a(this, he) ? O(this, he, a(this, fe)[e]) : F(this, xt, tn).call(this, a(this, pe)[e], a(this, fe)[e]), F(this, xt, tn).call(this, a(this, ce), e), O(this, ce, e));
};
const fs = Yt, gt = (s) => {
  const e = s.value, t = e.substring(0, s.selectionStart), n = e.substring(s.selectionEnd, e.length), i = t.lastIndexOf(`
`), l = t.substring(0, i + 1), r = n.indexOf(`
`), o = n.substring(
    r === -1 ? n.length : r,
    n.length
  ), c = t.substring(
    i + 1,
    t.length
  ), f = n.substring(0, r);
  return {
    prefixStr: t,
    subfixStr: n,
    prefixStrEndRow: l,
    subfixStrEndRow: o,
    prefixSupply: c,
    subfixSupply: f
  };
}, ms = (s, e = "", t, n) => {
  var m, v, g, $, b, y;
  let i = "", l = 0, r = 0, o = !1, c, f;
  const h = (m = te.editorConfig) == null ? void 0 : m.mermaidTemplate;
  if (/^h[1-6]{1}$/.test(s)) {
    const p = s.replace(/^h(\d)/, (w, S) => new Array(Number(S)).fill("#", 0, S).join(""));
    i = `${p} ${e}`, l = p.length + 1;
  } else if (s === "prettier") {
    const p = window.prettier || ((g = (v = te.editorExtensions) == null ? void 0 : v.prettier) == null ? void 0 : g.prettierInstance), w = [
      (($ = window.prettierPlugins) == null ? void 0 : $.markdown) || ((y = (b = te.editorExtensions) == null ? void 0 : b.prettier) == null ? void 0 : y.parserMarkdownInstance)
    ];
    return !p || w[0] === void 0 ? (x.emit(n.editorId, "errorCatcher", {
      name: "prettier",
      message: "prettier is undefined"
    }), t.value) : p.format(t.value, {
      parser: "markdown",
      plugins: w
    });
  } else
    switch (s) {
      case "bold": {
        i = `**${e}**`, l = 2, r = -2;
        break;
      }
      case "underline": {
        i = `<u>${e}</u>`, l = 3, r = -4;
        break;
      }
      case "italic": {
        i = `*${e}*`, l = 1, r = -1;
        break;
      }
      case "strikeThrough": {
        i = `~${e}~`, l = 1, r = -1;
        break;
      }
      case "sub": {
        i = `<sub>${e}</sub>`, l = 5, r = -6;
        break;
      }
      case "sup": {
        i = `<sup>${e}</sup>`, l = 5, r = -6;
        break;
      }
      case "codeRow": {
        i = "`" + e + "`", l = 1, r = -1;
        break;
      }
      case "quote": {
        i = `> ${e}`, l = 2;
        break;
      }
      case "orderedList": {
        i = `1. ${e}`, l = 3;
        break;
      }
      case "unorderedList": {
        i = `- ${e}`, l = 2;
        break;
      }
      case "task": {
        i = `- [ ] ${e}`, l = 6, o = !0;
        break;
      }
      case "code": {
        const p = n.text || e || "", w = n.mode || "language";
        i = `\`\`\`${w}
${p}
\`\`\`
`, l = 3, r = 3 + w.length - i.length, o = !0;
        break;
      }
      case "table": {
        i = "|";
        const { selectedShape: p = { x: 1, y: 1 } } = n, { x: w, y: S } = p;
        for (let T = 0; T <= S; T++)
          i += " col |";
        i += `
|`;
        for (let T = 0; T <= S; T++)
          i += " - |";
        for (let T = 0; T <= w; T++) {
          i += `
|`;
          for (let z = 0; z <= S; z++)
            i += " content |";
        }
        l = 2, r = 5 - i.length, o = !0;
        break;
      }
      case "link": {
        const { desc: p, url: w } = n;
        i = `[${p}](${w})`;
        break;
      }
      case "image": {
        const { desc: p, url: w, urls: S } = n;
        S instanceof Array ? i = S.reduce((T, z) => T + `![${p}](${z})
`, "") : i = `![${p}](${w})
`;
        break;
      }
      case "tab": {
        const { tabWidth: p = 2 } = n, w = new Array(p).fill(" ").join("");
        if (e === "")
          i = w;
        else if (/\n/.test(e)) {
          const { prefixStr: S, subfixStr: T, prefixSupply: z, subfixSupply: M } = gt(t);
          i = `${z}${e}${M}`.split(`
`).map((K) => `${w}${K}`).join(`
`), c = S.substring(0, S.length - z.length), f = T.substring(M.length, T.length), o = !0, l = p, r = -z.length - M.length;
        } else {
          const T = t.value.substring(0, t.selectionStart);
          /\n$/.test(T) || T === "" ? (i = `${w}${e}`, o = !0) : i = w;
        }
        break;
      }
      case "shiftTab": {
        const { tabWidth: p = 2 } = n, {
          prefixStr: w,
          prefixStrEndRow: S,
          subfixStrEndRow: T,
          prefixSupply: z,
          subfixSupply: M
        } = gt(t), A = new RegExp(`^\\s{${p}}`), k = (K = !1, U = !1) => {
          const q = `${z}${e}${M}`;
          if (A.test(q)) {
            const L = w.length - (U ? 0 : p), D = K ? L + e.length - p : L;
            return Oe(t, L, D), `${S}${q.replace(
              A,
              ""
            )}${T}`;
          } else if (/^\s/.test(q)) {
            const L = q.replace(/^\s/, ""), D = q.length - L.length, B = t.selectionStart - (U ? 0 : D), _ = K ? B + e.length - D : B;
            return Oe(t, B, _), `${S}${L}${T}`;
          } else
            i = e;
        };
        if (e === "") {
          const K = k();
          if (K)
            return K;
        } else if (/\n/.test(e)) {
          const U = `${z}${e}${M}`.split(`
`);
          let [q, L] = [0, 0];
          const D = U.map((B, _) => {
            if (A.test(B))
              return _ === 0 && (q = p), L += p, B.replace(A, "");
            if (/^\s/.test(B)) {
              const C = B.replace(/^\s/, "");
              return L += B.length - C.length, C;
            }
            return B;
          }).join(`
`);
          return Oe(
            t,
            t.selectionStart - q,
            t.selectionEnd - L
          ), `${S}${D}${T}`;
        } else {
          const K = k(!0, !0);
          if (K)
            return K;
        }
        break;
      }
      case "ctrlC": {
        const { prefixSupply: p, subfixSupply: w } = gt(t);
        return pt(e === "" ? `${p}${w}` : e), t.value;
      }
      case "ctrlX": {
        const {
          prefixStrEndRow: p,
          subfixStrEndRow: w,
          prefixStr: S,
          subfixStr: T,
          prefixSupply: z,
          subfixSupply: M
        } = gt(t);
        return e === "" ? (pt(`${z}${M}`), Oe(t, p.length), `${p}${w.replace(/^\n/, "")}`) : (pt(e), Oe(t, S.length), `${S}${T}`);
      }
      case "ctrlD": {
        const { prefixStrEndRow: p, subfixStrEndRow: w } = gt(t);
        return Oe(t, p.length), `${p}${w.replace(/^\n/, "")}`;
      }
      case "flow": {
        i = `\`\`\`mermaid
${(h == null ? void 0 : h.flow) || `flowchart TD 
  Start --> Stop`}
\`\`\`
`, l = 2;
        break;
      }
      case "sequence": {
        i = `\`\`\`mermaid
${(h == null ? void 0 : h.sequence) || `sequenceDiagram
  A->>B: hello!
  B-->>A: hi!
  A-)B: bye!`}
\`\`\`
`, l = 2;
        break;
      }
      case "gantt": {
        i = `\`\`\`mermaid
${(h == null ? void 0 : h.gantt) || `gantt
title A Gantt Diagram
dateFormat  YYYY-MM-DD
section Section
A task  :a1, 2014-01-01, 30d
Another task  :after a1, 20d`}
\`\`\`
`, l = 2;
        break;
      }
      case "class": {
        i = `\`\`\`mermaid
${(h == null ? void 0 : h.class) || `classDiagram
  class Animal
  Vehicle <|-- Car`}
\`\`\`
`, l = 2;
        break;
      }
      case "state": {
        i = `\`\`\`mermaid
${(h == null ? void 0 : h.state) || `stateDiagram-v2
  s1 --> s2`}
\`\`\`
`, l = 2;
        break;
      }
      case "pie": {
        i = `\`\`\`mermaid
${(h == null ? void 0 : h.pie) || `pie title Pets adopted by volunteers
  "Dogs" : 386
  "Cats" : 85
  "Rats" : 15`}
\`\`\`
`, l = 2;
        break;
      }
      case "relationship": {
        i = `\`\`\`mermaid
${(h == null ? void 0 : h.relationship) || `erDiagram
  CAR ||--o{ NAMED-DRIVER : allows
  PERSON ||--o{ NAMED-DRIVER : is`}
\`\`\`
`, l = 2;
        break;
      }
      case "journey": {
        i = `\`\`\`mermaid
${(h == null ? void 0 : h.journey) || `journey
  title My working day
  section Go to work
    Make tea: 5: Me
    Go upstairs: 3: Me
    Do work: 1: Me, Cat
  section Go home
    Go downstairs: 5: Me
    Sit down: 5: Me`}
\`\`\`
`, l = 2;
        break;
      }
      case "katexInline": {
        i = "$$", l = 1, r = -1;
        break;
      }
      case "katexBlock": {
        i = `$$

$$
`, l = 1, r = -4;
        break;
      }
      case "universal": {
        const { generate: p } = n, w = p(e);
        i = w.targetValue, o = w.select, l = w.deviationStart, r = w.deviationEnd;
      }
    }
  return Xt(t, i, {
    deviationStart: l,
    deviationEnd: r,
    select: o,
    prefixVal: c,
    subfixVal: f
  });
}, On = {
  block(s, e) {
    return {
      name: "KaTexBlockExtension",
      level: "block",
      start: (t) => {
        var n;
        return (n = t.match(/\n\$\$/)) == null ? void 0 : n.index;
      },
      tokenizer(t) {
        if (/^\$\$/.test(t) && t.split("$$").length > 2) {
          const n = yn(t, "$$");
          return {
            type: "KaTexBlockExtension",
            raw: n[0],
            text: n[1].trim(),
            tokens: []
          };
        }
      },
      renderer(t) {
        const n = e || typeof window < "u" && window.katex;
        if (n) {
          const i = n.renderToString(t.text, {
            throwOnError: !1,
            displayMode: !0
          });
          return `<p class="${s}-katex-block" data-processed>${i}</p>`;
        } else
          return `<p class="${s}-katex-block">${t.text}</p>`;
      }
    };
  },
  inline(s, e) {
    return {
      name: "KaTexInlineExtension",
      level: "inline",
      start: (t) => {
        var n;
        return (n = t.match(/\$[^\n]*/)) == null ? void 0 : n.index;
      },
      tokenizer(t) {
        if (/^\$[^\n]*\$/.test(t)) {
          const n = yn(t);
          return {
            type: "KaTexInlineExtension",
            raw: n[0],
            text: n[1].trim(),
            tokens: []
          };
        }
      },
      renderer(t) {
        const n = e || typeof window < "u" && window.katex;
        if (n) {
          const i = n.renderToString(t.text, {
            throwOnError: !1
          });
          return `<span class="${s}-katex-inline" data-processed>${i}</span>`;
        } else
          return `<span class="${s}-katex-inline">${t.text}</span>`;
      }
    };
  }
}, Xn = [
  "abstract",
  "attention",
  "bug",
  "caution",
  "danger",
  "error",
  "example",
  "failure",
  "hint",
  "info",
  "note",
  "question",
  "quote",
  "success",
  "tip",
  "warning"
], Zt = new RegExp(`^!!!\\s*(${Xn.join("|")})\\s*(.*)$`), gs = /^!!!\s*$/, ps = {
  name: "alert",
  level: "block",
  start(s) {
    var t;
    return (t = s.match(
      new RegExp(`(^|[\\r\\n])!!!\\s*(${Xn.join("|")})\\s*(.*)`)
    )) == null ? void 0 : t.index;
  },
  tokenizer(s) {
    const e = s.split(/\n/);
    if (Zt.test(e[0])) {
      const t = { x: -1, y: -1 }, n = [];
      for (let i = 0, l = e.length; i < l; i++)
        Zt.test(e[i]) ? t.x = i : gs.test(e[i]) && (t.y = i, t.x >= 0 && (n.push({ ...t }), t.x = -1, t.y = -1));
      if (n.length) {
        const i = n[0], [l, r, o] = Zt.exec(e[i.x]) || [], c = e.slice(i.x + 1, i.y).join(`
`), h = {
          type: "alert",
          raw: e.slice(i.x, i.y + 1).join(`
`),
          icon: r,
          title: o,
          text: c,
          titleTokens: [],
          tokens: [],
          childTokens: ["title", "text"]
        };
        return this.lexer.inlineTokens(h.title, h.titleTokens), this.lexer.blockTokens(h.text, h.tokens), h;
      }
    }
  },
  renderer(s) {
    return `<div class="md-editor-alert md-editor-alert-${s.icon}">
     <p class="md-editor-alert-title">${this.parser.parseInline(
      s.titleTokens,
      null
    )}</p>
     ${this.parser.parse(s.tokens)}
     </div>`;
  }
}, vs = typeof window > "u", bs = (s, e, t) => {
  var g, $;
  const n = N("previewOnly"), i = N("historyLength"), l = N("editorId");
  if (n)
    return;
  let r = -1;
  const o = {
    list: [
      {
        content: s.value,
        startPos: ((g = e.value) == null ? void 0 : g.selectionStart) || 0,
        endPos: (($ = e.value) == null ? void 0 : $.selectionEnd) || 0
      }
    ],
    userUpdated: !0,
    curr: 0
  }, c = [0, 0];
  let f = c;
  const h = (b) => {
    var S, T;
    const y = ((S = e.value) == null ? void 0 : S.selectionStart) || 0, p = ((T = e.value) == null ? void 0 : T.selectionEnd) || 0;
    o.list[o.curr].startPos = y, o.list[o.curr].endPos = p, o.userUpdated = !1, o.curr = b;
    const w = o.list[o.curr];
    f = [w.startPos, w.endPos], s.onChange(w.content), Oe(e.value, w.startPos, w.endPos).then(() => {
      x.emit(l, "selectTextChange");
    });
  }, m = (b) => {
    var w, S;
    clearTimeout(r);
    const y = ((w = e.value) == null ? void 0 : w.selectionStart) || 0, p = ((S = e.value) == null ? void 0 : S.selectionEnd) || 0;
    r = setTimeout(() => {
      if (o.userUpdated) {
        o.curr < o.list.length - 1 && (o.list = o.list.slice(0, o.curr + 1)), o.list.length > i && o.list.shift();
        const T = o.list.pop() || {
          startPos: 0,
          endPos: 0,
          content: b
        };
        T.startPos = f[0], T.endPos = f[1], f = c, Array.prototype.push.call(o.list, T, {
          content: b,
          startPos: y,
          endPos: p
        }), o.curr = o.list.length - 1;
      } else
        o.userUpdated = !0;
    }, 150);
  }, v = (b) => {
    var y, p;
    (f === c || b) && (f = [(y = e.value) == null ? void 0 : y.selectionStart, (p = e.value) == null ? void 0 : p.selectionEnd]);
  };
  W([Bt(s, "value"), t], () => {
    t.value && m(s.value);
  }), W(
    () => s.value,
    () => {
      x.emit(l, "selectTextChange");
    },
    {
      flush: "post"
    }
  ), ie(() => {
    x.on(l, {
      name: "ctrlZ",
      callback() {
        h(o.curr - 1 < 0 ? 0 : o.curr - 1);
      }
    }), x.on(l, {
      name: "ctrlShiftZ",
      callback() {
        h(
          o.curr + 1 === o.list.length ? o.curr : o.curr + 1
        );
      }
    }), x.on(l, {
      name: "saveHistoryPos",
      callback: v
    });
  });
}, ks = (s, e) => {
  var l;
  const t = (l = te.editorExtensions) == null ? void 0 : l.katex, n = t == null ? void 0 : t.instance, i = ne(!!n);
  return s.noKatex || e.use({
    extensions: [
      On.inline(d, n),
      On.block(d, n)
    ]
  }), ie(() => {
    if (!s.noKatex && !n) {
      const r = document.createElement("script");
      r.src = (t == null ? void 0 : t.js) || pn.js, r.onload = () => {
        i.value = !0;
      }, r.id = `${d}-katex`;
      const o = document.createElement("link");
      o.rel = "stylesheet", o.href = (t == null ? void 0 : t.css) || pn.css, o.id = `${d}-katexCss`, Ce(r, "katex"), Ce(o);
    }
  }), i;
}, ys = (s) => {
  var D, B;
  const {
    markedRenderer: e,
    markedExtensions: t,
    markedOptions: n,
    editorExtensions: i,
    editorConfig: l
  } = te, r = N("showCodeRowNumber"), o = N("editorId"), c = N("highlight"), f = N("previewOnly"), h = N("theme"), m = (D = i == null ? void 0 : i.highlight) == null ? void 0 : D.instance, v = (B = i == null ? void 0 : i.mermaid) == null ? void 0 : B.instance, g = ne(!!m), $ = ne([]);
  let b = [], y = [];
  const p = new fs({
    max: 1e3,
    // 缓存10分钟
    ttl: 6e5
  }), w = $s(s), S = ks(s, I), T = Te(() => (s.noMermaid || w.mermaidInited) && g.value && (s.noKatex || S.value));
  let z = new I.Renderer();
  z.image = (_, C, j) => `<span class="figure"><img src="${_}" title="${C || ""}" alt="${j || ""}" zoom><span class="figcaption">${j || ""}</span></span>`, z.listitem = (_, C) => C ? `<li class="li-task">${_}</li>` : `<li>${_}</li>`, e instanceof Function && (z = e(z));
  const M = z.code;
  z.code = (_, C, j) => {
    if (!s.noMermaid && C === "mermaid") {
      const Z = pi();
      try {
        if (vs)
          return `<p class="${d}-mermaid">${_}</p>`;
        {
          const se = p.get(_);
          if (se)
            return `<p class="${d}-mermaid" data-processed>${se}</p>`;
          const be = v || window.mermaid;
          if (w.mermaidInited) {
            const Ke = (be.renderAsync || be.render)(Z, _);
            Ke.then((Me) => {
              p.set(_, typeof Me == "string" ? Me : Me.svg);
            }), b.push(Ke);
          } else
            return `<p class="${d}-mermaid">${_}</p>`;
        }
        const ee = `<script type="text/tmplate">${Z}<\/script>`;
        return y.push(ee), ee;
      } catch (ee) {
        return `<p class="${d}-mermaid-error">Error: ${(ee == null ? void 0 : ee.message) || ""}</p>`;
      }
    }
    return M.call(z, _, C, j).replace(
      /^<pre><code\sclass="language-([^>]*)">/,
      '<pre><code class="language-$1" language="$1">'
    );
  };
  const A = z.heading, k = A !== new I.Renderer().heading;
  z.heading = (_, C, j, Z) => {
    $.value.push({ text: j, level: C });
    const ee = s.markedHeadingId(j, C, $.value.length);
    return k ? A.call(
      z,
      _,
      C,
      j,
      Z,
      $.value.length,
      ee
    ) : _ !== j ? `<h${C} id="${ee}">${_}</h${C}>` : `<h${C} id="${ee}"><a href="#${ee}">${j}</a></h${C}>`;
  }, m && I.setOptions({
    highlight: (_, C) => {
      let j;
      const Z = m.getLanguage(C);
      return C && Z ? j = m.highlight(_, {
        language: C,
        ignoreIllegals: !0
      }).value : j = m.highlightAuto(_).value, r ? kn(j.trim()) : `<span class="code-block">${j.trim()}</span>`;
    }
  }), I.setOptions({
    breaks: !0,
    ...n
  }), t instanceof Array && t.length > 0 && I.use({
    extensions: t
  }), I.use({
    extensions: [ps]
  });
  const K = ne(s.sanitize(I(s.value || "", { renderer: z }))), U = async (_) => {
    let C = s.sanitize(I(_, { renderer: z }));
    const j = [...b], Z = [...y];
    return y = [], b = [], (await Promise.allSettled(j)).forEach((se, be) => {
      se.status === "fulfilled" ? C = C.replace(
        Z[be],
        `<p class="${d}-mermaid" data-processed>${typeof se.value == "string" ? se.value : se.value.svg}</p>`
      ) : C = C.replace(
        Z[be],
        `<p class="${d}-mermaid-error">${se.reason || ""}</p>`
      );
    }), C;
  }, q = Kt(
    async () => {
      $.value = [];
      const _ = await U(s.value || "");
      K.value = _, x.emit(o, "buildFinished", K.value), s.onHtmlChanged(K.value);
    },
    (l == null ? void 0 : l.renderDelay) !== void 0 ? l == null ? void 0 : l.renderDelay : f ? 0 : 500
  );
  W(
    [T, Bt(w, "reRender"), Bt(s, "value")],
    q
  ), W([h], () => {
    p.clear();
  });
  const L = () => {
    I.setOptions({
      highlight: (_, C) => {
        let j;
        const Z = window.hljs.getLanguage(C);
        return C && Z ? j = window.hljs.highlight(_, {
          language: C,
          ignoreIllegals: !0
        }).value : j = window.hljs.highlightAuto(_).value, r ? kn(j.trim()) : `<span class="code-block">${j.trim()}</span>`;
      }
    }), g.value = !0;
  };
  return W(
    () => $.value,
    (_) => {
      s.onGetCatalog(_), x.emit(o, "catalogChanged", _);
    }
  ), ie(() => {
    const _ = document.createElement("link");
    if (_.rel = "stylesheet", _.href = c.value.css, _.id = `${d}-hlCss`, Ce(_), !m) {
      const C = document.createElement("script");
      C.src = c.value.js, C.onload = L, C.id = `${d}-hljs`, Ce(C, "hljs");
    }
  }), W(
    () => c.value.css,
    (_) => {
      vi(`${d}-hlCss`, "href", _);
    }
  ), ie(() => {
    x.on(o, {
      name: "pushCatalog",
      callback() {
        x.emit(o, "catalogChanged", $.value);
      }
    });
  }), K;
}, ws = (s, e, t, n, i) => {
  const l = N("previewOnly"), r = N("usedLanguageText"), o = N("editorId");
  let c = () => {
  }, f = () => {
  };
  const h = () => {
    document.querySelectorAll(`#${o}-preview pre`).forEach((g) => {
      var p, w;
      let $ = -1;
      (p = g.querySelector(".copy-button")) == null || p.remove();
      const b = ((w = r.value.copyCode) == null ? void 0 : w.text) || "复制代码", y = document.createElement("span");
      y.setAttribute("class", "copy-button"), y.dataset.tips = b, y.innerHTML = `<svg class="${d}-icon" aria-hidden="true"><use xlink:href="#${d}-icon-copy"></use></svg>`, y.addEventListener("click", () => {
        var A, k;
        clearTimeout($);
        const S = g.querySelector("code").innerText, T = pt(s.formatCopiedText(S)), z = ((A = r.value.copyCode) == null ? void 0 : A.successTips) || "已复制！", M = ((k = r.value.copyCode) == null ? void 0 : k.failTips) || "已复制！";
        y.dataset.tips = T ? z : M, $ = window.setTimeout(() => {
          y.dataset.tips = b;
        }, 1500);
      }), g.appendChild(y);
    });
  }, m = () => {
    ut(() => {
      s.setting.preview && !l && s.scrollAuto && (c(), f()), h();
    });
  }, v = (g) => {
    g && !l && ut(() => {
      c(), [f, c] = bn(
        t.value,
        n.value || i.value
      ), f(), h();
    });
  };
  W(() => e.value, m), W(() => r.value, h), W(() => s.setting.preview, v), W(() => s.setting.htmlPreview, v), W(
    () => s.scrollAuto,
    (g) => {
      g ? f() : c();
    }
  ), ie(() => {
    h(), !l && (n.value || i.value) && ([f, c] = bn(
      t.value,
      n.value || i.value
    )), s.scrollAuto && f();
  });
}, xs = (s, e) => {
  const t = N("previewOnly"), n = N("tabWidth"), i = N("editorId"), l = ne("");
  ie(() => {
    var r;
    t || ((r = e.value) == null || r.addEventListener("keypress", (o) => {
      var c, f, h;
      if (o.key === "Enter") {
        const m = (c = e.value) == null ? void 0 : c.selectionStart, v = (f = e.value) == null ? void 0 : f.value.substring(0, m), g = (h = e.value) == null ? void 0 : h.value.substring(m), $ = v == null ? void 0 : v.lastIndexOf(`
`), b = v == null ? void 0 : v.substring(
          $ + 1,
          m
        );
        if (/^\d+\.\s|^-\s/.test(b))
          if (o.cancelBubble = !0, o.preventDefault(), o.stopPropagation(), /^(\d+\.|-)\s+(\[[x\s]\]\s+)?$/.test(b)) {
            const y = v == null ? void 0 : v.replace(
              /(\d+\.|-)\s+(\[[x\s]\]\s+)?$/,
              ""
            );
            s.onChange(y + g), Oe(
              e.value,
              y == null ? void 0 : y.length
            );
          } else if (/^-\s+.+/.test(b)) {
            const y = /^-\s+\[[x\s]\]/.test(b) ? `
- [ ] ` : `
- `;
            s.onChange(
              Xt(e.value, y, {})
            );
          } else {
            const y = b == null ? void 0 : b.match(/\d+(?=\.)/), p = y && Number(y[0]) + 1 || 1, w = /^\d\.\s+\[[x\s]\]/.test(b) ? `
${p}. [ ] ` : `
${p}. `;
            s.onChange(
              Xt(e.value, w, {})
            );
          }
      }
    }), x.on(i, {
      name: "replace",
      callback(o, c = {}) {
        s.onChange(
          ms(
            o,
            l.value,
            e.value,
            {
              ...c,
              tabWidth: n,
              editorId: i
            }
          )
        );
      }
    }), x.on(i, {
      name: "selectTextChange",
      callback() {
        l.value = fi(e.value);
      }
    }));
  }), W(
    () => s.value,
    () => {
      l.value = "";
    }
  );
}, $s = (s) => {
  const e = N("theme"), { editorExtensions: t } = te, n = t == null ? void 0 : t.mermaid, i = ke({
    reRender: !1,
    mermaidInited: !!(n != null && n.instance)
  }), l = () => {
    const r = (n == null ? void 0 : n.instance) || window.mermaid;
    !s.noMermaid && r && (r.initialize({
      startOnLoad: !1,
      theme: e.value === "dark" ? "dark" : "default"
    }), i.reRender = !i.reRender);
  };
  return W(() => e.value, l), ie(() => {
    if (!s.noMermaid)
      if (n != null && n.instance)
        l(), i.mermaidInited = !0;
      else {
        const r = document.createElement("script");
        r.id = `${d}-mermaid`;
        const o = (n == null ? void 0 : n.js) || ri;
        /\.mjs/.test(o) ? (r.setAttribute("type", "module"), r.innerHTML = `import mermaid from "${o}";window.mermaid=mermaid;document.getElementById('${d}-mermaid').dispatchEvent(new Event('load'));`) : r.src = o, r.onload = () => {
          l(), i.mermaidInited = !0;
        }, Ce(r, "mermaid");
      }
  }), i;
}, Ss = (s, e) => {
  const t = N("editorId"), n = N("previewOnly"), i = (l) => {
    if (l.clipboardData) {
      if (l.clipboardData.files.length > 0) {
        const { files: r } = l.clipboardData;
        x.emit(
          t,
          "uploadImage",
          Array.from(r).filter((o) => /image\/.*/.test(o.type))
        ), l.preventDefault();
      }
      if (s.autoDetectCode && l.clipboardData.types.includes("vscode-editor-data")) {
        const r = JSON.parse(l.clipboardData.getData("vscode-editor-data"));
        x.emit(t, "replace", "code", {
          mode: r.mode,
          text: l.clipboardData.getData("text/plain")
        }), l.preventDefault();
      }
    }
  };
  ie(() => {
    n || e.value.addEventListener("paste", i);
  }), $t(() => {
    n || e.value.removeEventListener("paste", i);
  });
}, Cs = (s, e) => {
  const t = N("editorId"), n = Kt(() => {
    const i = document.querySelectorAll(`#${t}-preview img[zoom]`);
    i.length !== 0 && us(i, {
      background: "#00000073"
    });
  });
  ie(n), W([e, Bt(s.setting, "preview")], n);
}, Ts = (s) => {
  const e = N("editorId");
  ie(() => {
    x.on(e, {
      name: Pn,
      callback() {
        var t;
        (t = s.value) == null || t.focus();
      }
    });
  });
}, Es = () => ({
  value: {
    type: String,
    default: ""
  },
  onChange: {
    type: Function,
    default: () => {
    }
  },
  setting: {
    type: Object,
    default: () => ({})
  },
  onHtmlChanged: {
    type: Function,
    default: () => {
    }
  },
  onGetCatalog: {
    type: Function,
    default: () => {
    }
  },
  markedHeadingId: {
    type: Function,
    default: () => ""
  },
  noMermaid: {
    type: Boolean,
    default: !1
  },
  sanitize: {
    type: Function,
    default: (s) => s
  },
  placeholder: {
    type: String,
    default: ""
  },
  // 不使用该函数功能
  noKatex: {
    type: Boolean,
    default: !1
  },
  scrollAuto: {
    type: Boolean
  },
  formatCopiedText: {
    type: Function,
    default: (s) => s
  },
  autofocus: {
    type: Boolean
  },
  disabled: {
    type: Boolean
  },
  readonly: {
    type: Boolean
  },
  maxlength: {
    type: Number
  },
  autoDetectCode: {
    type: Boolean
  },
  /**
   * 输入框失去焦点时触发事件
   */
  onBlur: {
    type: Function,
    default: () => {
    }
  },
  /**
   * 输入框获得焦点时触发事件
   */
  onFocus: {
    type: Function,
    default: () => {
    }
  }
}), zs = /* @__PURE__ */ ae({
  name: "MDEditorContent",
  props: Es(),
  setup(s) {
    const e = ne(!0), t = N("previewOnly"), n = N("showCodeRowNumber"), i = N("previewTheme"), l = N("editorId"), r = ne(), o = ne(), c = ne(), f = ys(s);
    return ws(s, f, r, o, c), xs(s, r), bs(s, r, e), Ss(s, r), Cs(s, f), Ts(r), () => {
      const h = gi(s, ["formatCopiedText", "markedHeadingId", "noKatex", "noMermaid", "onChange", "onGetCatalog", "onHtmlChanged", "sanitize", "scrollAuto", "setting", "autoDetectCode", "onBlur", "onFocus"]);
      return u(Wt, null, [u("div", {
        class: `${d}-content`
      }, [!t && u("div", {
        class: `${d}-input-wrapper`
      }, [u("textarea", ti(h, {
        id: `${l}-textarea`,
        class: [s.setting.preview || s.setting.htmlPreview ? "" : "textarea-only"],
        ref: r,
        onBlur: (m) => {
          x.emit(l, "selectTextChange"), s.onBlur(m);
        },
        onFocus: s.onFocus,
        onKeydown: () => {
          x.emit(l, "saveHistoryPos", !0);
        },
        onCompositionstart: () => {
          e.value = !1;
        },
        onInput: (m) => {
          s.onChange(m.target.value);
        },
        onCompositionend: () => {
          e.value = !0;
        }
      }), null)]), s.setting.preview && u("div", {
        id: `${l}-preview-wrapper`,
        class: `${d}-preview-wrapper`,
        ref: o,
        key: "content-preview-wrapper"
      }, [u("article", {
        id: `${l}-preview`,
        class: [`${d}-preview`, `${i == null ? void 0 : i.value}-theme`, n && `${d}-scrn`],
        innerHTML: f.value
      }, null)]), s.setting.htmlPreview && u("div", {
        class: `${d}-preview-wrapper`,
        ref: c,
        key: "html-preview-wrapper"
      }, [u("div", {
        class: `${d}-html`
      }, [f.value])])])]);
    };
  }
}), _s = /* @__PURE__ */ ae({
  props: {
    modelValue: {
      type: String,
      default: ""
    }
  },
  setup(s) {
    const e = N("usedLanguageText");
    return () => {
      var t, n;
      return u("div", {
        class: `${d}-footer-item`
      }, [u("label", {
        class: `${d}-footer-label`
      }, [`${(t = e.value.footer) == null ? void 0 : t.markdownTotal}:`]), u("span", null, [((n = s.modelValue) == null ? void 0 : n.length) || 0])]);
    };
  }
});
const As = () => ({
  checked: {
    type: Boolean,
    default: !1
  },
  onChange: {
    type: Function,
    default: () => {
    }
  }
}), Is = /* @__PURE__ */ ae({
  props: As(),
  setup(s) {
    return () => u("div", {
      class: [`${d}-checkbox`, s.checked && `${d}-checkbox-checked`],
      onClick: () => {
        s.onChange(!s.checked);
      }
    }, null);
  }
}), Ls = () => ({
  scrollAuto: {
    type: Boolean
  },
  onScrollAutoChange: {
    type: Function,
    default: () => {
    }
  }
}), Fs = /* @__PURE__ */ ae({
  props: Ls(),
  setup(s) {
    const e = N("usedLanguageText");
    return () => {
      var t;
      return u("div", {
        class: `${d}-footer-item`
      }, [u("label", {
        class: `${d}-footer-label`,
        onClick: () => {
          s.onScrollAutoChange(!s.scrollAuto);
        }
      }, [(t = e.value.footer) == null ? void 0 : t.scrollAuto]), u(Is, {
        checked: s.scrollAuto,
        onChange: s.onScrollAutoChange
      }, null)]);
    };
  }
}), Rs = () => ({
  modelValue: {
    type: String,
    default: ""
  },
  footers: {
    type: Array,
    default: []
  },
  scrollAuto: {
    type: Boolean
  },
  onScrollAutoChange: {
    type: Function,
    default: () => {
    }
  },
  defFooters: {
    type: Object
  }
}), Os = /* @__PURE__ */ ae({
  name: "MDEditorFooter",
  props: Rs(),
  setup(s) {
    const e = Te(() => {
      const n = s.footers.indexOf("="), i = n === -1 ? s.footers : s.footers.slice(0, n), l = n === -1 ? [] : s.footers.slice(n, Number.MAX_SAFE_INTEGER);
      return [i, l];
    }), t = (n) => {
      if (Hn.includes(n))
        switch (n) {
          case "markdownTotal":
            return u(_s, {
              modelValue: s.modelValue
            }, null);
          case "scrollSwitch":
            return u(Fs, {
              scrollAuto: s.scrollAuto,
              onScrollAutoChange: s.onScrollAutoChange
            }, null);
        }
      else
        return s.defFooters instanceof Array ? s.defFooters[n] || "" : s.defFooters && s.defFooters.children instanceof Array && s.defFooters.children[n] || "";
    };
    return () => {
      const n = e.value[0].map((l) => t(l)), i = e.value[1].map((l) => t(l));
      return u("div", {
        class: `${d}-footer`
      }, [u("div", {
        class: `${d}-footer-left`
      }, [n]), u("div", {
        class: `${d}-footer-right`
      }, [i])]);
    };
  }
}), Ds = () => ({
  tocItem: {
    type: Object,
    default: () => ({})
  },
  markedHeadingId: {
    type: Function,
    default: () => {
    }
  },
  scrollElement: {
    type: [String, Object],
    default: ""
  },
  onClick: {
    type: Function,
    default: () => {
    }
  },
  scrollElementOffsetTop: {
    type: Number,
    default: 0
  }
}), Qn = /* @__PURE__ */ ae({
  props: Ds(),
  setup(s) {
    return () => {
      const {
        tocItem: e,
        markedHeadingId: t,
        scrollElement: n,
        onClick: i,
        scrollElementOffsetTop: l
      } = s;
      return u("div", {
        class: [`${d}-catalog-link`, e.active && `${d}-catalog-active`],
        onClick: (r) => {
          i(r, e), r.stopPropagation();
          const o = t(e.text, e.level, e.index), c = document.getElementById(o), f = n instanceof Element ? n : document.querySelector(n);
          if (c && f) {
            let h = c.offsetParent, m = c.offsetTop;
            if (f.contains(h))
              for (; h && f != h; )
                m += h == null ? void 0 : h.offsetTop, h = h == null ? void 0 : h.offsetParent;
            f == null || f.scrollTo({
              top: m - l,
              behavior: "smooth"
            });
          }
        }
      }, [u("span", {
        title: e.text
      }, [e.text]), u("div", {
        class: `${d}-catalog-wrapper`
      }, [e.children && e.children.map((r) => u(Qn, {
        markedHeadingId: t,
        key: `${e.text}-link-${r.level}-${r.text}`,
        tocItem: r,
        scrollElement: n,
        onClick: i,
        scrollElementOffsetTop: l
      }, null))])]);
    };
  }
});
const Hs = () => ({
  /**
   * 编辑器的Id，务必与需要绑定的编辑器Id相同
   */
  editorId: {
    type: String
  },
  class: {
    type: String,
    default: ""
  },
  markedHeadingId: {
    type: Function,
    default: (s) => s
  },
  /**
   * 指定滚动的容器，选择器需带上对应的符号，默认预览框
   * 元素必须定位！！！！！！
   *
   * 默认：#md-editor-preview-wrapper
   */
  scrollElement: {
    type: [String, Object]
  },
  theme: {
    type: String,
    default: "light"
  },
  /**
   * 高亮标题相对滚动容器顶部偏移量，即距离该值时，高亮当前目录菜单项
   *
   * 默认：20px
   */
  offsetTop: {
    type: Number,
    default: 20
  },
  /**
   * 滚动区域的固定顶部高度
   *
   * 默认：0
   */
  scrollElementOffsetTop: {
    type: Number,
    default: 0
  },
  onClick: {
    type: Function
  }
}), qt = /* @__PURE__ */ ae({
  name: "MdCatalog",
  props: Hs(),
  emits: ["onClick"],
  setup(s, e) {
    const t = s.editorId, n = ke({
      list: [],
      show: !1,
      scrollElement: s.scrollElement || `#${t}-preview-wrapper`
    }), i = Te(() => {
      const r = [];
      return n.list.forEach(({
        text: o,
        level: c,
        active: f
      }, h) => {
        const m = {
          level: c,
          text: o,
          index: h + 1,
          active: !!f
        };
        if (r.length === 0)
          r.push(m);
        else {
          let v = r[r.length - 1];
          if (m.level > v.level)
            for (let g = v.level + 1; g <= 6; g++) {
              const {
                children: $
              } = v;
              if (!$) {
                v.children = [m];
                break;
              }
              if (v = $[$.length - 1], m.level <= v.level) {
                $.push(m);
                break;
              }
            }
          else
            r.push(m);
        }
      }), r;
    });
    ie(() => {
      x.on(t, {
        name: "catalogChanged",
        callback: (r) => {
          n.list = r.map((o, c) => c === 0 ? {
            ...o,
            active: !0
          } : {
            ...o
          });
        }
      }), x.emit(t, "pushCatalog");
    });
    const l = () => {
      var o;
      const r = n.scrollElement instanceof HTMLElement ? n.scrollElement : document.querySelector(n.scrollElement);
      (o = r === document.documentElement ? window : r) == null || o.addEventListener("scroll", hi(() => {
        if (n.list.length === 0)
          return !1;
        const {
          activeHead: c
        } = n.list.reduce((f, h, m) => {
          const v = document.getElementById(s.markedHeadingId(h.text, h.level, m + 1));
          if (v instanceof HTMLElement) {
            const g = mi(v, r);
            if (g < s.offsetTop && g > f.minTop)
              return {
                activeHead: h,
                minTop: g
              };
          }
          return f;
        }, {
          activeHead: n.list[0],
          minTop: Number.MIN_SAFE_INTEGER
        });
        n.list = n.list.map((f) => f === c ? {
          ...f,
          active: !0
        } : {
          ...f,
          active: !1
        });
      }));
    };
    return ie(() => {
      l(), x.on(t, {
        name: Qt,
        callback(r) {
          r && ut(l);
        }
      });
    }), () => u("div", {
      class: `${d}-catalog${s.theme === "dark" ? "-dark" : ""} ${s.class}`
    }, [i.value.map((r) => u(Qn, {
      markedHeadingId: s.markedHeadingId,
      tocItem: r,
      key: `link-${r.level}-${r.text}`,
      scrollElement: n.scrollElement,
      onClick: (o, c) => {
        s.onClick ? s.onClick(o, c) : e.emit("onClick", o, c);
      },
      scrollElementOffsetTop: s.scrollElementOffsetTop
    }, null))]);
  }
}), js = (s) => s, Ps = {
  /**
   * 主题
   *
   * @default 'light'
   */
  modelValue: {
    type: String,
    default: ""
  },
  /**
   * 主题，支持light和dark
   *
   * @default 'light'
   */
  theme: {
    type: String,
    default: "light"
  },
  /**
   * 外层类名
   *
   * @default ''
   */
  class: {
    type: String,
    default: ""
  },
  /**
   * 历史记录最长条数
   *
   * @default 10
   */
  historyLength: {
    type: Number,
    default: 10
  },
  /**
   * input回调事件
   */
  onChange: {
    type: Function
  },
  /**
   * input回调事件
   */
  onSave: {
    type: Function
  },
  /**
   * 上传图片事件
   */
  onUploadImg: {
    type: Function
  },
  /**
   * 是否页面内全屏
   *
   * @default false
   */
  pageFullscreen: {
    type: Boolean,
    default: !1
  },
  /**
   * 是否展开预览
   *
   * @default true
   */
  preview: {
    type: Boolean,
    default: !0
  },
  /**
   * 是否展开html预览
   *
   * @default false
   */
  htmlPreview: {
    type: Boolean,
    default: !1
  },
  /**
   * 仅预览模式，不显示toolbar和编辑框
   *
   * @default false
   */
  previewOnly: {
    type: Boolean,
    default: !1
  },
  /**
   * 预设语言名称
   *
   * @default 'zh-CN'
   */
  language: {
    type: String,
    default: "zh-CN"
  },
  /**
   * 工具栏选择显示
   *
   * @default allToolbar
   */
  toolbars: {
    type: Array,
    default: Dn
  },
  /**
   * 工具栏选择不显示
   *
   * @default []
   */
  toolbarsExclude: {
    type: Array,
    default: []
  },
  /**
   * 格式化md
   *
   * @default true
   */
  noPrettier: {
    type: Boolean,
    default: !1
  },
  /**
   * html变化事件
   */
  onHtmlChanged: {
    type: Function
  },
  /**
   * 获取目录结构
   */
  onGetCatalog: {
    type: Function
  },
  /**
   * 编辑器唯一标识
   *
   * @default 'md-editor-v3'
   */
  editorId: {
    type: String,
    default: ii
  },
  /**
   * 一个tab等于空格数
   *
   * @default 2
   */
  tabWidth: {
    type: Number,
    default: 2
  },
  /**
   * 预览中代码是否显示行号
   *
   * @default false
   */
  showCodeRowNumber: {
    type: Boolean,
    default: !1
  },
  /**
   * 预览内容样式
   *
   * @default 'default'
   */
  previewTheme: {
    type: String,
    default: "default"
  },
  /**
   * 编辑器样式
   */
  style: {
    type: Object,
    default: () => ({})
  },
  /**
   * 标题的id生成方式
   *
   * @default (text: string) => text
   */
  markedHeadingId: {
    type: Function,
    default: js
  },
  /**
   * 表格预设格子数
   *
   * @default [6, 4]
   */
  tableShape: {
    type: Array,
    default: () => [6, 4]
  },
  /**
   * 不使用该mermaid
   *
   * @default false
   */
  noMermaid: {
    type: Boolean,
    default: !1
  },
  /**
   *
   * 不能保证文本正确的情况，在marked编译md文本后通过该方法处理
   * 推荐DOMPurify、sanitize-html
   *
   * @default (text: string) => text
   */
  sanitize: {
    type: Function,
    default: (s) => s
  },
  /**
   * 空提示
   *
   * @default ''
   */
  placeholder: {
    type: String,
    default: ""
  },
  /**
   * 不使用katex
   *
   * @default false
   */
  noKatex: {
    type: Boolean,
    default: !1
  },
  /**
   * 自定义的工具栏列表
   */
  defToolbars: {
    type: [String, Object]
  },
  /**
   * 内部错误捕获
   */
  onError: {
    type: Function
  },
  /**
   * 代码主题
   *
   * @default 'atom'
   */
  codeTheme: {
    type: String,
    default: "atom"
  },
  /**
   * 页脚列表显示顺序
   */
  footers: {
    type: Array,
    default: Hn
  },
  /**
   * 是否默认激活输入框和预览框同步滚动
   *
   * @default true
   */
  scrollAuto: {
    type: Boolean,
    default: !0
  },
  /**
   * 自定义的也叫工具组件列表
   */
  defFooters: {
    type: [String, Object]
  },
  /**
   * 不插入iconfont链接
   *
   * @default false
   */
  noIconfont: {
    type: Boolean
  },
  /**
   * 复制代码格式化方法
   *
   * @default (text) => text
   */
  formatCopiedText: {
    type: Function,
    default: (s) => s
  },
  /**
   * 是否禁用上传图片
   *
   * @default false
   */
  noUploadImg: {
    type: Boolean
  },
  /**
   * 某些预览主题的代码模块背景是暗色系
   * 将这个属性设置为true，会自动在该主题下的light模式下使用暗色系的代码风格
   *
   * @default true
   */
  codeStyleReverse: {
    type: Boolean,
    default: !0
  },
  /**
   * 需要自动调整的预览主题
   *
   * @default ['default', 'mk-cute']
   */
  codeStyleReverseList: {
    type: Array,
    default: ["default", "mk-cute"]
  },
  /**
   * 文本区域自动获得焦点
   *
   * @default false
   */
  autoFocus: {
    type: Boolean
  },
  /**
   * 禁用文本区域
   *
   * @default false
   */
  disabled: {
    type: Boolean
  },
  /**
   * 文本区域为只读
   *
   * @default false
   */
  readOnly: {
    type: Boolean
  },
  /**
   * 文本区域允许的最大字符数
   */
  maxLength: {
    type: Number
  },
  /**
   * 是否启用自动识别粘贴代码类别
   * 目前支持 vscode 复制的代码识别
   *
   * @default false
   */
  autoDetectCode: {
    type: Boolean
  },
  /**
   * 输入框失去焦点时触发事件
   */
  onBlur: {
    type: Function
  },
  /**
   * 输入框获得焦点时触发事件
   */
  onFocus: {
    type: Function
  }
}, Ms = [
  "onChange",
  "onSave",
  "onUploadImg",
  "onHtmlChanged",
  "onGetCatalog",
  "onError",
  "update:modelValue",
  "onBlur",
  "onFocus"
];
const We = /* @__PURE__ */ ae({
  name: "MdEditorV3",
  props: Ps,
  emits: Ms,
  setup(s, e) {
    const {
      editorId: t,
      previewOnly: n,
      noKatex: i,
      noMermaid: l,
      noPrettier: r,
      noUploadImg: o
    } = s, c = ke({
      scrollAuto: s.scrollAuto
    });
    bi(s, e), ki(s), yi(s);
    const [f, h] = wi(s, e), [m, v] = xi(s);
    return $t(() => {
      x.clear(t);
    }), $i(s, e, m, f, h), () => {
      var b;
      const g = Ee({
        props: s,
        ctx: e
      }, "defToolbars"), $ = Ee({
        props: s,
        ctx: e
      }, "defFooters");
      return u("div", {
        id: t,
        class: [d, s.class, s.theme === "dark" && `${d}-dark`, f.fullscreen || f.pageFullscreen ? `${d}-fullscreen` : "", n && `${d}-previewOnly`],
        style: s.style
      }, [!n && u(Hi, {
        noPrettier: r,
        toolbars: s.toolbars,
        toolbarsExclude: s.toolbarsExclude,
        setting: f,
        updateSetting: h,
        tableShape: s.tableShape,
        defToolbars: g,
        noUploadImg: o
      }, null), u(zs, {
        value: s.modelValue,
        setting: f,
        markedHeadingId: s.markedHeadingId,
        noMermaid: l,
        sanitize: s.sanitize,
        placeholder: s.placeholder,
        noKatex: i,
        scrollAuto: c.scrollAuto,
        formatCopiedText: s.formatCopiedText,
        autofocus: s.autoFocus,
        disabled: s.disabled,
        readonly: s.readOnly,
        maxlength: s.maxLength,
        autoDetectCode: s.autoDetectCode,
        onChange: (y) => {
          x.emit(t, "saveHistoryPos"), s.onChange ? s.onChange(y) : (e.emit("update:modelValue", y), e.emit("onChange", y));
        },
        onHtmlChanged: (y) => {
          s.onHtmlChanged ? s.onHtmlChanged(y) : e.emit("onHtmlChanged", y);
        },
        onGetCatalog: (y) => {
          s.onGetCatalog ? s.onGetCatalog(y) : e.emit("onGetCatalog", y);
        },
        onBlur: (y) => {
          s.onBlur ? s.onBlur(y) : e.emit("onBlur", y);
        },
        onFocus: (y) => {
          s.onFocus ? s.onFocus(y) : e.emit("onFocus", y);
        }
      }, null), !n && ((b = s.footers) == null ? void 0 : b.length) > 0 && u(Os, {
        modelValue: s.modelValue,
        footers: s.footers,
        defFooters: $,
        scrollAuto: c.scrollAuto,
        onScrollAutoChange: (y) => c.scrollAuto = y
      }, null), v.value && !n && u(qt, {
        theme: s.theme,
        style: {
          display: m.value ? "block" : "none"
        },
        class: `${d}-catalog-editor`,
        editorId: t,
        markedHeadingId: s.markedHeadingId
      }, null)]);
    };
  }
}), Bs = () => ({
  title: {
    type: String,
    default: ""
  },
  // 展示在工具栏的内容，通常是个图标
  trigger: {
    type: [String, Object]
  },
  onClick: {
    type: Function
  }
}), nn = /* @__PURE__ */ ae({
  name: "NormalToolbar",
  props: Bs(),
  emits: ["onClick"],
  setup(s, e) {
    return () => {
      const t = Ee({
        props: s,
        ctx: e
      }, "trigger");
      return u("div", {
        class: `${d}-toolbar-item`,
        title: s.title,
        onClick: (n) => {
          s.onClick instanceof Function ? s.onClick(n) : e.emit("onClick", n);
        }
      }, [t]);
    };
  }
}), Ns = () => ({
  title: {
    type: String,
    default: ""
  },
  visible: {
    type: Boolean
  },
  // 展示在工具栏的内容，通常是个图标
  trigger: {
    type: [String, Object]
  },
  onChange: {
    type: Function
  },
  // 下拉框中的内容
  overlay: {
    type: [String, Object]
  }
}), sn = /* @__PURE__ */ ae({
  name: "DropdownToolbar",
  props: Ns(),
  emits: ["onChange"],
  setup(s, e) {
    const t = N("editorId");
    return () => {
      const n = Ee({
        props: s,
        ctx: e
      }, "trigger"), i = Ee({
        props: s,
        ctx: e
      }, "overlay");
      return u(it, {
        relative: `#${t}-toolbar-wrapper`,
        visible: s.visible,
        onChange: (l) => {
          s.onChange instanceof Function ? s.onChange(l) : e.emit("onChange", l);
        },
        overlay: i
      }, {
        default: () => [u("div", {
          class: `${d}-toolbar-item`,
          title: s.title || ""
        }, [n])]
      });
    };
  }
});
function Us(s) {
  return typeof s == "function" || Object.prototype.toString.call(s) === "[object Object]" && !ni(s);
}
const qs = () => ({
  title: {
    type: String,
    default: ""
  },
  modalTitle: {
    type: String,
    default: ""
  },
  visible: {
    type: Boolean
  },
  width: {
    type: String,
    default: "auto"
  },
  height: {
    type: String,
    default: "auto"
  },
  // 展示在工具栏的内容，通常是个图标
  trigger: {
    type: [String, Object]
  },
  onClick: {
    type: Function
  },
  onClose: {
    type: Function
  },
  /**
   * 显示全屏按钮
   */
  showAdjust: {
    type: Boolean,
    default: !1
  },
  isFullscreen: {
    type: Boolean,
    default: !1
  },
  onAdjust: {
    type: Function
  }
}), ln = /* @__PURE__ */ ae({
  name: "ModalToolbar",
  props: qs(),
  emits: ["onClick", "onClose", "onAdjust"],
  setup(s, e) {
    return () => {
      const t = Ee({
        props: s,
        ctx: e
      }, "trigger"), n = Ee({
        props: s,
        ctx: e
      }, "default");
      return u(Wt, null, [u("div", {
        class: `${d}-toolbar-item`,
        title: s.title,
        onClick: () => {
          s.onClick instanceof Function ? s.onClick() : e.emit("onClick");
        }
      }, [t]), u(rn, {
        width: s.width,
        height: s.height,
        title: s.modalTitle,
        visible: s.visible,
        onClose: () => {
          s.onClose instanceof Function ? s.onClose() : e.emit("onClose");
        },
        showAdjust: s.showAdjust,
        isFullscreen: s.isFullscreen,
        onAdjust: (i) => {
          s.onAdjust instanceof Function ? s.onAdjust(i) : e.emit("onAdjust", i);
        }
      }, Us(n) ? n : {
        default: () => [n]
      })]);
    };
  }
});
We.install = (s) => (s.component(We.name, We), s.component(nn.name, nn), s.component(sn.name, sn), s.component(qt.name, qt), s.component(ln.name, ln), s);
We.NormalToolbar = nn;
We.DropdownToolbar = sn;
We.MdCatalog = qt;
We.ModalToolbar = ln;
We.config = ai;
export {
  We as default
};
